webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(24);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(388);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _index = __webpack_require__(452);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _base = __webpack_require__(450);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _router = __webpack_require__(451);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _App = __webpack_require__(802);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _http = __webpack_require__(449);
	
	var _http2 = _interopRequireDefault(_http);
	
	__webpack_require__(721);
	
	__webpack_require__(461);
	
	__webpack_require__(757);
	
	var _betterScroll = __webpack_require__(470);
	
	var _betterScroll2 = _interopRequireDefault(_betterScroll);
	
	var _mintUi = __webpack_require__(762);
	
	var _mintUi2 = _interopRequireDefault(_mintUi);
	
	__webpack_require__(720);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.prototype.$axios = _http2.default;
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_base2.default);
	_vue2.default.use(_mintUi2.default);
	_vue2.default.prototype.$BScroll = _betterScroll2.default;
	
	var app = new _vue2.default({
		router: _router2.default,
		store: _index2.default,
		components: {
			App: _App2.default
		},
		template: '<app/>'
	});
	
	app.$mount('#app');

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var client_ver = '5.3.0';
	
	var share_url_prefix = 'http://vshare.cdrb.com.cn';
	var app_down_link = 'http://vweb.people.cn/prod/common/api/share/down.php?pjcode=cdrb_2_201503';
	
	var app_open_link = 'cdrbdailynewsdetail://open?';
	
	var app_bot_link_text = {
		'hasComments': '天下景观在锦观',
		'noComments': '天下景观在锦观'
	};
	
	switch (("production")) {
		case 'development':
			var intfc_prefix_common = '/intfc_prefix_common';
			var govUrl = 'http://10.50.161.227:8494';
			break;
		case 'testing':
			var intfc_prefix_common = 'https://testcdrbappapi.peopletech.cn';
			var govUrl = 'https://testcdrbjghapi.peopletech.cn';
			break;
		case 'production':
			var intfc_prefix_common = '';
	
			var govUrl = '/gov';
			break;
	}
	
	exports.client_ver = client_ver;
	exports.intfc_prefix_common = intfc_prefix_common;
	exports.share_url_prefix = share_url_prefix;
	exports.app_down_link = app_down_link;
	exports.app_open_link = app_open_link;
	exports.app_bot_link_text = app_bot_link_text;
	exports.govUrl = govUrl;

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(47);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(467);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _from = __webpack_require__(118);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var u = navigator.userAgent;
	var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
	
	var api = {
	    setFontSytle: function setFontSytle(fontNormal, fontBold) {
	        var style = "@font-face {\n            font-family: 'FZBIAOYSKIOS';\n            src: local(\"FZBiaoYaSong--GB1-0-YS\"),\n                url('" + fontNormal + "') format('truetype');\n        }\n        @font-face {\n            font-family: 'FZBIAOYSKIOS BOLD';\n            src: local(\"FZCYSK--GBK1-0\"),\n                url('" + fontBold + "') format('truetype');\n            font-weight:bold;\n        } ";
	        var ele = document.createElement("style");
	        ele.innerHTML = style;
	        document.getElementsByTagName('head')[0].insertBefore(ele, document.querySelector("style"));
	    },
	    changeFontSize: function changeFontSize() {
	        var fontSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
	
	        $vm.fontSizeNum = fontSize;
	    },
	
	
	    onPageScroll: function onPageScroll() {},
	
	    refreshSub: function refreshSub(val) {
	        $vm.isFollow = val * 1;
	    },
	
	
	    loadNetState: function loadNetState(networkType, networkFlag) {
	        if (networkType == 1 && networkFlag == 0) {
	            $vm.saveVideo.pause();
	
	            var size = $($vm.saveVideo).attr('size');
	            size = size / 1024 / 1024;
	            size = size.toFixed(1);
	
	            var val = confirm("\u64AD\u653E\u89C6\u9891\u9700\u8981\u6D88\u8017" + size + "M\u6D41\u91CF\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F");
	            if (val) {
	                $vm.saveVideo.play();
	            }
	        }
	    },
	
	    changeNetwork: function changeNetwork() {
	        var video = $('video');
	        var videoArr = (0, _from2.default)(video);
	        videoArr.map(function (item, index) {
	            if (!item.paused) {
	                $vm.saveVideo = item;
	
	                item.pause();
	
	                var size = $(item).attr('size');
	                size = size / 1024 / 1024;
	                size = size.toFixed(1);
	
	                var val = confirm("\u64AD\u653E\u89C6\u9891\u9700\u8981\u6D88\u8017" + size + "M\u6D41\u91CF\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F");
	                if (val) {
	                    item.play();
	                }
	            }
	        });
	    },
	
	    isSharePage: function isSharePage() {
	        var result = true;
	        if (isAndroid) {
	            try {
	                console.log((0, _typeof3.default)(window.jsobj.voiceRead));
	                result = false;
	            } catch (e) {}
	        } else if (isiOS) {
	            try {
	                console.log((0, _typeof3.default)(window.webkit.messageHandlers.voiceRead.postMessage));
	                result = false;
	            } catch (e) {}
	        }
	        return result;
	    },
	
	    isPreviewPage: function isPreviewPage() {
	        if ($vm.$route.query.preview) {
	            return true;
	        }
	        return false;
	    },
	
	    checkTerminal: function checkTerminal() {
	        var result = '';
	        if (isiOS) {
	            result = 'ios';
	        } else if (isAndroid) {
	            result = 'android';
	        }
	        return result;
	    },
	
	    appendComment: function appendComment(option) {
	        if (option) {
	            $vm.$forceUpdate();
	            var opt = JSON.parse(option || '{}');
	            var arr = [opt].concat((0, _toConsumableArray3.default)($vm.comments));
	            $vm.comments = arr;
	        }
	    },
	    loadPhraiseData: function loadPhraiseData(arr) {
	        $vm.handleLikes(JSON.parse(arr || '[]'));
	    },
	    isLoggedin: function isLoggedin(status) {
	        console.log(status, 'status');
	        $vm.isLogin = status;
	        $vm.$forceUpdate();
	    },
	    getVoteParams: function getVoteParams(data) {
	        console.log(data, 'getVotepara');
	
	        $vm.isVoteResult = data && data.split(',');
	        console.log($vm.isVoteResult, 'getVoteParams');
	        $vm.$forceUpdate();
	    },
	    appPostMessage: function appPostMessage(name) {
	        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	        if (isAndroid) {
	            try {
	                window.jsobj[name](value);
	            } catch (e) {}
	        } else if (isiOS) {
	            try {
	                window.webkit.messageHandlers[name].postMessage(value);
	            } catch (e) {}
	        }
	    }
	};
	
	exports.default = api;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var Jt = {};
	
	Jt.event = {
		stopDefault: function stopDefault(e) {
			if (e && e.preventDefaule) {
				e.preventDefaule();
			} else {
				window.event.returnValue = false;
			}
			return false;
		}
	};
	
	Jt.string = {
		unicode: function unicode(str) {
			str = str ? str + "" : "";
			var i,
			    len = str.length,
			    value = "";
			for (i = 0; i < len; i++) {
				value += "\\u" + parseInt(str.charCodeAt(i)).toString(16);
			}
			return value;
		},
		trim: function trim(str) {
			return String(str).replace(/^\s+|\s+$/g, "");
		},
		isEmpty: function isEmpty(str) {
			return str === undefined || str === null || this.trim(str) === "";
		}
	};
	
	Jt.array = {
		isEmpty: function isEmpty(arr) {
			return arr === undefined || arr === null || arr.length === 0;
		}
	};
	
	Jt.function = {
		throttle: function throttle(fn, delay) {
			var now = void 0,
			    lastExec = void 0,
			    timer = void 0,
			    context = void 0,
			    args = void 0;
			var execute = function execute() {
				fn.apply(context, args);
				lastExec = now;
			};
			return function () {
				context = this;
				args = arguments;
				now = Date.now();
				if (timer) {
					clearTimeout(timer);
					timer = null;
				}
				if (lastExec) {
					var diff = delay - (now - lastExec);
					if (diff < 0) {
						execute();
					} else {
						timer = setTimeout(function () {
							execute();
						}, diff);
					}
				} else {
					execute();
				}
			};
		}
	};
	
	Jt.object = {
		isEmpty: function isEmpty(obj) {
			var name = void 0;
			for (name in obj) {
				return false;
			}
			return true;
		}
	};
	
	Jt.browser = {
		stopBodyScroll: function stopBodyScroll() {
			$("body").on("touchmove mousewheel", Jt.event.stopDefault);
		},
		startBodyScroll: function startBodyScroll() {
			$("body").off("touchmove mousewheel", Jt.event.stopDefault);
		}
	};
	
	Jt.dom = {
		getScrollTop: function getScrollTop(el) {
			var scrollTop = 0;
			if (el && el !== window) {
				scrollTop = el.scrollTop;
			} else {
				scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
			}
			return scrollTop;
		},
		getClientHeight: function getClientHeight(el) {
			if (el && el !== window) {
				return el.clientHeight;
			}
			return document.documentElement.clientHeight;
		}
	};
	
	module.exports = exports = Jt;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var imgMixin = {
		methods: {
			webp: function webp(url) {
				if (url) {
					url = url.replace(/@!w4/, '');
				}
				return url;
			}
		}
	};
	
	exports.default = imgMixin;

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _project = __webpack_require__(13);
	
	var initWxShare = function initWxShare(_ref, that) {
	    var title = _ref.title,
	        imgUrl = _ref.imgUrl,
	        desc = _ref.desc;
	
	    var url = encodeURIComponent(window.location.href.split('#')[0]);
	    var newImgUrl = null;
	    that.$axios.get(_project.intfc_prefix_common + '/api/v2/wechat/getWechatInfo?url=' + url).then(function (res) {
	        var result = res.item;
	        console.log('getWechatInfo:', result);
	        console.log(title, imgUrl, desc);
	        wx.config({
	            debug: false,
	            appId: result.appId,
	            timestamp: result.timestamp,
	            nonceStr: result.nonceStr,
	            signature: result.signature,
	            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareQZone", "onMenuShareWeibo"] });
	        that.$axios.get(_project.intfc_prefix_common + '/api/client/backGround/getImageInfo').then(function (res) {
	            if (res.item && res.item.weiChat && res.item.weiChat.backGroundUrl) {
	                newImgUrl = res.item.weiChat.backGroundUrl;
	            }
	        });
	
	        wx.ready(function () {
	            var shareData = {
	                link: window.location.href,
	                title: title,
	                desc: desc ? desc : '天下景观在锦观',
	                imgUrl: newImgUrl ? newImgUrl : 'https://rmrbpre.oss-cn-beijing.aliyuncs.com/cdrb-prod/dir2/logo.png' };
	
	            wx.onMenuShareTimeline(shareData);
	            wx.onMenuShareAppMessage(shareData);
	            wx.onMenuShareQQ(shareData);
	            wx.onMenuShareWeibo(shareData);
	            wx.onMenuShareQZone(shareData);
	        });
	        wx.error(function (res) {
	            console.log(res);
	        });
	    }).catch(function (err) {
	        console.log(err);
	    });
	};
	
	exports.default = initWxShare;

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(729)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(437),
	  /* template */
	  __webpack_require__(835),
	  /* scopeId */
	  "data-v-0ea55dd2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getHotComments = getHotComments;
	exports.getCommentDetail = getCommentDetail;
	exports.getSubjectList = getSubjectList;
	exports.getTopicBlockList = getTopicBlockList;
	exports.getDetail = getDetail;
	exports.getDetailPreview = getDetailPreview;
	exports.getDetailGov = getDetailGov;
	exports.getLiveDetail = getLiveDetail;
	exports.getLive = getLive;
	exports.getLiveComments = getLiveComments;
	exports.getAskDetail = getAskDetail;
	exports.getAskRelated = getAskRelated;
	exports.getAskTopic = getAskTopic;
	exports.getPagerDetail = getPagerDetail;
	
	var _device = __webpack_require__(82);
	
	var _project = __webpack_require__(13);
	
	var defaults = {
		client_ver: _project.client_ver,
		device_size: _device.pixel
	};
	
	function getAjaxPromise(opts) {
		console.log(opts);
		var url_prefix = _project.intfc_prefix_common;
		var url = url_prefix + opts.url;
		var type = opts.type || 'GET';
		var data = $.extend({}, opts.params);
		var dataType = opts.dataType || 'json';
		return $.ajax({
			type: type,
			url: url,
			data: data,
			dataType: dataType
		});
	}
	function getGovAjaxPromise(opts) {
		console.log(opts);
		var url_prefix = _project.govUrl;
		var url = url_prefix + opts.url;
		var type = opts.type || 'GET';
		var data = $.extend({}, opts.params);
		var dataType = opts.dataType || 'json';
		return $.ajax({
			type: type,
			url: url,
			data: data,
			dataType: dataType
		});
	}
	
	function getHotComments(params) {
		params['count'] = 5;
	}
	function getCommentDetail(params) {
		var url = '/comment/commentdetail';
		return getAjaxPromise({ url: url, params: params });
	}
	
	function getSubjectList(params) {
		var url = '/api/v2/subjects/' + params.articleId;
		return getAjaxPromise({ url: url, params: params });
	}
	function getTopicBlockList(params) {
		var url = '/api/v2/blocks/' + params.articleId;
		return getAjaxPromise({ url: url, params: params });
	}
	
	function getDetail(params) {
		var url = '/api/v2/articles/detail/' + params.articleId;
		return getAjaxPromise({ url: url });
	}
	function getDetailPreview(params) {
		var url = '/api/v2/articles/detailPreview/' + params.articleId;
		return getAjaxPromise({ url: url });
	}
	function getDetailGov(params) {
		var url = '/api/v2/articles/info/' + params.articleId;
		return getGovAjaxPromise({ url: url });
	}
	
	function getLiveDetail(params) {
		var url = '/api/v2/live/detail/' + params.articleId;
		return getAjaxPromise({ url: url, params: params });
	}
	
	function getLive(params) {
		var url = '/api/v2/live/liveRoomTalk';
		return getAjaxPromise({ url: url, params: params });
	}
	function getLiveComments(params) {
		var url = '/api/v2/live/liveRoomComment';
		return getAjaxPromise({ url: url, params: params });
	}
	function getAskDetail(params) {
		var url = '/ask/detail';
		return getAjaxPromise({ url: url, params: params });
	}
	
	function getAskRelated(params) {
		var url = '/ask/related';
		return getAjaxPromise({ url: url, params: params });
	}
	
	function getAskTopic(params) {
		var url = '/ask/topicdetail';
		return getAjaxPromise({ url: url, params: params });
	}
	function getPagerDetail(params) {
		var url = '';
	
		var url_prefix = 'http://vweb.people.cn/test/common/api/paper/paperdetail.php';
		return getAjaxPromise({ url_prefix: url_prefix, url: url, params: params });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var docEl = document.documentElement;
	var dpr = window.devicePixelRatio || 1;
	var width = docEl.clientWidth;
	var height = docEl.clientHeight;
	var pixel = width * dpr + 'x' + height * dpr;
	
	var ua = navigator.userAgent;
	
	var isIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	var isAdr = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1;
	var isWx = !!ua.match(/MicroMessenger/i);
	
	exports.dpr = dpr;
	exports.width = width;
	exports.height = height;
	exports.pixel = pixel;
	exports.isIos = isIos;
	exports.isAdr = isAdr;
	exports.isWx = isWx;

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(413),
	  /* template */
	  __webpack_require__(840),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var newsItemMixin = {
		computed: {
			path: function path() {
				console.log(this.item.sysCode);
				var item = this.item;
	
				if (item.type === 'subject') {
					return '#/topic/' + item.articleId;
				} else if (item.type === 'image') {
					return '#/img/' + item.sysCode + '/' + item.categoryId + '/' + item.articleId;
				} else if (item.type === 'link') {
					return item.link;
				} else {
					if (item.sysCode == "article") {
						return '#/detail/normal/' + item.articleId;
					} else if (item.sysCode == "paper") {
						return '#/detail/paper/' + item.articleId;
					}
				}
			}
		}
	};
	
	exports.default = newsItemMixin;

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(741)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(411),
	  /* template */
	  __webpack_require__(853),
	  /* scopeId */
	  "data-v-53527c84",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(416),
	  /* template */
	  __webpack_require__(868),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(753)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(421),
	  /* template */
	  __webpack_require__(869),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(755)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(422),
	  /* template */
	  __webpack_require__(872),
	  /* scopeId */
	  "data-v-f90fef22",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(426),
	  /* template */
	  __webpack_require__(848),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(737)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(447),
	  /* template */
	  __webpack_require__(843),
	  /* scopeId */
	  "data-v-33ee5711",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(53);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'app',
		data: function data() {
			return {
				isPreviewPage: false
			};
		},
		created: function created() {
			window.appapi = _appapi2.default;
			window.$vm = this;
			this.isPreviewPage = appapi.isPreviewPage();
		},
		mounted: function mounted() {
			if (this.$route.query.preview && !navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/webOS/i) && !navigator.userAgent.match(/iPhone/i) && !navigator.userAgent.match(/iPad/i) && !navigator.userAgent.match(/iPod/i) && !navigator.userAgent.match(/BlackBerry/i) && !navigator.userAgent.match(/Windows Phone/i)) {
				$('html').css({ 'max-width': '375px', 'font-size': '37.5px' });
			}
	
			var appW = this.$refs.app.offsetWidth;
			this.updateWidth(appW);
		},
	
		methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
			updateWidth: 'app:update:width'
		}))
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	
	function timeFormat(time) {
		var t1 = Math.floor(time / 60);
		var t2 = Math.floor(time % 60);
		if (t1 < 10) {
			t1 = "0" + t1;
		}
		if (t2 < 10) {
			t2 = "0" + t2;
		}
		return t1 + ":" + t2;
	}
	
	exports.default = {
		props: {
			src: {
				type: String,
				default: ""
			},
			totalTimes: {
				type: String,
				default: ""
			}
		},
		data: function data() {
			return {
				status: 1,
	
				currentTime: 0,
	
				duration: 0,
	
				bw: 0,
	
				pw_t: 0,
	
				pw_c: 0,
	
				dw: 0,
	
				dl: 0,
	
				moving: false
			};
		},
		computed: {
			currentTime_f: function currentTime_f() {
				return timeFormat(this.currentTime);
			},
			duration_f: function duration_f() {
				var totalTime = timeFormat(this.duration);
				if (totalTime === "00:00") {
					totalTime = this.totalTimes;
				}
				return totalTime;
			},
	
			bw_f: function bw_f() {
				return this.bw + "px";
			},
	
			pw_c_f: function pw_c_f() {
				return this.pw_c + "px";
			},
	
			dl_f: function dl_f() {
				return this.dl + "px";
			}
		},
		mounted: function mounted() {
			var _this = this;
	
			this.$nextTick(function () {
				_this.pw_t = _this.$refs.bar.offsetWidth;
				_this.dw = _this.$refs.dot.offsetWidth;
				_this.dl = -_this.dw / 2;
				var audio = _this.$refs.audio;
				console.log('pw_t', pw_t, 'dw', dw, 'dl', dl, 'audio.duration', audio.duration);
			});
		},
		methods: {
			onLoadedmetadata: function onLoadedmetadata() {
				var audio = this.$refs.audio;
				var readyState = audio.readyState;
				var duration = audio.duration;
				if ((readyState === 1 || readyState === 4) && duration && duration !== 1) {
					this.duration = duration;
				}
			},
	
			onCanplay: function onCanplay() {
				var vm = this;
				var audio = vm.$refs.audio;
				vm.pw_t = vm.$refs.bar.offsetWidth;
				var bufferTimer = setInterval(function () {
					if (audio.buffered && audio.buffered == undefined) {
						return;
					}
					var bufferIndex = audio.buffered.length;
					if (bufferIndex > 0) {
						vm.bw = audio.buffered.end(bufferIndex - 1) / audio.duration * vm.pw_t;
						if (Math.abs(audio.duration - audio.buffered.end(bufferIndex - 1)) < 1) {
							vm.bw = vm.pw_t;
							clearInterval(bufferTimer);
						}
					}
				});
				console.log("onCanplay", audio.buffered.end(audio.buffered.length - 1));
	
				console.log("onCanplay pw_t", vm.pw_t);
			},
	
			onTimeupdate: function onTimeupdate() {
				var audio = this.$refs.audio;
				var duration = audio.duration;
				var currentTime = audio.currentTime;
				if (currentTime != 0 & !isNaN(duration)) {
					if (!this.duration) {
						this.duration = duration;
					}
					this.currentTime = currentTime;
					this.pw_c = currentTime / duration * this.pw_t;
					if (!this.moving) {
						this.dl = this.pw_c - this.dw / 2;
					}
					if (audio.ended) {
						this.resetPlayer();
					}
				}
			},
	
			onToggle: function onToggle() {
				var audio = this.$refs.audio;
	
				if (this.status === 0) {
					this.status = 1;
					audio.pause();
				} else {
					this.status = 0;
					audio.play();
				}
			},
	
			onStart: function onStart($event) {
				if (!this.bw) {
					return;
				}
				this.moving = true;
				this.dot_sx = $event.targetTouches && $event.targetTouches.length ? $event.targetTouches[0].pageX : $event.pageX;
				this.dl_s = this.dl;
			},
	
			onMove: function onMove($event) {
				this.dot_nx = $event.targetTouches && $event.targetTouches.length ? $event.targetTouches[0].pageX : $event.pageX;
				var range = this.dot_nx - this.dot_sx;
				if (range > 0) {
					if (this.dl_s + range < this.pw_t) {
						this.dl = this.dl_s + range;
					} else {
						this.dl = this.pw_t - this.dw / 2;
					}
				} else if (range < 0) {
					if (this.dl_s + range < 0) {
						this.dl = -this.dw / 2;
					} else {
						this.dl = this.dl_s + range;
					}
				}
			},
	
			onEnd: function onEnd($event) {
				var audio = this.$refs.audio;
				var duration = audio.duration;
				audio.currentTime = this.dl / this.pw_t * duration;
				this.moving = false;
			},
	
			onBarClick: function onBarClick($event) {
				if (!this.bw) {
					return;
				}
				var audio = this.$refs.audio;
				var duration = audio.duration;
				this.dl = $event.clientX - this.$refs.bar.getBoundingClientRect().left;
				audio.currentTime = this.dl / this.pw_t * duration;
			},
	
			stepPlayer: function stepPlayer(val) {
				var audio = this.$refs.audio;
				var duration = audio.duration;
				var step = this.pw_t / duration * 10;
				if (val > 0) {
					if (this.currentTime + 10 > duration) {
						audio.currentTime = duration;
						this.currentTime = 0;
					} else {
						audio.currentTime = this.currentTime == 0 ? this.currentTime : audio.currentTime;
						this.currentTime = audio.currentTime + 10;
						audio.currentTime = this.currentTime;
						this.dl = this.dl + step;
					}
				} else {
					if (this.currentTime == 0) return;
					if (this.currentTime - 10 < 0) {
						this.currentTime = 0;
						audio.currentTime = this.currentTime;
						this.dl = -this.dw / 2;
					} else {
						this.currentTime = audio.currentTime - 10;
						audio.currentTime = this.currentTime;
						this.dl = this.dl - step;
					}
				}
			},
	
			resetPlayer: function resetPlayer() {
				var audio = this.$refs.audio;
				this.currentTime = 0;
				this.pw_c = 0;
				this.dl = -this.dw / 2;
				this.status = 1;
				audio.pause();
			}
		},
		watch: {
			totalTimes: function totalTimes(val, oldVal) {
				console.log('val', val);
			}
		}
	};

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: '',
	  props: {
	    bannerUrl: Array
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: {},
	  watch: {},
	  created: function created() {},
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      _this._initScroll();
	    });
	  },
	
	  methods: {
	    _initScroll: function _initScroll() {
	      this.swipeScroll = new this.$BScroll(this.$refs.subjectSwipe, {
	        click: true,
	        scrollX: true,
	        freeScroll: true,
	        eventPassthrough: 'vertical'
	      });
	    }
	  },
	  filters: {},
	  components: {}
	};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(75);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _comListSwipe = __webpack_require__(382);
	
	var _comListSwipe2 = _interopRequireDefault(_comListSwipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ["relvantNewsData"],
	    data: function data() {
	        return {
	            isSharePage: false };
	    },
	    created: function created() {
	        window.appapi = _appapi2.default;
	        this.isSharePage = appapi.isSharePage();
	    },
	    mounted: function mounted() {},
	
	
	    methods: {
	
	        getDate: function getDate(date) {
	            return date.slice(0, -2) + ':00';
	        },
	
	        goPath: function goPath(article) {
	            if (!this.isSharePage) {
	                var articleId = article.articleId,
	                    type = article.type,
	                    sysCode = article.sysCode;
	
	                var obj = {
	                    articleId: articleId,
	                    type: type,
	                    sysCode: sysCode
	                };
	                window.appapi.appPostMessage("goNewsDetail", (0, _stringify2.default)(obj));
	            } else {
	                window.location.href = article.shareUrl;
	            }
	        }
	    },
	    components: {
	        subjectSwipe: _comListSwipe2.default
	    }
	};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _commentBlock = __webpack_require__(805);
	
	var _commentBlock2 = _interopRequireDefault(_commentBlock);
	
	__webpack_require__(713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: {
			comments: {
				type: Array,
				default: []
			},
			blockTitle: {
				type: String,
				default: '热门评论'
			}
		},
		components: {
			CommentBlock: _commentBlock2.default
		},
		computed: {
			show: function show() {
				if (Jt.array.isEmpty(this.comments)) {
					return false;
				}
				return true;
			}
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _commentItem = __webpack_require__(806);
	
	var _commentItem2 = _interopRequireDefault(_commentItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			CommentItem: _commentItem2.default
		},
		props: ['comments']
	
	};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _mainItem = __webpack_require__(807);
	
	var _mainItem2 = _interopRequireDefault(_mainItem);
	
	var _replyItem = __webpack_require__(809);
	
	var _replyItem2 = _interopRequireDefault(_replyItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default],
		components: {
			MainItem: _mainItem2.default,
			ReplyItem: _replyItem2.default
		},
		props: ['item'],
		data: function data() {
			return {
				openReplyStatus: false
			};
		},
	
		computed: {
			showReply: function showReply() {
				if (!Jt.array.isEmpty(this.item.replies)) {
					return true;
				}
				return false;
			},
			replyCount: function replyCount() {
				if (!Jt.array.isEmpty(this.item.replies)) {
					return this.item.replies.length;
				}
				return 0;
			}
		},
		methods: {
			openReplyHandle: function openReplyHandle() {
				this.openReplyStatus = true;
			}
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default],
		props: ['item', 'hide'],
		data: function data() {
			return {
				textWrapClosed: true,
				textClosed: false,
				showToggle: false
			};
		},
	
		watch: {
			hide: function hide(newVal, oldVal) {
				this.calcHeight();
			}
		},
		mounted: function mounted() {
			this.calcHeight();
		},
	
		methods: {
			calcHeight: function calcHeight() {
				this.$nextTick(function () {
					var textWrap = this.$refs.textWrap;
					var text = this.$refs.text;
					var outerH = textWrap.offsetHeight;
					var innerH = text.offsetHeight;
					if (outerH < innerH) {
						this.textClosed = true;
						this.showToggle = true;
					}
				});
			},
			toggleText: function toggleText() {
				this.textWrapClosed = !this.textWrapClosed;
				this.textClosed = !this.textClosed;
			}
		}
	};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _mainTopBar = __webpack_require__(808);
	
	var _mainTopBar2 = _interopRequireDefault(_mainTopBar);
	
	var _itemContent = __webpack_require__(383);
	
	var _itemContent2 = _interopRequireDefault(_itemContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default],
		components: {
			MainTopBar: _mainTopBar2.default,
			ItemContent: _itemContent2.default
		},
		props: ['item']
	};

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		props: ['item']
	};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _replyTopBar = __webpack_require__(810);
	
	var _replyTopBar2 = _interopRequireDefault(_replyTopBar);
	
	var _itemContent = __webpack_require__(383);
	
	var _itemContent2 = _interopRequireDefault(_itemContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default],
		components: {
			ReplyTopBar: _replyTopBar2.default,
			ItemContent: _itemContent2.default
		},
		props: {
			item: {
				type: Object,
				required: true
			},
			index: {
				type: Number,
				required: true
			},
			count: {
				type: Number,
				required: true
			},
			openReplyStatus: {
				type: Boolean,
				required: true
			},
			openReplyHandle: {
				type: Function,
				required: true
			}
		},
		computed: {
			itemHide: function itemHide() {
				if (this.index > 1 && this.index < this.count - 1 && !this.openReplyStatus) {
					return true;
				}
				return false;
			},
			openBtnShow: function openBtnShow() {
				if (this.index === this.count - 1 && this.index > 2 && !this.openReplyStatus) {
					return true;
				}
				return false;
			}
		}
	};

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		props: ['item']
	};

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	
	function timeFormat(time) {
		var t1 = Math.floor(time / 60);
		var t2 = Math.floor(time % 60);
		if (t1 < 10) {
			t1 = "0" + t1;
		}
		if (t2 < 10) {
			t2 = "0" + t2;
		}
		return t1 + ":" + t2;
	}
	
	exports.default = {
		props: {
			src: {
				type: String,
				default: ""
			}
		},
		data: function data() {
			return {
				status: 0,
	
				currentTime: 0,
	
				duration: 0,
	
				bw: 0,
	
				pw_t: 0,
	
				pw_c: 0,
	
				dw: 0,
	
				dl: 0,
	
				moving: false
			};
		},
		computed: {
			currentTime_f: function currentTime_f() {
				return timeFormat(this.currentTime);
			},
			duration_f: function duration_f() {
				return timeFormat(this.duration);
			},
			bw_f: function bw_f() {
				return this.bw + "px";
			},
			pw_c_f: function pw_c_f() {
				return this.pw_c + "px";
			},
			dl_f: function dl_f() {
				return this.dl + "px";
			}
		},
		mounted: function mounted() {
			this.pw_t = this.$refs.bar.offsetWidth;
			this.dw = this.$refs.dot.offsetWidth;
			this.dl = -this.dw / 2;
		},
		methods: {
			onLoadedmetadata: function onLoadedmetadata() {
				var audio = this.$refs.audio;
				var readyState = audio.readyState;
				var duration = audio.duration;
				if ((readyState === 1 || readyState === 4) && duration && duration !== 1) {
					this.duration = duration;
				}
			},
	
			onCanplay: function onCanplay() {
				var vm = this;
				var audio = vm.$refs.audio;
				var bufferTimer = setInterval(function () {
					if (audio.buffered == undefined) {
						return;
					}
					var bufferIndex = audio.buffered.length;
					if (bufferIndex > 0) {
						vm.bw = audio.buffered.end(bufferIndex - 1) / audio.duration * vm.pw_t;
						if (Math.abs(audio.duration - audio.buffered.end(bufferIndex - 1)) < 1) {
							vm.bw = vm.pw_t;
							clearInterval(bufferTimer);
						}
					}
				});
			},
	
			onTimeupdate: function onTimeupdate() {
				var audio = this.$refs.audio;
				var duration = audio.duration;
				var currentTime = audio.currentTime;
				if (currentTime != 0 & !isNaN(duration)) {
					if (!this.duration) {
						this.duration = duration;
					}
					this.currentTime = currentTime;
					this.pw_c = currentTime / duration * this.pw_t;
					if (!this.moving) {
						this.dl = this.pw_c - this.dw / 2;
					}
					if (audio.ended) {
						this.resetPlayer();
					}
				}
			},
	
			onToggle: function onToggle() {
				var audio = this.$refs.audio;
				if (isNaN(audio.duration)) {
					return;
				}
				this.status = this.status ? 0 : 1;
				this.status === 1 ? audio.play() : audio.pause();
			},
	
			onStart: function onStart($event) {
				if (!this.bw) {
					return;
				}
				this.moving = true;
				this.dot_sx = $event.targetTouches && $event.targetTouches.length ? $event.targetTouches[0].pageX : $event.pageX;
				this.dl_s = this.dl;
			},
	
			onMove: function onMove($event) {
				this.dot_nx = $event.targetTouches && $event.targetTouches.length ? $event.targetTouches[0].pageX : $event.pageX;
				var range = this.dot_nx - this.dot_sx;
				if (range > 0) {
					if (this.dl_s + range < this.pw_t) {
						this.dl = this.dl_s + range;
					} else {
						this.dl = this.pw_t - this.dw / 2;
					}
				} else if (range < 0) {
					if (this.dl_s + range < 0) {
						this.dl = -this.dw / 2;
					} else {
						this.dl = this.dl_s + range;
					}
				}
			},
	
			onEnd: function onEnd($event) {
				var audio = this.$refs.audio;
				var duration = audio.duration;
				audio.currentTime = this.dl / this.pw_t * duration;
				this.moving = false;
			},
	
			onBarClick: function onBarClick($event) {
				if (!this.bw) {
					return;
				}
				var audio = this.$refs.audio;
				var duration = audio.duration;
				this.dl = $event.clientX - this.$refs.bar.getBoundingClientRect().left;
				audio.currentTime = this.dl / this.pw_t * duration;
			},
	
			resetPlayer: function resetPlayer() {
				var audio = this.$refs.audio;
				this.currentTime = 0;
				this.pw_c = 0;
				this.dl = -this.dw / 2;
				this.status = 0;
				audio.pause();
			}
		}
	};

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "dialog",
	    props: {
	        isShow: {
	            type: Boolean,
	            default: false,
	            required: true
	        },
	        params: {
	            type: Object,
	            default: function _default() {}
	        }
	    },
	    updated: function updated() {
	        var _this = this;
	        this.$nextTick(function () {
	            new JMLink([{
	                jmlink: 'https://bciq41.jglinks.cn/Aan7',
	                button: document.querySelectorAll('button.openApp'),
	                autoLaunchApp: false,
	                autoRedirectToDownloadUrl: true,
	                downloadWhenUniversalLinkFailed: false,
	                inapp: false,
	                params: _this.params,
	                plhparams: _this.params
	            }]);
	        });
	    },
	
	    methods: {
	        doSomething: function doSomething(event) {},
	        close: function close() {
	            this.$emit("on-close");
	        },
	        ok: function ok() {}
	    }
	};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _style = __webpack_require__(229);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _lazyload = __webpack_require__(230);
	
	var _lazyload2 = _interopRequireDefault(_lazyload);
	
	var _vue = __webpack_require__(24);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _pageCommon = __webpack_require__(45);
	
	var _pageCommon2 = _interopRequireDefault(_pageCommon);
	
	var _project = __webpack_require__(13);
	
	var _icon_user_default_avatar = __webpack_require__(163);
	
	var _icon_user_default_avatar2 = _interopRequireDefault(_icon_user_default_avatar);
	
	var _weChatShare = __webpack_require__(39);
	
	var _weChatShare2 = _interopRequireDefault(_weChatShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_lazyload2.default);
	
	exports.default = {
	  data: function data() {
	    return {
	      getedMoreHeight: false,
	      timer: undefined,
	      showMoreDesc: false,
	      isSharePage: false,
	      data: {},
	      dataAll: {},
	      authors: "",
	      desc: "",
	      fontSizeNum: 3,
	      isPreviewPage: false
	    };
	  },
	
	  watch: {
	    dataAll: {
	      handler: function handler(val) {
	        console.log(11111, val);
	        if (this.isSharePage) {
	          (0, _weChatShare2.default)({
	            title: val.title.substr(0, 128)
	          }, this);
	        }
	      },
	
	      deep: true
	    }
	  },
	  created: function created() {
	    window.appapi = _appapi2.default;
	    window.$vm = this;
	
	    appapi.changeFontSize(this.$route.query.fontsize);
	    this.isPreviewPage = appapi.isPreviewPage();
	    this.isSharePage = appapi.isSharePage();
	    this.initNormal(this.$route.params.id);
	  },
	  destroyed: function destroyed() {
	    var wraper = document.querySelector(".wrapper");
	    var vbutton = wraper.querySelector(".content-button");
	    var video = wraper.querySelector("video");
	    var _this = this;
	    vbutton.removeEventListener("click");
	    video.removeEventListener("playing");
	    video.removeEventListener("pause");
	    video.removeEventListener("ended");
	  },
	  mounted: function mounted() {
	    this.setVideoUI();
	  },
	  updated: function updated() {
	    var _this2 = this;
	
	    if (!this.getedMoreHeight) {
	      this.$nextTick(function () {
	        _this2.getCanShowMore();
	        _this2.getedMoreHeight = true;
	      });
	    }
	  },
	
	  methods: {
	    getCanShowMore: function getCanShowMore() {
	      console.log(this.$refs.dsc.clientHeight, this.$refs.dsc.scrollHeight);
	      if (this.$refs.dsc.clientHeight + 2 < this.$refs.dsc.scrollHeight) {} else {
	        this.$refs.morebtn.parentNode.removeChild(this.$refs.morebtn);
	      }
	    },
	    showMore: function showMore() {
	      this.showMoreDesc = !this.showMoreDesc;
	    },
	    appPostMessage: function appPostMessage(name) {
	      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      if (name) window.appapi.appPostMessage(name, value);
	    },
	    setVideoUI: function setVideoUI() {
	      var wraper = document.querySelector(".wrapper");
	      var vbutton = wraper.querySelector(".content-button");
	      var video = wraper.querySelector("video");
	      var _this = this;
	      vbutton.addEventListener("click", function () {
	        console.log("!111111111111");
	        video.play();
	        vbutton.style.display = 'none';
	
	        this.timer = setTimeout(function () {
	          video.removeAttribute("controls");
	        }, 1000);
	      });
	      video.addEventListener("click", function (e) {
	        clearTimeout(this.timer);
	
	        video.pause();
	      });
	      video.addEventListener("playing", function () {
	        _this.appPostMessage('getNetState');
	      });
	      video.addEventListener("pause", function () {
	        video.removeAttribute("controls");
	        vbutton.style.display = '';
	      });
	      video.addEventListener("ended", function () {
	        video.removeAttribute("controls");
	        vbutton.style.display = '';
	      });
	    },
	    initNormal: function initNormal(id) {
	      var _this3 = this;
	
	      var query = this.$route.query;
	      var isTimeLimit = query.isTimeLimit;
	      var articleUrl = _project.intfc_prefix_common + '/api/v2/articles/detail/';
	      if (!!isTimeLimit) {
	        articleUrl = _project.intfc_prefix_common + '/api/v2/articles/detailPreview/';
	      }
	
	      this.$axios.get('' + articleUrl + id).then(function (res) {
	        var result1 = res.item;
	        var result = res.item.medias[0] ? res.item.medias[0] : undefined;
	        if (res.code === 0 && result) {
	          _this3.data = result;
	          _this3.dataAll = result1;
	          _this3.authors = res.item.authors;
	          _this3.desc = res.item.description;
	          _this3.appPostMessage('renderFinish');
	        }
	      }).catch(function (e) {
	        console.log(e);
	      });
	    }
	  },
	  components: {
	    PageCommon: _pageCommon2.default
	  }
	};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _style = __webpack_require__(37);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _defaultHead = __webpack_require__(369);
	
	var _defaultHead2 = _interopRequireDefault(_defaultHead);
	
	var _project = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            head: _defaultHead2.default,
	            list: [],
	            loading: false,
	            isAll: false,
	            wrapperHeight: 0,
	            data: {
	                page: {
	                    last: 2
	                }
	            },
	            time: '',
	            next: 1,
	            clock: null,
	            el: null
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        this.getComment(this.$route.params.id);
	
	        this.el = setInterval(function () {
	            _this.getNewComment(_this.$route.params.id);
	        }, 30000);
	    },
	    mounted: function mounted() {
	        var _this2 = this;
	
	        this.$nextTick(function () {
	            _this2.wrapperHeight = document.documentElement.clientHeight - _this2.$refs.wrapper.getBoundingClientRect().top;
	        });
	    },
	    destroyed: function destroyed() {
	        clearInterval(this.el);
	    },
	
	
	    methods: {
	        getComment: function getComment(articleId) {
	            var _this3 = this;
	
	            this.loading = true;
	            var pageToken = this.next * 1;
	            var pageLast = this.data.page.last * 1;
	            if (pageToken > pageLast) {
	                this.loading = false;
	                this.isAll = true;
	                return false;
	            }
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/live/liveRoomComment?articleId=' + articleId + '&pageToken=' + pageToken).then(function (res) {
	                var result = res;
	                if (res.code === 0) {
	                    _this3.data = result;
	                    _this3.time = result.item.time;
	                    _this3.loading = false;
	                    if (_this3.data.items && _this3.data.items.length > 0) {
	                        _this3.data.items.map(function (item) {
	                            _this3.list.push(item);
	                        });
	
	                        _this3.next++;
	                    }
	                } else {
	                    (0, _toast2.default)(res.msg);
	                    _this3.loading = false;
	                }
	            });
	        },
	        getNewComment: function getNewComment(articleId) {
	            var _this4 = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/live/newLiveRoomComment?articleId=' + articleId + '&time=' + this.time + '&sysCode="live"').then(function (res) {
	                var result = res.items;
	                if (res.code === 0) {
	                    if (!result) {
	                        return;
	                    }
	                    _this4.time = res.item.time;
	                    result.map(function (item) {
	                        _this4.list.push(item);
	                    });
	                } else {
	                    (0, _toast2.default)(res.msg);
	                }
	            });
	        },
	
	
	        getDate: function getDate(date) {
	            return date.slice(0, -2) + ':00';
	        },
	
	        loadMore: function loadMore() {
	            if (this.isAll || this.loading) return false;
	
	            this.getComment(this.$route.params.id);
	        },
	        showGallary: function showGallary(src) {
	            this.$emit('handleGallary', src);
	        }
	    }
	};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(172);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(47);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _style = __webpack_require__(37);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _defaultHead = __webpack_require__(369);
	
	var _defaultHead2 = _interopRequireDefault(_defaultHead);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _lodash = __webpack_require__(758);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _timers = __webpack_require__(368);
	
	var _jquery = __webpack_require__(44);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _util = __webpack_require__(774);
	
	var _project = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            head: _defaultHead2.default,
	            top: null,
	            loading: false,
	            isAll: false,
	            data: {
	                page: {
	                    last: 2
	                }
	            },
	            list: [],
	            wrapperHeight: 0,
	            next: 1,
	            time: "",
	            clock: null,
	            el: null,
	            isShowVideo: true,
	            isQQBrowse: false,
	            isWeixin: false,
	            isAndroid: false,
	            saveVideo: null
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        var id = this.$route.params.id;
	        this.getLive(id);
	        window.appapi = _appapi2.default;
	        window.$vm = this;
	        this.isSharePage = appapi.isSharePage();
	        this.el = setInterval(function () {
	            _this.getNewLive(_this.$route.params.id);
	        }, 30000);
	
	        var ua = navigator.userAgent.toLocaleLowerCase();
	
	        if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
	            this.isQQBrowse = true;
	        }
	        if (ua.match(/MicroMessenger/i) == "micromessenger") {
	            this.isWeixin = true;
	        }
	        var u = navigator.userAgent;
	        if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
	            this.isAndroid = true;
	        }
	    },
	    mounted: function mounted() {
	        var _this2 = this;
	
	        this.$nextTick(function () {
	            _this2.wrapperHeight = document.documentElement.clientHeight - _this2.$refs.wrapper.getBoundingClientRect().top;
	        });
	    },
	    updated: function updated() {
	        this.audioNewEvent();
	        this.videoEvent();
	    },
	    destroyed: function destroyed() {
	        clearInterval(this.el);
	    },
	
	
	    methods: {
	        getLive: function getLive(articleId) {
	            var _this3 = this;
	
	            this.loading = true;
	            var pageToken = this.next * 1;
	            var pageLast = this.data.page.last * 1;
	            if (pageToken > pageLast) {
	                this.loading = false;
	                this.isAll = true;
	                return false;
	            }
	            this.$axios.get(_project.intfc_prefix_common + "/api/v2/live/liveRoomTalk?articleId=" + articleId + "&pageToken=" + pageToken).then(function (res) {
	                var result = res;
	                if (res.code === 0) {
	                    _this3.data = result;
	                    _this3.time = result.item.time;
	                    _this3.loading = false;
	                    if (result.items && result.items.length > 0) {
	                        result.items.map(function (n) {
	                            if (n.top) {
	                                _this3.top = _this3.getAvatar(n);
	                                return false;
	                            }
	                            var newData = _this3.getAvatar(n);
	                            _this3.list.push(newData);
	                        });
	
	                        _this3.next++;
	                    }
	                } else {
	                    _this3.loading = false;
	                    (0, _toast2.default)(res.msg);
	                }
	            });
	        },
	        getNewLive: function getNewLive(articleId) {
	            var _this4 = this;
	
	            try {
	                this.$axios.get(_project.intfc_prefix_common + "/api/v2/live/newLiveRoomTalk?articleId=" + articleId + "&time=" + this.time).then(function (res) {
	                    var result = res.items;
	                    if (res.code === 0) {
	                        _this4.time = res.item.time;
	                        var arr = _lodash2.default.remove(result, function (n) {
	                            if (n.top) {
	                                _this4.top = _this4.getAvatar(n);
	                                return false;
	                            }
	                            return true;
	                        });
	                        var newArr = _this4.getAvatar(arr);
	                        _this4.list = [].concat((0, _toConsumableArray3.default)(newArr), (0, _toConsumableArray3.default)(_this4.list));
	                    } else {
	                        _this4.loading = false;
	                        (0, _toast2.default)(res.msg);
	                    }
	                });
	            } catch (error) {}
	        },
	
	
	        getDate: function getDate(date) {
	            return date.slice(0, -2) + ":00";
	        },
	
	        loadMore: function loadMore() {
	            if (this.isAll || this.loading) return false;
	
	            this.getLive(this.$route.params.id);
	        },
	        audioNewEvent: function audioNewEvent() {
	            var audios = document.getElementsByTagName("audio");
	            var videos = document.getElementsByTagName("video");
	
	            function pauseAll() {
	                var self = this;
	                [].forEach.call(audios, function (i) {
	                    i !== self && i.pause();
	                });
	                [].forEach.call(videos, function (i) {
	                    i !== self && i.pause();
	                });
	            }
	
	            [].forEach.call(audios, function (i) {
	                i.addEventListener("play", pauseAll.bind(i));
	            });
	        },
	        videoEvent: function videoEvent() {
	            var videoArray = document.getElementsByClassName("videoClass");
	
	            var _loop = function _loop() {
	                videoArray[i].onpause = function () {};
	                videoArray[i].onplay = function () {
	                    stop("audioClass");
	                };
	                function stopOtherVideo(i) {
	                    for (var j = 0; j < videoArray.length; j++) {
	                        if (!videoArray[j].paused && i !== j) {
	                            videoArray[j].pause();
	                        }
	                    }
	                }
	                function stop(className) {
	                    var tagArray = document.getElementsByClassName(className);
	                    for (var i = 0; i < tagArray.length; i++) {
	                        if (!tagArray[i].paused) {
	                            tagArray[i].pause();
	                        }
	                    }
	                }
	            };
	
	            for (var i = 0; i < videoArray.length; i++) {
	                _loop();
	            }
	        },
	        getAvatar: function getAvatar(obj) {
	            var newObj = (0, _assign2.default)({}, obj);
	            newObj.isShowVideo = false;
	            if (obj.userIcon) {
	                var userIcon = obj.userIcon;
	                var httpStr = userIcon.slice(0, 4);
	                if (httpStr !== "http") {
	                    newObj.userIcon = this.head;
	                }
	            }
	            return newObj;
	        },
	        showGallary: function showGallary(src) {
	            this.$emit('handleGallary', src);
	        }
	    }
	};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _newsItem = __webpack_require__(816);
	
	var _newsItem2 = _interopRequireDefault(_newsItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default],
		props: ['list'],
		components: {
			NewsItem: _newsItem2.default
		},
		computed: {
			show: function show() {
				if (Jt.array.isEmpty(this.list)) {
					return false;
				}
				return true;
			},
			relatedNews: function relatedNews() {
				var relatedNews = this.list || [];
				for (var i = 0, len = relatedNews.length; i < len; i++) {
					relatedNews[i].view_type = 'normal';
					relatedNews[i].id = relatedNews[i].articleId;
					relatedNews[i].news_timestamp = relatedNews[i].date;
				}
				return relatedNews;
			}
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		props: ['list'],
		computed: {
			show: function show() {
				if (Jt.array.isEmpty(this.list)) {
					return false;
				}
				return true;
			},
			isShowResult: function isShowResult() {
				var votesList = this.list || [];
				for (var i = 0; i < votesList.length; i++) {
					if (votesList[i].isShowResult) {
						return true;
					}
					return false;
				}
			},
			votesList: function votesList() {
				var votesList = this.list || [];
				for (var i = 0; i < votesList.length; i++) {
					var options = votesList[i].options,
					    total = 0,
					    len = options.length;
					for (var j = 0; j < len; j++) {
						total += parseInt(options[j].hits);
					}
					var preoArr = [];
					for (var k = 0; k < len; k++) {
						var preo_val = 0;
						if (total > 0) {
							if (k != len - 1) {
								preo_val = parseInt(parseFloat(options[k].hits) / total * 100);
							} else {
								var temp = 0;
								for (var _k = 0; _k < preoArr.length; _k++) {
									temp += preoArr[_k];
								}
								preo_val = 100 - temp;
							}
							preoArr.push(preo_val);
						}
						options[k].preo_val = preo_val;
					}
				}
				return votesList;
			}
		}
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(53);
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _newsItem = __webpack_require__(171);
	
	var _newsItem2 = _interopRequireDefault(_newsItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default, _newsItem2.default],
		props: ['item'],
		computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
			appW: 'app:width'
		}), {
			imgH: function imgH() {
				var imgW = (this.appW - 30) / 2;
				return imgW * 3 / 4 + 'px';
			},
			showComment: function showComment() {
				var count = this.item.comments + '';
				if (!Jt.string.isEmpty(count) && count !== '0') {
					return true;
				}
				return false;
			}
		})
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _newsNormal = __webpack_require__(817);
	
	var _newsNormal2 = _interopRequireDefault(_newsNormal);
	
	var _newsImg = __webpack_require__(815);
	
	var _newsImg2 = _interopRequireDefault(_newsImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			NewsNormal: _newsNormal2.default,
			NewsImg: _newsImg2.default
		},
		props: ['item'],
		computed: {
			type: function type() {
	
				var viewType = this.item.viewType;
				var type = this.item.type;
	
				return "normal";
			}
		}
	};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _newsItem = __webpack_require__(171);
	
	var _newsItem2 = _interopRequireDefault(_newsItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default, _newsItem2.default],
		props: ['item'],
		computed: {
			showImg: function showImg() {
				if (this.item.isTailor) {
					return this.item.images ? this.item.images[0] : "";
				} else {
					return this.item.realImages ? this.item.realImages[0] : "";
				}
			},
			showJoin: function showJoin() {
				var joinCount = parseInt(this.item.joinCount);
				if (joinCount === 0 || isNaN(joinCount)) {
					return false;
				}
				return true;
			},
			showTag: function showTag() {
				var tag = this.item.tags;
				if (!Jt.string.isEmpty(tag)) {
					return true;
				}
				return false;
			},
			showComment: function showComment() {
				var count = this.item.comments;
				if (!Jt.string.isEmpty(count) && count !== '0') {
					return true;
				}
				return false;
			}
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _style = __webpack_require__(159);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _spinner = __webpack_require__(161);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _style3 = __webpack_require__(37);
	
	var _style4 = _interopRequireDefault(_style3);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _toConsumableArray2 = __webpack_require__(47);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(75);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _project = __webpack_require__(13);
	
	var _comListSwipe = __webpack_require__(382);
	
	var _comListSwipe2 = _interopRequireDefault(_comListSwipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            isSharePage: false,
	            articleList: [],
	            loading: false,
	            isAll: false,
	            data: {
	                page: {
	                    last: 2
	                }
	            },
	            next: 1,
	            pageToken: ''
	        };
	    },
	    created: function created() {
	        window.appapi = _appapi2.default;
	        this.isSharePage = appapi.isSharePage();
	    },
	    mounted: function mounted() {
	        this.getArticles();
	    },
	
	
	    methods: {
	
	        getDate: function getDate(date) {
	            return date.slice(0, -2) + ':00';
	        },
	        goPath: function goPath(article) {
	            if (!this.isSharePage) {
	                var listTitle = article.listTitle,
	                    pushDate = article.pushDate,
	                    source = article.source,
	                    likes = article.likes,
	                    imageUrl = article.imageUrl,
	                    articleId = article.articleId,
	                    type = article.type,
	                    sysCode = article.sysCode;
	
	
	                var obj = {
	                    listTitle: listTitle,
	                    pushDate: pushDate,
	                    source: source,
	                    likes: likes,
	                    imageUrl: imageUrl,
	                    articleId: articleId,
	                    type: type,
	                    sysCode: sysCode
	                };
	                window.appapi.appPostMessage("goNewsDetail", (0, _stringify2.default)(obj));
	            } else {
	                window.location.href = article.shareUrl.slice(article.shareUrl.indexOf("://") + 1);
	            }
	        },
	        getArticles: function getArticles(id, index) {
	            var _this = this;
	
	            var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
	
	            this.loading = true;
	            this.pageToken = this.next * 1;
	            var pageLast = this.data.page.last * 1;
	            console.log(pageLast);
	            if (this.pageToken > pageLast) {
	                this.loading = false;
	                this.isAll = true;
	                return false;
	            }
	            this.$axios.get(_project.intfc_prefix_common + "/api/v2/articles/recommentPage?articleId=" + this.$route.params.id + "&pageToken=" + this.pageToken + "&size=5").then(function (res) {
	                var result = res;
	                if (res.code === 0) {
	                    _this.data = result;
	                    _this.loading = false;
	                    if (_this.data.item && _this.data.item.list.length > 0) {
	                        var _articleList;
	
	                        console.log('this.data.item.list', _this.data.item.list);
	                        (_articleList = _this.articleList).push.apply(_articleList, (0, _toConsumableArray3.default)(_this.data.item.list));
	                    }
	                    _this.next++;
	                } else {
	                    (0, _toast2.default)(res.msg);
	                    _this.loading = false;
	                }
	            });
	        },
	        loadMore: function loadMore() {
	            if (this.isAll || this.loading) return false;
	            this.getArticles(this.$route.params.id);
	        }
	    },
	    components: {
	        subjectSwipe: _comListSwipe2.default,
	        spinner: _spinner2.default
	    }
	};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _style = __webpack_require__(37);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _toConsumableArray2 = __webpack_require__(47);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _style3 = __webpack_require__(159);
	
	var _style4 = _interopRequireDefault(_style3);
	
	var _spinner = __webpack_require__(161);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _style5 = __webpack_require__(719);
	
	var _style6 = _interopRequireDefault(_style5);
	
	var _infiniteScroll = __webpack_require__(761);
	
	var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _mine_avatar = __webpack_require__(370);
	
	var _mine_avatar2 = _interopRequireDefault(_mine_avatar);
	
	var _icon_user_default_avatar = __webpack_require__(163);
	
	var _icon_user_default_avatar2 = _interopRequireDefault(_icon_user_default_avatar);
	
	var _icon_Quotes2x = __webpack_require__(769);
	
	var _icon_Quotes2x2 = _interopRequireDefault(_icon_Quotes2x);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _project = __webpack_require__(13);
	
	var _themeListArticle = __webpack_require__(818);
	
	var _themeListArticle2 = _interopRequireDefault(_themeListArticle);
	
	var _themeRemark = __webpack_require__(820);
	
	var _themeRemark2 = _interopRequireDefault(_themeRemark);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    directives: { InfiniteScroll: _infiniteScroll2.default },
	    components: {
	        spinner: _spinner2.default,
	        listArticle: _themeListArticle2.default,
	        themeRemark: _themeRemark2.default
	    },
	    props: ['sysCode'],
	    data: function data() {
	        return {
	            activeTab: '0',
	            tabList: [{
	                key: '0',
	                text: '留言'
	            }, {
	                key: '1',
	                text: '相关阅读'
	            }],
	            head: _mine_avatar2.default,
	            icon: _icon_user_default_avatar2.default,
	            hotImg: _icon_Quotes2x2.default,
	            loading: false,
	            isAll: false,
	            wrapperHeight: 0,
	            hotCommentsList: [],
	            newCommentsList: [],
	            data: {
	                page: {
	                    last: 2
	                }
	            },
	            next: 1,
	            pageToken: ''
	        };
	    },
	    created: function created() {
	        window.appapi = _appapi2.default;
	        this.isSharePage = appapi.isSharePage();
	    },
	    mounted: function mounted() {
	        var _this = this;
	
	        this.hasNoListArticle();
	        this.$nextTick(function () {
	            _this.wrapperHeight = document.documentElement.clientHeight - _this.$refs.wrapper.getBoundingClientRect().top;
	        });
	    },
	
	    watch: {
	        'sysCode': function sysCode(newVal, oldVal) {
	            console.log(newVal, 'newVal, oldVal', oldVal);
	            if (newVal) {
	                this.getComment(this.$route.params.id);
	            }
	        }
	    },
	    methods: {
	        hasNoListArticle: function hasNoListArticle() {
	            var _this2 = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/articles/recommentPage?articleId=' + this.$route.params.id + '&pageToken=' + this.pageToken + '&size=5').then(function (res) {
	                var result = res;
	                if (res.code === 0 && res.item.count == 0) {
	                    _this2.tabList.splice(1);
	                }
	            });
	        },
	        handleTabClick: function handleTabClick(value) {
	            this.activeTab = value;
	        },
	        getComment: function getComment(articleId) {
	            var _this3 = this;
	
	            this.loading = true;
	            this.pageToken = this.next * 1;
	            var pageLast = this.data.page.last * 1;
	            if (this.pageToken > pageLast) {
	                this.loading = false;
	                this.isAll = true;
	                return false;
	            }
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/comments/commentList/' + this.sysCode + '/' + this.$route.params.id + '?pageToken=' + this.pageToken).then(function (res) {
	                var result = res;
	                if (res.code === 0) {
	                    _this3.data = result;
	                    _this3.loading = false;
	                    if (_this3.data.item && _this3.data.item.hotComments && _this3.data.item.hotComments.length > 0 && _this3.next === 1) {
	                        _this3.hotCommentsList = _this3.data.item.hotComments;
	                    }
	                    if (_this3.data.item && _this3.data.item.newComments && _this3.data.item.newComments.length > 0) {
	                        var _newCommentsList;
	
	                        (_newCommentsList = _this3.newCommentsList).push.apply(_newCommentsList, (0, _toConsumableArray3.default)(_this3.data.item.newComments));
	                        _this3.next++;
	                    }
	                } else {
	                    (0, _toast2.default)(res.msg);
	                    _this3.loading = false;
	                }
	            });
	        },
	
	        getDate: function getDate(date) {
	            return date.slice(0, -2) + ':00';
	        },
	        loadMore: function loadMore() {
	            if (this.isAll || this.loading) return false;
	            this.getComment(this.$route.params.id);
	        },
	        appPostMessage: function appPostMessage(name) {
	            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	            if (name) window.appapi.appPostMessage(name, value);
	        },
	        getLikesCount: function getLikesCount(count) {
	            var result = '';
	            if (count > 0) {
	                result = count;
	                if (count > 999999) {
	                    result = count.substring(0, count.length - 4) + '万';
	                    if (count > 99999999) {
	                        result = '过亿';
	                    }
	                }
	            }
	            return result;
	        },
	        setActiveLike: function setActiveLike(opt) {
	            this.$emit("on-openApp", opt);
	        }
	    }
	};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    content: {
	      type: String
	    },
	    image: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      terminalFlag: '',
	      isHideFlag: false,
	      isNeedUnfold: false,
	      unfoldText: "展开",
	      lineNum: 5
	    };
	  },
	
	  computed: {
	    contentFormat: function contentFormat() {
	      var str1 = this.content.replace(/ /g, "");
	      var str2 = str1.replace(/(\\r\\n|\\n|\\r)/gm, '<br />');
	
	      return str2;
	    }
	  },
	  watch: {
	    'content': function content(newVal, oldVal) {
	      if (newVal && newVal !== oldVal) {
	        this.formatDesc(this.lineNum);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.appapi = _appapi2.default;
	    this.terminalFlag = _appapi2.default.checkTerminal();
	    this.$nextTick(function () {
	      _this.formatDesc(_this.lineNum);
	    });
	  },
	
	  methods: {
	    formatDesc: function formatDesc(lineNum) {
	      this.$nextTick(function () {
	        console.log("计算高度");
	        var n = lineNum;
	        var conEl = this.$refs.con;
	        if (!conEl) return;
	        var finalStyle = conEl.currentStyle ? conEl.currentStyle : window.getComputedStyle(conEl, null);
	
	        if (parseInt(finalStyle.height) > parseInt(finalStyle.lineHeight) * n) {
	          this.isNeedUnfold = true;
	        }
	      });
	    },
	    unfold: function unfold() {
	      this.isHideFlag = !this.isHideFlag;
	      this.unfoldText = this.unfoldText === '展开' ? '收起' : '展开';
	    }
	  }
	};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(466);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _style = __webpack_require__(159);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _spinner = __webpack_require__(161);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _stringify = __webpack_require__(75);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _style3 = __webpack_require__(37);
	
	var _style4 = _interopRequireDefault(_style3);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _components;
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _tab = __webpack_require__(785);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _tabs = __webpack_require__(789);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _pullRefresh = __webpack_require__(782);
	
	var _pullRefresh2 = _interopRequireDefault(_pullRefresh);
	
	__webpack_require__(786);
	
	__webpack_require__(790);
	
	__webpack_require__(783);
	
	var _weChatShare = __webpack_require__(39);
	
	var _weChatShare2 = _interopRequireDefault(_weChatShare);
	
	var _pageCommon = __webpack_require__(45);
	
	var _pageCommon2 = _interopRequireDefault(_pageCommon);
	
	var _project = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Hours',
	  data: function data() {
	    return {
	      blocks: [],
	      active: 0,
	      count: 0,
	      loading: false,
	      isAll: false,
	      isLoading: false,
	      isSharePage: false,
	      data1: {
	        item: [{
	          page: {
	            last: 2
	          }
	        }]
	      },
	      next: 1,
	      pageToken: '',
	      nav: [],
	      dataList_: {
	        item: {
	          page: {
	            last: 2
	          }
	        }
	      },
	      dataList: [],
	      noData: null,
	      noData_: null,
	      data_: [],
	      title: '国内'
	    };
	  },
	  created: function created() {
	    window.appapi = _appapi2.default;
	    window.$vm = this;
	    this.isSharePage = appapi.isSharePage();
	
	    this.appPostMessage('FullScreen');
	  },
	  mounted: function mounted() {
	    this.getInit();
	    window.addEventListener("scroll", this.handleScroll, true);
	    this.$nextTick(function () {
	      var u = navigator.userAgent;
	      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	      if (isiOS) {
	        try {
	          document.querySelector('.date_').style.fontSize = "0.4rem";
	        } catch (e) {
	          console.log(e);
	        }
	      } else {
	        try {
	          document.querySelector('.date_').style.fontSize = "0.373rem";
	        } catch (e) {
	          console.log(e);
	        }
	      }
	    });
	  },
	
	  methods: {
	    getInit: function getInit() {
	      var _this = this;
	
	      this.loading = true;
	      this.pageToken = this.next * 1;
	      var pageLast = this.data1.item[0].page.last * 1;
	
	      if (this.pageToken > pageLast) {
	        this.loading = false;
	        this.isAll = true;
	        return false;
	      }
	      this.$axios.get(_project.intfc_prefix_common + '/api/v2/articles/hot24ArticleList?pageToken=' + this.pageToken).then(function (res) {
	        var result = res.item;
	        console.log(res, 'resresresres-----');
	        if (res.code === 0) {
	          _this.loading = false;
	          _this.data1 = res;
	          _this.noData_ = result.count;
	          var navList = result;
	          if (_this.next == 1 && _this.title == '国内') {
	            navList.map(function (v) {
	              if (v.categoryInfo.name == "国际" || v.categoryInfo.name == "本地") {
	                _this.nav.push({
	                  name: v.categoryInfo.name,
	                  id: v.categoryInfo.id
	                });
	              }
	            });
	          }
	          if (_this.data1.item && _this.data1.item.length > 0) {
	            _this.data_ = _this.data_.concat(_this.data1.item);
	            _this.next++;
	          }
	
	          (0, _weChatShare2.default)({
	            title: result.title
	          }, _this);
	        } else {
	          (0, _toast2.default)(res.msg);
	          _this.loading = false;
	        }
	      });
	    },
	    get24Init: function get24Init(id) {
	      var _this2 = this;
	
	      this.loading = true;
	      this.pageToken = this.next * 1;
	
	      var pageLast = this.dataList_.item.page.last * 1;
	
	      if (this.pageToken > pageLast) {
	        this.loading = false;
	        this.isAll = true;
	        return false;
	      }
	      this.$axios.get(_project.intfc_prefix_common + '/api/v2/articles/hot24ArticleList/' + id + '?pageToken=' + this.pageToken).then(function (res) {
	        var result = res.item;
	        if (res.code === 0) {
	          _this2.loading = false;
	          _this2.dataList_ = res;
	          _this2.noData = result.count;
	          _this2.dataList = res.item;
	
	          try {
	            if (Array.isArray(_this2.dataList)) {
	              _this2.dataList = _this2.dataList.concat(_this2.dataList_.item);
	              _this2.next++;
	            } else {
	              for (var i in _this2.dataList_.item.list) {
	                _this2.dataList.list[i] = _this2.dataList_.item.list[i];
	              }
	
	              _this2.next++;
	            }
	          } catch (error) {
	            console.log(error);
	          }
	
	          (0, _weChatShare2.default)({
	            title: result.title
	          }, _this2);
	        } else {
	          (0, _toast2.default)(res.msg);
	          _this2.loading = false;
	        }
	      });
	    },
	    changeID: function changeID(name, title) {
	      var _this3 = this;
	
	      this.next = 1;
	
	      this.nav.map(function (v) {
	        if (v.name == title) {
	          _this3.title = title;
	          return _this3.get24Init(v.id);
	        }
	      });
	    },
	
	    getDate: function getDate(date) {
	      return date.slice(0, -2) + ':00';
	    },
	
	    getTime: function getTime(time) {
	      var result = '';
	      if (time) {
	        result = time.substring(11, 16);
	      }
	      return result;
	    },
	    getCount: function getCount(count) {
	      var result = 0;
	      if (count > 0) {
	        result = count;
	        if (count > 999999) {
	          result = count.substring(0, count.length - 4) + '万';
	          if (count > 99999999) {
	            result = '过亿';
	          }
	        }
	      }
	      return result;
	    },
	    goPath: function goPath(article) {
	      if (!this.isSharePage) {
	        var articleId = article.articleId,
	            type = article.type,
	            sysCode = article.sysCode;
	
	        var obj = {
	          articleId: articleId,
	          type: type,
	          sysCode: sysCode
	        };
	        window.appapi.appPostMessage("goNewsDetail", (0, _stringify2.default)(obj));
	      } else {
	        window.location.href = article.shareUrl;
	      }
	    },
	    loadMore: function loadMore() {
	      var _this4 = this;
	
	      if (this.isAll || this.loading) return false;
	      if (this.title == '国内') {
	        this.getInit();
	      } else {
	        this.nav.map(function (v) {
	          if (v.name == _this4.title) {
	            return _this4.get24Init(v.id);
	          }
	        });
	      }
	    },
	    appPostMessage: function appPostMessage(name) {
	      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      if (name) window.appapi.appPostMessage(name, value);
	    },
	    onRefresh: function onRefresh() {
	      var _this5 = this;
	
	      setTimeout(function () {
	        _this5.isLoading = false;
	        _this5.count++;
	      }, 1000);
	    },
	    loadImg: function loadImg(e) {
	      e.target.style.backgroundImage = 'unset';
	    },
	    getLikesCount: function getLikesCount(count) {
	      var result = '';
	      if (count > 0) {
	        result = count;
	        if (count > 999999) {
	          result = count.substring(0, count.length - 4) + '万';
	          if (count > 99999999) {
	            result = '过亿';
	          }
	        }
	      }
	      return result;
	    },
	    handleScroll: function handleScroll(e) {
	      var top_ = document.querySelector(".van-tabs__wrap");
	      var imgs_ = document.querySelector(".bg_header_img");
	      var scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
	
	      if (imgs_) {
	        var topH = this.$refs.imgHight.offsetHeight;
	        var zHight = topH;
	
	
	        if (this.isSharePage) {
	          if (scrollTop > zHight) {
	            top_.style.position = 'fixed';
	            top_.style.zIndex = '9';
	            top_.style.top = '0';
	            top_.style.clear = 'both';
	            top_.style.overflow = 'hidden';
	            top_.style._top = 'expression(eval(document.documentElement.scrollTop))';
	          } else {
	            top_.style.position = 'relative';
	          }
	        } else {
	          if (scrollTop > topH) {
	            top_.style.position = 'fixed';
	            top_.style.zIndex = '99999';
	            top_.style.top = '0';
	            top_.style.clear = 'both';
	            top_.style.overflow = 'hidden';
	          } else {
	            top_.style.position = 'relative';
	          }
	        }
	      }
	    }
	  },
	  destroyed: function destroyed() {
	    window.removeEventListener('scroll', this.handleScroll, true);
	  },
	
	  components: (_components = {
	    PageCommon: _pageCommon2.default
	  }, (0, _defineProperty3.default)(_components, _tab2.default.name, _tab2.default), (0, _defineProperty3.default)(_components, _tabs2.default.name, _tabs2.default), (0, _defineProperty3.default)(_components, _pullRefresh2.default.name, _pullRefresh2.default), (0, _defineProperty3.default)(_components, 'spinner', _spinner2.default), _components)
	};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(53);
	
	var _pageCommon = __webpack_require__(45);
	
	var _pageCommon2 = _interopRequireDefault(_pageCommon);
	
	var _userAvatar = __webpack_require__(833);
	
	var _userAvatar2 = _interopRequireDefault(_userAvatar);
	
	var _commentNormal = __webpack_require__(115);
	
	var _commentNormal2 = _interopRequireDefault(_commentNormal);
	
	__webpack_require__(714);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var statusMap = {
		'0': '待审核',
		'1': '审核通过',
		'2': '办理中',
		'3': '已回复',
		'4': '审核未通过'
	};
	
	exports.default = {
		components: {
			PageCommon: _pageCommon2.default,
			UserAvatar: _userAvatar2.default,
			CommentNormal: _commentNormal2.default
		},
		filters: {
			path: function path(item) {
				return '#/ask/detail/' + item.question_id;
			}
		},
		computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
			detail: 'ask:detail:detail',
			related: 'ask:detail:related',
			comments: 'ask:detail:comments',
			hasComments: 'ask:detail:hasComments'
		}), {
			showDomain: function showDomain() {
				return !Jt.string.isEmpty(this.detail.domain);
			},
			fQ: function fQ() {
				return this.detail.question || {};
			},
			fA: function fA() {
				return this.detail.answer || {};
			},
			sQ: function sQ() {
				return this.detail.sec_question || {};
			},
			sA: function sA() {
				return this.detail.sec_answer || {};
			},
			showFA: function showFA() {
				var fA = this.fA;
				return !Jt.object.isEmpty(fA) && !Jt.string.isEmpty(fA.content);
			},
			showSQ: function showSQ() {
				var sQ = this.sQ;
				return !Jt.object.isEmpty(sQ) && !Jt.string.isEmpty(sQ.content);
			},
			showSA: function showSA() {
				var sA = this.sA;
				return !Jt.object.isEmpty(sA) && !Jt.string.isEmpty(sA.content);
			},
			statusCode: function statusCode() {
				return this.detail.status + '';
			},
			statusText: function statusText() {
				var code = this.statusCode;
				return statusMap[code];
			},
			showStatus: function showStatus() {
				var code = this.statusCode;
				var codes = ['0', '1', '2', '4'];
				if (codes.indexOf(code) === -1) {
					return false;
				}
				return true;
			},
			showRelated: function showRelated() {
				return !Jt.array.isEmpty(this.related);
			}
		}),
		watch: {
			'$route': function $route() {
				this.init(this.$route.params.id);
			}
		},
		created: function created() {
			this.init(this.$route.params.id);
		},
	
		methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
			init: 'ask:detail:init'
		}))
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(53);
	
	var _device = __webpack_require__(82);
	
	var device = _interopRequireWildcard(_device);
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _pageCommon = __webpack_require__(45);
	
	var _pageCommon2 = _interopRequireDefault(_pageCommon);
	
	var _commentNormal = __webpack_require__(115);
	
	var _commentNormal2 = _interopRequireDefault(_commentNormal);
	
	__webpack_require__(715);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default],
		components: {
			PageCommon: _pageCommon2.default,
			CommentNormal: _commentNormal2.default
		},
		computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
			detail: 'ask:topic:detail',
			related: 'ask:topic:related',
			comments: 'ask:topic:comments',
			hasComments: 'ask:topic:hasComments'
		}), {
			focusImgH: function focusImgH() {
				return 130 * device.width / 320 + 'px';
			},
			showRelated: function showRelated() {
				return !Jt.array.isEmpty(this.related);
			}
		}),
		created: function created() {
			this.init(this.$route.params.id);
		},
	
		methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
			init: 'ask:topic:init'
		}))
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt, $) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(53);
	
	var _project = __webpack_require__(13);
	
	var _device = __webpack_require__(82);
	
	var _weChatShare = __webpack_require__(39);
	
	var _weChatShare2 = _interopRequireDefault(_weChatShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isMlinked = false;
	exports.default = {
	    props: {
	        type: String,
	        showAppTopLink: {
	            type: Boolean,
	            default: true
	        },
	        showAppBotLink: {
	            type: Boolean,
	            default: true
	        },
	        hasComments: {
	            type: Boolean,
	            default: false
	        },
	        detail: {
	            type: Object,
	            default: function _default() {
	                return {};
	            }
	        },
	        autoOpenApp: {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	        appW: 'app:width'
	    }), {
	        pageCls: function pageCls() {
	            var cls = ['p-common'];
	            if (!Jt.string.isEmpty(this.type)) {
	                cls.push('p-' + this.type);
	            }
	            return cls;
	        },
	        appBotLinkText: function appBotLinkText() {
	            if (this.hasComments) {
	                return _project.app_bot_link_text['hasComments'];
	            }
	            return _project.app_bot_link_text['noComments'];
	        },
	        isIos: function isIos() {
	            if (_device.isIos) {
	                return true;
	            }
	            return false;
	        }
	    }),
	    watch: {
	        detail: function detail(newVal, oldVal) {
	            if (!Jt.object.isEmpty(newVal)) {
	                this.setShareData(newVal);
	                var data = newVal;
	                if (!isMlinked && this.showAppTopLink) {
	                    try {
	                        new JMLink([{
	                            jmlink: 'https://bciq41.jglinks.cn/Aan7',
	                            button: document.querySelectorAll('a.openApp'),
	                            autoLaunchApp: false,
	                            autoRedirectToDownloadUrl: true,
	                            downloadWhenUniversalLinkFailed: false,
	                            inapp: false,
	                            params: {
	                                articleId: data.id,
	                                categoryId: data.categoryId,
	                                sysCode: data.sysCode || "",
	                                type: data.type || "",
	                                link: data.link || ""
	                            }
	                        }]);
	                    } catch (error) {
	                        console.log('mlink:', error);
	                    }
	                    isMlinked = true;
	                }
	            }
	        }
	    },
	    data: function data() {
	        return {
	            'show_guid': false
	        };
	    },
	
	    methods: {
	        toggleGuid: function toggleGuid() {
	            this.show_guid = !this.show_guid;
	            this.$nextTick(function () {
	                if (this.show_guid) {
	                    Jt.browser.stopBodyScroll();
	                } else {
	                    Jt.browser.startBodyScroll();
	                }
	            });
	        },
	        setShareData: function setShareData(data) {
	
	            $("head").append('<meta name="description" itemprop="description" content="天下景观在锦观" />');
	            $("head").append('<meta itemprop="image" content="http://rmrbpre.img-cn-beijing.aliyuncs.com/cdrb2/dir2/20190513/cdrb_2_201503133341dc-40bd-4efb-85f2-ae81b3c86ccc.png" />');
	
	            if (data.title) {
	                document.title = data.title;
	                $(document).attr("title", data.title);
	                $("head").append('<meta itemprop="name" content=' + data.title + ' />');
	            }
	        }
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(44)))

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(75);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _style = __webpack_require__(37);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _from = __webpack_require__(118);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _style3 = __webpack_require__(229);
	
	var _style4 = _interopRequireDefault(_style3);
	
	var _lazyload = __webpack_require__(230);
	
	var _lazyload2 = _interopRequireDefault(_lazyload);
	
	var _vue = __webpack_require__(24);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _pageCommon = __webpack_require__(45);
	
	var _pageCommon2 = _interopRequireDefault(_pageCommon);
	
	var _pageVote = __webpack_require__(387);
	
	var _pageVote2 = _interopRequireDefault(_pageVote);
	
	var _project = __webpack_require__(13);
	
	var _icon_user_default_avatar = __webpack_require__(163);
	
	var _icon_user_default_avatar2 = _interopRequireDefault(_icon_user_default_avatar);
	
	var _comList = __webpack_require__(804);
	
	var _comList2 = _interopRequireDefault(_comList);
	
	var _comAudioBar = __webpack_require__(803);
	
	var _comAudioBar2 = _interopRequireDefault(_comAudioBar);
	
	var _weChatShare = __webpack_require__(39);
	
	var _weChatShare2 = _interopRequireDefault(_weChatShare);
	
	var _swiper = __webpack_require__(367);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _uuid = __webpack_require__(775);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_lazyload2.default);
	exports.default = {
	    data: function data() {
	        return {
	            icon: _icon_user_default_avatar2.default,
	            isSharePage: false,
	            el: null,
	            data: {},
	            type: '',
	            videoUrl: '',
	            audioUrl: '',
	            imageUrl: '',
	            isVoice: false,
	            content: '',
	            poster: '',
	            date: '',
	            fontSizeNum: 3,
	            source: '',
	            urls: [],
	            comments: null,
	            mockLikes: [],
	            images: [],
	            saveVideo: null,
	            picFlag: true,
	            openVideoMask: false,
	            relvantNewsData: [],
	            isFollow: null,
	            totalTimes: "",
	            isPreviewPage: false,
	            newImages: [],
	            showLargeImage: false,
	            showLargeIndex: 0,
	            mySwiper: '',
	            slideTo: '',
	            vodeOption: {},
	            isShowDialog: false,
	            dialogParams: {},
	            uuids: 0,
	            likes: 0,
	            isLike: false
	        };
	    },
	    created: function created() {
	        window.appapi = _appapi2.default;
	        window.$vm = this;
	
	        appapi.changeFontSize(this.$route.query.fontsize);
	        this.isPreviewPage = appapi.isPreviewPage();
	
	        if (this.$route.params.type === 'paper') {
	            this.initPaper(this.$route.params.id);
	        } else if (this.$route.params.type === 'normal') {
	            this.initNormal(this.$route.params.id);
	        } else if (this.$route.params.type === 'gov') {
	            this.initGov(this.$route.params.id);
	        }
	
	        this.isSharePage = appapi.isSharePage();
	
	        this.uuids = localStorage.getItem('uuid');
	        if (!this.uuids) {
	            localStorage.setItem('uuid', (0, _uuid.v4)());
	        }
	
	        console.log(this.uuids, '初次uuids');
	    },
	    mounted: function mounted() {
	        this.move();
	    },
	    updated: function updated() {
	        var imgs = $('.content img');
	        this.images = (0, _from2.default)(imgs);
	        this.$nextTick(function () {
	            this.mySwiper = new _swiper2.default(".largeSwiper .swiper-container", {
	                pagination: {
	                    el: '.swiper-pagination',
	                    clickable: true,
	                    type: 'fraction'
	                },
	
	                initialSlide: this.showLargeIndex,
	                speed: 500,
	                zoom: true,
	                loop: this.newImages.length > 1 ? true : false,
	                autoHeight: true,
	                autoplayDisableOnInteraction: false,
	                paginationCustomRender: function paginationCustomRender(swiper, current, total) {
	                    return current + " / " + total;
	                }
	            });
	        });
	    },
	    beforeDestroy: function beforeDestroy() {},
	
	
	    watch: {
	        '$route': function $route(to, from) {
	            if (to.params.id != from.params.id) {
	                if (this.$route.params.type === 'paper') {
	                    this.initPaper(this.$route.params.id);
	                } else if (this.$route.params.type === 'normal') {
	                    this.initNormal(this.$route.params.id);
	                } else if (this.$route.params.type === 'gov') {
	                    this.initGov(this.$route.params.id);
	                }
	            }
	        },
	
	        data: {
	            handler: function handler(val) {
	
	                if (this.isSharePage) {
	                    var imgUrl = val.images ? val.images[0] : '';
	                    var cover = val.cover || '';
	                    (0, _weChatShare2.default)({
	                        title: val.title
	                    }, this);
	                }
	
	                this.pageUpdate();
	            },
	
	            deep: true
	        },
	        el: {
	            handler: function handler(val, oldVal) {
	                if (oldVal) {
	                    var father = $(oldVal).parent();
	                    father.css('position', 'relative');
	                    $(oldVal).css('position', 'absolute').css('z-index', 1);
	                }
	            },
	
	            deep: true
	        },
	        comments: {
	            handler: function handler() {},
	
	            deep: true
	        }
	    },
	
	    methods: {
	        closeLargeImage: function closeLargeImage() {
	
	            this.showLargeImage = false;
	        },
	        readPaper: function readPaper() {
	            this.pauseAllVideo();
	            this.appPostMessage('voiceRead');
	        },
	        setFollow: function setFollow() {
	            if (!this.isFollow) {
	                this.appPostMessage('sub');
	            } else {
	                this.goGov();
	            }
	        },
	        goGov: function goGov() {
	            if (this.isSharePage) {
	                if (this.data.orgInfo.type == '1') {
	                    this.$router.push({ name: 'Local', params: { id: this.data.orgInfo.id } });
	                }
	            } else {
	                this.appPostMessage('goGovDetail');
	            }
	        },
	        move: function move() {
	            window.onload = window.onscroll = function () {};
	        },
	        initGov: function initGov(id) {
	            var _this2 = this;
	
	            this.$axios.get(_project.govUrl + '/api/v2/articles/info/' + id).then(function (res) {
	                var result = res.data;
	                if (res.code === 0) {
	                    _this2.likes = result.likes;
	
	                    if (result.delFlag === '1' || result.delFlag === '3') {
	                        (0, _toast2.default)("请求文章不存在或已下线");
	                        return;
	                    }
	                    if (result.type === "link") {
	                        window.location.href = result.link;
	                        return false;
	                    } else if (result.type === "image") {
	                        _this2.articleType = "image";
	                        _this2.data = result;
	                        _this2.data.medias = result.mediaList;
	                        var obj = _this2.data.medias[0];
	                        _this2.swipeDescription = obj.description || "";
	                        _this2.data.content = "";
	                        return false;
	                    } else {
	                        _this2.data = result;
	                        var reg = new RegExp(/line-height:\s.*?[\d]*/g);
	                        _this2.data.content = _this2.data.content ? _this2.data.content.replace(reg, "line-height: ''") : "";
	                        var textreg = new RegExp(/text-indent:\s.*?(\d{2}pt)/g);
	                        _this2.data.content = _this2.data.content ? _this2.data.content.replace(textreg, "text-indent:2em") : "";
	
	                        _this2.imageUrl = result.images ? result.images[0] : "";
	
	                        _this2.isVoice = result.isVoice ? result.isVoice : false;
	                        _this2.source = result.copyfrom;
	                        _this2.date = result.date.substring(0, 10) + ' ' + result.date.substring(11, 16);
	
	                        if (result.type === "video") {
	                            _this2.poster = result.image;
	                            _this2.videoUrl = result.mediaList[0].image;
	                        }
	                        if (result.type === "audio") {
	                            _this2.poster = result.image;
	                            _this2.audioUrl = result.mediaList[0].image + '?_t=' + Date.parse(new Date());
	                            _this2.totalTimes = result.mediaList[0].times;
	                        }
	                    }
	                    _this2.getHotList(result.categoryId, result.articleId);
	                    _this2.getComment(result.sysCode, id);
	
	                    _this2.appPostMessage('renderFinish');
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        },
	        initPaper: function initPaper(id) {
	            var _this3 = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/paper/detail?articleId=' + id + '&platform=' + appapi.checkTerminal()).then(function (res) {
	                var result = res.item;
	                if (res.code === 0) {
	                    _this3.data = result;
	                    _this3.likes = result.likes;
	                    _this3.source = result.copyfrom;
	                    _this3.date = result.newsDatetime;
	                    if (result.imgall && result.imgall.length > 0) {
	                        result.imgall.map(function (item, index) {
	                            _this3.urls.push(item.imgUrl);
	                        });
	                    }
	
	                    _this3.appPostMessage('renderFinish');
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        },
	        initNormal: function initNormal(id) {
	            var _this4 = this;
	
	            var query = this.$route.query;
	            var isTimeLimit = query.isTimeLimit;
	            var articleUrl = _project.intfc_prefix_common + '/api/v2/articles/detail/';
	            if (!!isTimeLimit) {
	                articleUrl = _project.intfc_prefix_common + '/api/v2/articles/detailPreview/';
	            }
	
	            this.$axios.get('' + articleUrl + id).then(function (res) {
	                var result = res.item;
	                if (res.code === 0) {
	                    _this4.likes = result.likes;
	
	                    if (result.type === 'link') {
	                        window.location.href = result.link;
	                        return false;
	                    }
	
	                    _this4.data = result;
	
	                    _this4.imageUrl = result.images ? result.images[0] : '';
	                    _this4.isVoice = result.isVoice ? result.isVoice : false;
	                    _this4.source = result.source;
	                    _this4.date = result.date.substring(0, 10) + ' ' + result.date.substring(11, 16);
	                    if (result.type === 'video') {
	                        result.medias.map(function (item) {
	                            if (item.type === 'video') {
	                                _this4.poster = item.image;
	                            }
	                            item.resources.map(function (opt) {
	                                if (opt.enctype === 'ld') {
	                                    _this4.videoUrl = opt.url;
	                                }
	                            });
	                        });
	                    }
	
	                    if (result.type === 'audio') {
	                        result.medias.map(function (item) {
	                            item.resources.map(function (opt, i) {
	                                if (i === 0) {
	                                    _this4.audioUrl = opt.url;
	                                }
	                            });
	                        });
	                        _this4.totalTimes = result.medias[0].times;
	                    }
	                    _this4.getHotList(result.categoryId, result.articleId);
	                    if (_this4.$route.params.type === 'normal') {
	                        _this4.getComment(result.sysCode, id);
	                    }
	
	                    _this4.appPostMessage('renderFinish');
	                } else {
	                    (0, _toast2.default)(res.msg);
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        },
	        pageUpdate: function pageUpdate() {
	            var _this5 = this;
	
	            this.$nextTick(function () {
	                _this5.setContentCSS();
	                _this5.setVideoBtn();
	                _this5.setVideoFun();
	                _this5.setPaperImg();
	            });
	        },
	        getVote: function getVote(voteId) {
	            var _this6 = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/vote/getVoteInfo/32').then(function (res) {
	                if (res.code == 0) {
	                    _this6.vodeOption = res.item;
	                }
	            });
	        },
	        getHotList: function getHotList(categoryId, excludeId) {
	            var _this7 = this;
	
	            var hotListUrl = "";
	            if (this.$route.params.type === 'normal') {
	                hotListUrl = _project.intfc_prefix_common + '/api/v2/articles/hot/list?categoryId=' + categoryId + '&excludeId=' + excludeId;
	            } else if (this.$route.params.type === 'gov') {
	                hotListUrl = _project.govUrl + '/api/v2/articles/hot/list?categoryId=' + categoryId + '&excludeId=' + excludeId;
	            }
	            this.$axios.get(hotListUrl).then(function (res) {
	                var result = res.item || res.data;
	                if (res.code === 0) {
	                    if (result) {
	                        _this7.relvantNewsData = result.map(function (i) {
	                            var imgArray = i.imageUrl || i.image;
	                            if (imgArray) {
	                                if (imgArray.indexOf(",") != -1) {
	                                    i.imageUrl = imgArray.split(",");
	                                } else {
	                                    i.imageUrl = [imgArray];
	                                }
	                            }
	                            return i;
	                        });
	                    }
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        },
	        getComment: function getComment(sysCode, articleId) {
	            var _this8 = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/comments/' + sysCode + '/' + articleId + '?size=5').then(function (res) {
	                var result = res.items;
	                if (res.code === 0) {
	                    console.log('comments:', result);
	                    if (result) {
	                        _this8.comments = result;
	                        _this8.comments.map(function (item) {
	                            item.isLike = false;
	                        });
	
	                        _this8.handleLikes(_this8.mockLikes);
	                    } else {
	                        _this8.comments = [];
	                    }
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        },
	        uuid: function uuid() {
	            var _this9 = this;
	
	            this.$axios.post(_project.intfc_prefix_common + '/api/v2/articles/likeArticleOrNot?articleId=' + this.$route.params.id + '&likeOrNot=1').then(function (res) {
	                _this9.$forceUpdate();
	                if (res.code === 0) {
	                    if (_this9.isSharePage) {
	                        console.log(_this9.uuids, 'this.uuids');
	                        if (_this9.uuids) {
	                            _this9.likes = res.item;
	                            _this9.isLike = true;
	                        } else {
	                            (0, _toast2.default)('请登录后再点赞');
	                        }
	                    }
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        },
	        setContentCSS: function setContentCSS() {
	            var _this10 = this;
	
	            var img = $('.content img');
	            var video = $('.content video');
	            var p = $('.content p,.content ul,.content ol,.content h1,.content h2,.content h3,.content h4,.content h5,.content h6,.content blockquote');
	            var a = $('.content a');
	            var imgParent = img.parent();
	            var videoParent = video.parent();
	
	            var images = (0, _from2.default)(img);
	
	            if (images && images.length > 0) {
	                images.map(function (item, index) {
	
	                    var img = $(item);
	                    var imgUrl = img.attr('src');
	                    _this10.newImages[index] = img.attr('src');
	
	                    _this10.setImageFun(img, index);
	
	                    img.attr("src", imgUrl);
	
	                    if (!img.attr('data-src')) {
	                        _this10.urls.push(img.attr('src'));
	                        img.attr('data-src', imgUrl);
	                    }
	                });
	            }
	            img.css('width', '100%').css('height', 'auto').css('display', 'block').css('margin', '0 auto').attr('onerror', __webpack_require__(771));
	
	            video.css('width', '100%').css('height', '5.76rem').css('display', 'block').css('position', 'absolute').css('top', 0).css('z-index', 1).css('object-fit', '').attr('controlsList', 'nodownload');
	            p.css('margin', '1em 0').css('padding', '0 .4rem').css('font-size', '').css('line-height', '').css('font-family', '').css('overflow', 'hidden');
	            a.css('font-size', '');
	
	            $(videoParent).attr('style', '');
	            $(videoParent).children('.content-button').remove();
	            if ($(videoParent).children('video').attr('flag') != '1') {
	                $(videoParent).attr('style', '').css('margin', '1.33rem .4rem').css('height', '5.76rem').css('position', 'relative').css('background', '#000').append('<button class="content-button"></button>');
	            }
	        },
	        setVideoBtn: function setVideoBtn() {
	            var _this = this;
	            $('button').click(function () {
	                if (!navigator.onLine) {
	                    (0, _toast2.default)({
	                        message: '网络连接失败，请稍后再试',
	                        position: 'bottom'
	                    });
	                } else {
	                    var video = $(this).prev();
	
	                    video[0].play();
	                }
	            });
	        },
	        setVideoFun: function setVideoFun() {
	            var _this = this;
	            var md = $(".content video");
	            var topVideo = $(".video-wrap video");
	            var arg = (0, _from2.default)(md);
	            arg.map(function (item, index) {
	                item.addEventListener("pause", function () {
	                    setTimeout(function () {
	
	                        if (item.paused) {
	                            var father = $(item).parent();
	                            father.css('position', 'relative');
	                            $(item).css('position', 'absolute').css('z-index', 1);
	
	                            if (_this.el === item) _this.el = null;
	                        }
	                    }, 100);
	                });
	
	                item.addEventListener("ended", function () {
	                    setTimeout(function () {
	                        if (item.ended) {
	                            var father = $(item).parent();
	                            father.css('position', 'relative').append('<button class="content-button"></button>');
	
	                            if ($(item).attr('poster')) {
	                                father.append('<img class="poster" src="' + $(item).attr('poster') + '" />');
	                            }
	
	                            $(item).css('position', 'absolute').css('z-index', 1).removeAttr('controls');
	                            $(father.children('.content-button')).click(function () {
	                                var video = $(this).prev();
	                                video[0].play();
	                            });
	
	                            if (_this.el === item) _this.el = null;
	                        }
	                    }, 100);
	                });
	
	                item.addEventListener("playing", function () {
	
	                    var obj = (0, _stringify2.default)({
	                        width: $(item).attr('data-width'),
	                        height: $(item).attr('data-height')
	                    });
	                    console.log(obj, 'obj');
	                    _this.appPostMessage('toVideoSize', (0, _stringify2.default)({
	                        width: $(item).attr('data-width'),
	                        height: $(item).attr('data-height')
	                    }));
	                    _this.pauseVideo(item);
	
	                    _this.appPostMessage('pauseAudio');
	                    var btn = $(item).next();
	                    btn.remove();
	                    var videoParent = $(item).parent();
	                    $(videoParent).children('.poster').remove();
	                    $(item).attr('controls', 'controls');
	
	                    _this.el = item;
	
	                    _this.saveVideo = item;
	                    _this.appPostMessage('getNetState');
	                });
	
	                var videoInfo = _this.data.moreVideos[index];
	                $(item).attr('size', videoInfo.video.size);
	            });
	
	            if (topVideo && topVideo.length > 0) {
	                topVideo[0].addEventListener("pause", function () {});
	
	                topVideo[0].addEventListener("ended", function () {
	
	                    var father = $(this).parent();
	                    father.append('<button class="content-button"></button>');
	                    if ($(this).attr('poster')) {
	                        father.append('<img class="poster" src="' + $(this).attr('poster') + '" />');
	                    }
	                    $(this).removeAttr('controls');
	
	                    $(father.children('.content-button')).click(function () {
	                        var video = $(this).prev();
	                        video[0].play();
	                    });
	                });
	                var topVideoInfo = _this.data.medias[0];
	                var obj = topVideoInfo.resources[0];
	                console.log(obj, 'obj');
	                topVideo.attr('size', obj.size);
	
	                topVideo[0].addEventListener("playing", function () {
	
	                    var objVideo = (0, _stringify2.default)({
	                        width: _this.data.medias[0].resources[0].width,
	                        height: _this.data.medias[0].resources[0].height
	                    });
	                    console.log(objVideo, 'obj');
	                    _this.appPostMessage('toVideoSize', objVideo);
	                    _this.pauseVideo(this);
	                    _this.el = null;
	
	                    _this.appPostMessage('pauseAudio');
	                    var btn = $(this).next();
	                    btn.remove();
	                    var videoParent = $(this).parent();
	                    $(videoParent).children('.poster').remove();
	                    $(this).attr('controls', 'controls');
	
	                    _this.saveVideo = this;
	                    _this.appPostMessage('getNetState');
	                });
	
	                var dpr = window.devicePixelRatio;
	                var u = navigator.userAgent;
	                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	                if (isiOS && !this.isPreviewPage) {
	                    topVideo.css('height', window.screen.width * dpr / 16 * 9 + 'px');
	                    $(".video-wrap").css('height', window.screen.width * dpr / 16 * 9 + 'px');
	                } else if (!this.isPreviewPage) {
	                    topVideo.css('height', window.screen.width / 16 * 9 + 'px');
	                    $(".video-wrap").css('height', window.screen.width / 16 * 9 + 'px');
	                }
	            }
	        },
	        pauseVideo: function pauseVideo(act) {
	            var video = $('video');
	            var videoArr = (0, _from2.default)(video);
	            videoArr.map(function (item, index) {
	                if (!item.paused && act !== item) {
	                    item.pause();
	                }
	            });
	        },
	        setImageFun: function setImageFun(img, index) {
	            var _this11 = this;
	
	            var _this = this;
	
	            img.off("click").on("click", function () {
	                if (_this11.isSharePage) {
	                    _this11.showLargeImage = true;
	                    _this11.showLargeIndex = index;
	                } else {
	                    _this11.showLargeImage = false;
	                    if (_this11.picFlag) {
	                        _this11.picFlag = false;
	                        _this11.pauseAllVideo();
	                        var obj = (0, _stringify2.default)({ position: index, urls: _this.urls });
	                        _this11.appPostMessage('checkBigPic', obj);
	                        setTimeout(function () {
	                            _this11.picFlag = true;
	                        }, 500);
	                    }
	                }
	            });
	        },
	        pauseAllVideo: function pauseAllVideo() {
	            var video = $('video');
	            var videoArr = (0, _from2.default)(video);
	            videoArr.map(function (item, index) {
	                if (!item.paused) {
	                    item.pause();
	                }
	            });
	        },
	        setPaperImg: function setPaperImg() {
	            var _this12 = this;
	
	            var images = (0, _from2.default)($('.images img'));
	            images.map(function (item, index) {
	                console.log(_this12.mySwiper, "setPagerImg");
	                _this12.setImageFun($(item), index);
	            });
	        },
	        lazyLoad: function lazyLoad() {
	            var _this13 = this;
	
	            var height = document.documentElement.clientHeight;
	
	            this.images.map(function (item) {
	                if (item.getBoundingClientRect().top < height) {
	                    if (_this13.CheckImgExists($(item).attr("data-src"))) {
	                        $(item).attr("src", $(item).attr("data-src"));
	                    } else {}
	                }
	            });
	        },
	        appPostMessage: function appPostMessage(name) {
	            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	            if (name) window.appapi.appPostMessage(name, value);
	        },
	        getTime: function getTime(time) {
	            var result = '';
	            if (time) {
	                result = time.substring(0, 10) + ' ' + time.substring(11, 16);
	            }
	            return result;
	        },
	        getLikesCount: function getLikesCount(count) {
	            var result = '';
	            if (count > 0) {
	                var strTel = count.toString();
	                result = count;
	                if (count > 999999) {
	                    result = strTel.substring(0, strTel.length - 4) + '万';
	                    if (count > 99999999) {
	                        result = '过亿';
	                    }
	                }
	            }
	            return result;
	        },
	        handleLikes: function handleLikes(arr) {
	            var _this14 = this;
	
	            if (arr && arr.length > 0) {
	                this.mockLikes = arr;
	                this.mockLikes.map(function (item) {
	                    _this14.$forceUpdate();
	                    _this14.comments.map(function (option) {
	                        if (item === option.id) {
	                            option.isLike = true;
	                        }
	                    });
	                });
	            }
	        },
	        setActiveLike: function setActiveLike(opt) {
	            if (this.isSharePage || !opt.id) return;
	            this.$forceUpdate();
	            if (!opt.isLike) {
	                this.appPostMessage('phraise', (0, _stringify2.default)(opt));
	                this.comments.map(function (option) {
	                    if (opt.id === option.id) {
	                        option.isLike = true;
	                        option.likes += 1;
	                    }
	                });
	            }
	        },
	        addComment: function addComment(item) {
	            if (!item.id) return;
	            this.appPostMessage('comment', (0, _stringify2.default)(item));
	        },
	        CheckImgExists: function CheckImgExists(imgurl) {
	            var ImgObj = new Image();
	            ImgObj.src = imgurl;
	
	            if (ImgObj.fileSize > 0 || ImgObj.width > 0 && ImgObj.height > 0) {
	                return true;
	            } else {
	                return false;
	            }
	        }
	    },
	
	    components: {
	        PageCommon: _pageCommon2.default,
	        List: _comList2.default,
	        audioBar: _comAudioBar2.default,
	        PageVote: _pageVote2.default
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(75);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(24);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _pageCommon = __webpack_require__(45);
	
	var _pageCommon2 = _interopRequireDefault(_pageCommon);
	
	var _project = __webpack_require__(13);
	
	var _weChatShare = __webpack_require__(39);
	
	var _weChatShare2 = _interopRequireDefault(_weChatShare);
	
	var _mine_avatar = __webpack_require__(370);
	
	var _mine_avatar2 = _interopRequireDefault(_mine_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: '',
	    props: {},
	    data: function data() {
	        return {
	            icon: _mine_avatar2.default,
	            data: null,
	            fontSizeNum: 3,
	            isPreviewPage: false,
	            isSharePage: false,
	            comments: null,
	            mockLikes: [] };
	    },
	
	    computed: {},
	    watch: {
	        comments: {
	            handler: function handler() {},
	
	            deep: true
	        }
	    },
	    created: function created() {
	        window.appapi = _appapi2.default;
	        window.$vm = this;
	
	        appapi.changeFontSize(this.$route.query.fontsize);
	        this.isPreviewPage = appapi.isPreviewPage();
	        this.isSharePage = appapi.isSharePage();
	        var govDetailId = this.$route.params.id;
	        this.getInit(govDetailId);
	    },
	    mounted: function mounted() {},
	
	    methods: {
	        summaryReplace: function summaryReplace(str) {
	            return str.replace(/\n/g, "<br/>");
	        },
	        handleShare: function handleShare(taget) {
	            this.appPostMessage('doShare', taget);
	        },
	        getInit: function getInit(govDetailId) {
	            var _this = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/threads/getThreadsById/' + govDetailId).then(function (res) {
	                if (res.code == 0) {
	                    _this.data = res.item;
	                    _this.getComment(_this.data.sysCode, govDetailId);
	                    _this.appPostMessage('renderFinish', '');
	                    (0, _weChatShare2.default)({
	                        title: _this.data.subject,
	                        imgUrl: _this.data.shareImage || ''
	                    }, _this);
	                }
	            });
	        },
	        getComment: function getComment(sysCode, articleId) {
	            var _this2 = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/comments/' + sysCode + '/' + articleId + '?size=5').then(function (res) {
	                var result = res.items;
	                if (res.code === 0) {
	                    console.log(_this2.comments !== null && _this2.comments.length > 0);
	                    if (result) {
	                        _this2.comments = result;
	                        _this2.comments.map(function (item) {
	                            item.isLike = false;
	                        });
	                        _this2.handleLikes(_this2.mockLikes);
	                    } else {
	                        _this2.comments = [];
	                    }
	                }
	            }).catch(function (e) {
	                console.log(e);
	            });
	        },
	        handleLikes: function handleLikes(arr) {
	            var _this3 = this;
	
	            console.log(arr, 'arr');
	            if (arr && arr.length > 0) {
	                this.mockLikes = arr;
	                this.mockLikes.map(function (item) {
	                    _this3.$forceUpdate();
	                    _this3.comments.map(function (option) {
	                        console.log(item, option.id, 'dfdfd');
	                        if (item === option.id) {
	                            option.isLike = true;
	                        }
	                    });
	                });
	            }
	        },
	        addComment: function addComment(item) {
	            if (!item.id) return;
	            this.appPostMessage('comment', (0, _stringify2.default)(item));
	        },
	        setActiveLike: function setActiveLike(opt) {
	            if (this.isSharePage || !opt.id) return;
	            this.$forceUpdate();
	            if (!opt.isLike) {
	                this.appPostMessage('phraise', (0, _stringify2.default)(opt));
	                this.comments.map(function (option) {
	                    if (opt.id === option.id) {
	                        option.isLike = true;
	                        option.likes += 1;
	                    }
	                });
	            }
	        },
	        getLikesCount: function getLikesCount(count) {
	            var result = '';
	            if (count > 0) {
	                result = count;
	                if (count > 999999) {
	                    result = count.substring(0, count.length - 4) + '万';
	                    if (count > 99999999) {
	                        result = '过亿';
	                    }
	                }
	            }
	            return result;
	        },
	        getTime: function getTime(time) {
	            var result = '';
	            if (time) {
	                result = time.substring(0, 10) + ' ' + time.substring(11, 16);
	            }
	            return result;
	        },
	        bigImage: function bigImage(type, imageUrl) {
	            if (this.isSharePage) {
	                $('a#openApp')[0].click();
	            }
	            var urls = [];
	            var videoUrl = '';
	            this.data.attachmentList.forEach(function (item) {
	                if (item.type == 'image') {
	                    urls.push(item.url);
	                } else if (item.type == 'video') {
	                    videoUrl = item.url;
	                }
	            });
	            console.log(urls, videoUrl);
	            if (type == 'image') {
	                var index = urls.indexOf(imageUrl);
	                var obj = (0, _stringify2.default)({ position: index, urls: urls });
	                this.appPostMessage('checkBigPic', obj);
	            } else {
	                var _obj = (0, _stringify2.default)({ videoUrl: videoUrl, videoTitle: '' });
	                this.appPostMessage('watchVideo', _obj);
	            }
	        },
	        appPostMessage: function appPostMessage(name) {
	            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	            if (name) window.appapi.appPostMessage(name, value);
	        }
	    },
	    filters: {},
	    components: {
	        PageCommon: _pageCommon2.default
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(53);
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _swiper = __webpack_require__(367);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _pageCommon = __webpack_require__(45);
	
	var _pageCommon2 = _interopRequireDefault(_pageCommon);
	
	var _newsRelated = __webpack_require__(386);
	
	var _newsRelated2 = _interopRequireDefault(_newsRelated);
	
	var _commentNormal = __webpack_require__(115);
	
	var _commentNormal2 = _interopRequireDefault(_commentNormal);
	
	__webpack_require__(722);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _weChatShare = __webpack_require__(39);
	
	var _weChatShare2 = _interopRequireDefault(_weChatShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_image2.default],
	  components: {
	    PageCommon: _pageCommon2.default,
	    NewsRelated: _newsRelated2.default,
	    CommentNormal: _commentNormal2.default
	  },
	  data: function data() {
	    return {
	      isSharePage: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    detail: "normal:detail",
	    comments: "normal:comments",
	    hasComments: "normal:hasComments"
	  })),
	  watch: {
	    $route: function $route() {
	      this.init({
	        sysCode: this.$route.params.sysCode,
	        categoryId: this.$route.params.categoryId,
	        id: this.$route.params.id,
	        isTimeLimit: this.$route.query.isTimeLimit
	      });
	    },
	    detail: {
	      handler: function handler(val) {
	        if (this.isSharePage) {
	          var imgUrl = val.images ? val.images[0] : '';
	          var cover = val.cover || '';
	          (0, _weChatShare2.default)({
	            title: val.title
	          }, this);
	        }
	      },
	
	      deep: true
	    }
	  },
	  created: function created() {
	    this.init({
	      sysCode: this.$route.params.sysCode,
	      categoryId: this.$route.params.categoryId,
	      id: this.$route.params.id,
	      isTimeLimit: this.$route.query.isTimeLimit
	    });
	    window.appapi = _appapi2.default;
	    this.isSharePage = appapi.isSharePage();
	  },
	  updated: function updated() {
	    this.$nextTick(function () {
	      this.swiper = new _swiper2.default(".p-img .swiper-container", {
	        pagination: {
	          el: '.swiper-pagination',
	          clickable: true,
	          type: 'fraction'
	        },
	        speed: 500,
	        loop: true,
	        autoHeight: true,
	        autoplayDisableOnInteraction: false,
	        paginationCustomRender: function paginationCustomRender(swiper, current, total) {
	          return current + " / " + total;
	        }
	      });
	      console.log(this.swiper, 'swiper');
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.swiper.destroy();
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    init: "normal:init"
	  }), {
	    getTime: function getTime(time) {
	      var result = "";
	      if (time) {
	        result = time.substring(0, 10) + " " + time.substring(11, 16);
	      }
	      return result;
	    }
	  })
	};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(47);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _weChatShare = __webpack_require__(39);
	
	var _weChatShare2 = _interopRequireDefault(_weChatShare);
	
	var _project = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      data: {
	        page: {
	          next: 1,
	          last: 99
	        }
	      },
	      office: {},
	      categoryList: [],
	      activeIndex: 0,
	      list: [],
	      categoryId: null
	    };
	  },
	  created: function created() {
	    this.getInit(this.$route.params.id);
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      _this._initScroll();
	    });
	  },
	
	
	  methods: {
	    getInit: function getInit(id) {
	      var _this2 = this;
	
	      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	
	      this.$axios.get(_project.govUrl + "/api/v2/organize/info/" + id).then(function (res) {
	        var result = res.data;
	        if (res.code === 0) {
	          _this2.categoryList = result.categoryList;
	          _this2.office = result;
	
	          var _id = result.categoryList[0].id;
	          if (_id && _id !== "desc") {
	            _this2.categoryId = _id;
	            _this2.getArticles();
	          }
	
	          (0, _weChatShare2.default)({
	            title: _this2.office.name
	          }, _this2);
	        }
	      });
	    },
	    getArticles: function getArticles() {
	      var _this3 = this;
	
	      var pageToken = this.data.page.next * 1;
	      var pageLast = this.data.page.last * 1;
	
	      if (pageToken > pageLast) return false;
	
	      this.$axios.get(_project.govUrl + "/api/v2/articles/list?categoryId=" + this.categoryId + "&size=" + 10 + "&pageToken=" + pageToken).then(function (res) {
	        var result = res.data;
	        if (res.code === 0) {
	          _this3.list = [].concat((0, _toConsumableArray3.default)(_this3.list), (0, _toConsumableArray3.default)(result.records));
	          _this3.data.page.next = result.current + 1;
	          _this3.data.page.last = result.pages;
	        }
	      });
	    },
	    routerPush: function routerPush(item, index) {
	      if (this.activeIndex === index) return false;
	      this.activeIndex = index;
	      this.categoryId = item.id;
	
	      if (item.id === "desc") return false;
	
	      this.data = {
	        page: {
	          next: 1,
	          last: 99
	        }
	      };
	      this.list = [];
	
	      this.getArticles();
	    },
	    getCount: function getCount(count) {
	      var result = 0;
	      if (count > 0) {
	        result = count;
	        if (count > 999999) {
	          result = count.substring(0, count.length - 4) + "万";
	          if (count > 99999999) {
	            result = "过亿";
	          }
	        }
	      }
	      return result;
	    },
	
	
	    getDate: function getDate(date) {
	      return date.slice(0, -2) + ":00";
	    },
	
	    goPath: function goPath(article) {
	      this.$router.push({
	        name: "Detail",
	        params: { type: "gov", id: article.articleId }
	      });
	    },
	    _initScroll: function _initScroll() {
	      this.navScroll = new this.$BScroll(this.$refs.nav, {
	        click: true,
	        scrollY: false,
	        scrollX: true
	      });
	    }
	  }
	};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _style = __webpack_require__(37);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _liveRoom = __webpack_require__(813);
	
	var _liveRoom2 = _interopRequireDefault(_liveRoom);
	
	var _interactive = __webpack_require__(812);
	
	var _interactive2 = _interopRequireDefault(_interactive);
	
	var _weChatShare = __webpack_require__(39);
	
	var _weChatShare2 = _interopRequireDefault(_weChatShare);
	
	var _project = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            data: {},
	            activeIndex: 0,
	            linkList: [{ name: '直播间' }, { name: '网友互动' }],
	            isShowGallary: false,
	            gallaryImg: ''
	        };
	    },
	    created: function created() {
	        var id = this.$route.params.id;
	        this.getInit(id);
	    },
	    mounted: function mounted() {},
	    updated: function updated() {
	        this.audioNewEvent();
	    },
	
	
	    methods: {
	        routerPush: function routerPush(index) {
	            this.activeIndex = index;
	        },
	        getInit: function getInit(articleId) {
	            var _this = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/live/detail/' + articleId).then(function (res) {
	                var result = res.item;
	                if (res.code === 0) {
	                    _this.data = result;
	
	                    var imgUrl = _this.data.imageUrl;
	                    (0, _weChatShare2.default)({
	                        title: _this.data.title
	                    }, _this);
	                } else {
	                    (0, _toast2.default)(res.msg);
	                }
	            });
	        },
	        audioNewEvent: function audioNewEvent() {
	            var audios = document.getElementsByTagName("audio");
	            var videos = document.getElementsByTagName("video");
	
	            function pauseAll() {
	                var self = this;
	                [].forEach.call(audios, function (i) {
	                    i !== self && i.pause();
	                });
	                [].forEach.call(videos, function (i) {
	                    i !== self && i.pause();
	                });
	            }
	
	            [].forEach.call(videos, function (i) {
	                i.addEventListener("play", pauseAll.bind(i));
	            });
	        },
	        handleGallary: function handleGallary(src) {
	            this.isShowGallary = true;
	            this.gallaryImg = src;
	        },
	        closeGallary: function closeGallary() {
	            this.isShowGallary = false;
	            this.gallaryImg = '';
	        }
	    },
	
	    components: {
	        Room: _liveRoom2.default,
	        Interactive: _interactive2.default
	    }
	};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(53);
	
	var _device = __webpack_require__(82);
	
	var device = _interopRequireWildcard(_device);
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _audioBar = __webpack_require__(384);
	
	var _audioBar2 = _interopRequireDefault(_audioBar);
	
	var _pageCommon = __webpack_require__(45);
	
	var _pageCommon2 = _interopRequireDefault(_pageCommon);
	
	var _newsRelated = __webpack_require__(386);
	
	var _newsRelated2 = _interopRequireDefault(_newsRelated);
	
	var _commentNormal = __webpack_require__(115);
	
	var _commentNormal2 = _interopRequireDefault(_commentNormal);
	
	var _newsVotes = __webpack_require__(814);
	
	var _newsVotes2 = _interopRequireDefault(_newsVotes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default],
		components: {
			AudioBar: _audioBar2.default,
			PageCommon: _pageCommon2.default,
			NewsRelated: _newsRelated2.default,
			CommentNormal: _commentNormal2.default,
			NewsVotes: _newsVotes2.default
		},
		data: function data() {
			return {
				openFull: true
			};
		},
	
		computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
			detail: 'normal:detail',
			comments: 'normal:comments',
			hasComments: 'normal:hasComments',
			appW: 'app:width'
		}), {
			content: function content() {
				var vm = this;
				var contentW = this.appW - 20;
				var $content = $('<div>' + this.detail.content + '</div>');
				$content.find('p').has('img').css('textIndent', '0em');
				$content.find('img').each(function () {
					var $img = $(this);
					var realW = $img.attr('width');
					var realH = $img.attr('height');
					if (realW && realW < contentW / 2) {
						$img.css({
							'width': realW + 'px',
							'height': 'auto'
						});
					} else {
						$img.css({
							'width': '100%',
							'height': 'auto'
						});
					}
					$img.attr('src', vm.webp($img.attr('src')));
				});
				return $content.html();
			},
			showMedias: function showMedias() {
				var medias = this.detail.medias;
				if (Jt.array.isEmpty(medias)) {
					return false;
				}
				return true;
			},
			videoH: function videoH() {
				return (this.appW - 20) / 2 + 'px';
			}
		}),
		watch: {
			'$route': function $route() {
				this.init({
					sysCode: this.$route.params.sysCode,
					categoryId: this.$route.params.categoryId,
					id: this.$route.params.id
				});
			},
			'detail': function detail(newVal, oldVal) {
				if (!Jt.object.isEmpty(newVal)) {
					this.$nextTick(function () {
						this.calcContentHeight();
					});
				}
			}
		},
		created: function created() {
			this.init({
				sysCode: this.$route.params.sysCode,
				categoryId: this.$route.params.categoryId,
				id: this.$route.params.id
			});
		},
	
		methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
			init: 'normal:init'
		}), {
			calcContentHeight: function calcContentHeight() {
				var $content = $(this.$el).find('.m-content');
				var deviceH = device.height;
				var contentH = $content.height();
				var tempH = 0,
				    showH = 0,
				    collapse = false;
				if (contentH >= deviceH * 3 && contentH <= deviceH * 4) {
					collapse = true;
					showH = deviceH * 2.5;
				} else if (contentH >= deviceH * 4) {
					collapse = true;
					showH = deviceH * 3.5;
				}
				if (collapse) {
					var $pEls = $content.find('p');
					if ($pEls.length < 2) {
						return;
					}
					$(this.$el).find('.open-full-btn').css('display', 'block');
					this.openFull = false;
					$pEls.each(function () {
						tempH += $(this).height();
						if (tempH >= showH) {
							$(this).addClass('f-dn');
						}
					});
				}
			},
			openFullHandle: function openFullHandle() {
				$(this.$el).find('.open-full-btn').hide();
				$(this.$el).find('.m-content p.f-dn').show();
			}
		})
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44), __webpack_require__(19)))

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(53);
	
	var _device = __webpack_require__(82);
	
	var device = _interopRequireWildcard(_device);
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _audioBar = __webpack_require__(384);
	
	var _audioBar2 = _interopRequireDefault(_audioBar);
	
	var _pageCommon = __webpack_require__(45);
	
	var _pageCommon2 = _interopRequireDefault(_pageCommon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default],
		components: {
			AudioBar: _audioBar2.default,
			PageCommon: _pageCommon2.default
		},
		data: function data() {
			return {
				openFull: true
			};
		},
	
		computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
			detail: 'paper:detail',
			appW: 'app:width'
		}), {
			content: function content() {
				var vm = this;
				var contentW = this.appW - 20;
				var $content = $('<div>' + this.detail.content + '</div>');
				$content.find('p').has('img').css('textIndent', '0em');
				$content.find('img').each(function () {
					var $img = $(this);
					var realW = $img.attr('width');
					var realH = $img.attr('height');
					if (realW && realW < contentW / 2) {
						$img.css({
							'width': realW + 'px',
							'height': 'auto'
						});
					} else {
						$img.css({
							'width': '100%',
							'height': 'auto'
						});
					}
					$img.attr('src', vm.webp($img.attr('src')));
				});
				return $content.html();
			},
			showMedias: function showMedias() {
				var medias = this.detail.medias;
				if (Jt.array.isEmpty(medias)) {
					return false;
				}
				return true;
			},
			videoH: function videoH() {
				return (this.appW - 20) / 2 + 'px';
			}
		}),
		watch: {
			'$route': function $route() {
				this.init({
					sysCode: this.$route.params.sysCode,
					id: this.$route.params.id,
					date: this.$route.params.date
				});
			},
			'detail': function detail(newVal, oldVal) {
				if (!Jt.object.isEmpty(newVal)) {
					this.$nextTick(function () {
						this.calcContentHeight();
					});
				}
			}
		},
		created: function created() {
			console.log(this.$route);
			this.init({
				sysCode: this.$route.params.sysCode,
				id: this.$route.params.id,
				date: this.$route.params.date
			});
		},
	
		methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
			init: 'paper:init'
		}), {
			calcContentHeight: function calcContentHeight() {
				var $content = $(this.$el).find('.m-content');
				var deviceH = device.height;
				var contentH = $content.height();
				var tempH = 0,
				    showH = 0,
				    collapse = false;
				if (contentH >= deviceH * 3 && contentH <= deviceH * 4) {
					collapse = true;
					showH = deviceH * 2.5;
				} else if (contentH >= deviceH * 4) {
					collapse = true;
					showH = deviceH * 3.5;
				}
				if (collapse) {
					var $pEls = $content.find('p');
					if ($pEls.length < 2) {
						return;
					}
					$(this.$el).find('.open-full-btn').css('display', 'block');
					this.openFull = false;
					$pEls.each(function () {
						tempH += $(this).height();
						if (tempH >= showH) {
							$(this).addClass('f-dn');
						}
					});
				}
			},
			openFullHandle: function openFullHandle() {
				$(this.$el).find('.open-full-btn').hide();
				$(this.$el).find('.m-content p.f-dn').show();
			}
		})
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44), __webpack_require__(19)))

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _weChatShare = __webpack_require__(39);
	
	var _weChatShare2 = _interopRequireDefault(_weChatShare);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _pageCommon = __webpack_require__(45);
	
	var _pageCommon2 = _interopRequireDefault(_pageCommon);
	
	var _pageVote = __webpack_require__(387);
	
	var _pageVote2 = _interopRequireDefault(_pageVote);
	
	var _project = __webpack_require__(13);
	
	var _themeList = __webpack_require__(819);
	
	var _themeList2 = _interopRequireDefault(_themeList);
	
	var _dialog = __webpack_require__(385);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _vote_icon = __webpack_require__(371);
	
	var _vote_icon2 = _interopRequireDefault(_vote_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        PageCommon: _pageCommon2.default,
	        themeList: _themeList2.default,
	        dialogComponent: _dialog2.default,
	        PageVote: _pageVote2.default
	    },
	    data: function data() {
	        return {
	            titleIcon: _vote_icon2.default,
	            isNeedUnfold: false,
	            isHideDescFlag: false,
	            unfoldText: "展开",
	            isSharePage: false,
	            data: {},
	            errorUserPhoto: '',
	            vodeOption: {},
	            isShowDialog: false,
	            dialogParams: {}
	        };
	    },
	
	    watch: {
	        'data': function data(newVal, oldVal) {
	            if (newVal.id && newVal.id !== oldVal.id) {
	                this.formatDesc();
	            }
	        }
	    },
	    created: function created() {
	        window.appapi = _appapi2.default;
	        window.$vm = this;
	        var themeId = this.$route.params.id;
	        this.getInit(themeId);
	
	        this.isSharePage = appapi.isSharePage();
	        console.log(this.isSharePage);
	    },
	    mounted: function mounted() {},
	
	    methods: {
	        formatDesc: function formatDesc() {
	            this.$nextTick(function () {
	                var DescEl = this.$el.querySelector('.title-area .description');
	                var DescH = DescEl.offsetHeight;
	                var finalStyle = DescEl.currentStyle ? DescEl.currentStyle : window.getComputedStyle(DescEl, null);
	
	                if (parseInt(finalStyle.height) > parseInt(finalStyle.lineHeight) * 5) {
	                    this.isNeedUnfold = true;
	                    this.isHideDescFlag = true;
	                }
	            });
	        },
	        unfold: function unfold() {
	            this.isHideDescFlag = !this.isHideDescFlag;
	            this.unfoldText = this.unfoldText === '展开' ? '收起' : '展开';
	        },
	        loadImg: function loadImg(e) {
	            e.target.style.backgroundImage = 'unset';
	        },
	        getInit: function getInit(themeId) {
	            var _this = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/articles/detail/' + themeId).then(function (res) {
	                if (res.code == 0) {
	                    _this.data = res.item;
	                    var result = res.item;
	                    var desc = result.description ? result.description : '';
	                    (0, _weChatShare2.default)({
	                        title: result.listTitle || result.title,
	                        desc: desc,
	                        imgUrl: result.shareImage || ''
	                    }, _this);
	                    if (_this.data.hasVote) {
	                        _this.getVote(_this.data.voteId);
	                    }
	                }
	            });
	        },
	        getVote: function getVote(voteId) {
	            var _this2 = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/vote/getVoteInfo/' + voteId).then(function (res) {
	                if (res.code == 0) {
	                    _this2.vodeOption = res.item;
	                    var n = 0;
	                    _this2.vodeOption.options.map(function (item) {
	                        if (item.imageUrl) n++;
	                    });
	                    if (n != 0) {
	                        _this2.vodeOption.options.map(function (item) {
	                            if (!item.imageUrl) {
	                                _this2.$nextTick(function () {
	                                    var item = this.$el.querySelectorAll('.ballot-list .noimageUrl');
	                                    console.log(item, 'item');
	                                    for (var i = 0; i < item.length; i++) {
	                                        item[i].style.height = "1rem";
	                                    }
	                                });
	                            }
	                        });
	                    }
	                    if (n == 0) {
	                        _this2.vodeOption.options.map(function (item) {
	                            if (item.title.length > 16) {
	                                _this2.$nextTick(function () {
	                                    var item = this.$el.querySelectorAll('.ballot-list .item');
	                                    for (var i = 0; i < item.length; i++) {
	                                        item[i].style.height = "1rem";
	                                    }
	                                });
	                            }
	                        });
	                    }
	                }
	            });
	        },
	        goLast: function goLast() {
	            this.$router.push('/lastTheme');
	        },
	        openDialog: function openDialog(options) {
	            console.log("rerere");
	            this.isShowDialog = true;
	            this.dialogParams = {
	                articleId: this.data.id,
	                categoryId: this.data.categoryId,
	                sysCode: this.data.sysCode || "",
	                type: this.data.type || this.data.sysCode || "",
	                link: this.data.link || ""
	            };
	        },
	        closeDialog: function closeDialog() {
	            this.isShowDialog = false;
	        },
	        okDialog: function okDialog() {
	            this.isShowDialog = false;
	        }
	    }
	};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(47);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _style = __webpack_require__(37);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _weChatShare = __webpack_require__(39);
	
	var _weChatShare2 = _interopRequireDefault(_weChatShare);
	
	var _project = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            data: {},
	            blocks: []
	        };
	    },
	    created: function created() {
	        this.getInit(this.$route.params.id);
	    },
	
	
	    methods: {
	        getInit: function getInit(id) {
	            var _this = this;
	
	            var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/subjects/' + id + '?size=' + size).then(function (res) {
	                var result = res.item;
	                if (res.code === 0) {
	                    _this.data = result;
	                    _this.blocks = result.blocks;
	
	                    (0, _weChatShare2.default)({
	                        title: result.title
	                    }, _this);
	                } else {
	                    (0, _toast2.default)(res.msg);
	                }
	            });
	        },
	        toggleBlock: function toggleBlock(index, e) {
	            var id = this.generateElementId(index);
	            document.getElementById(id).scrollIntoView(true);
	        },
	        getArticles: function getArticles(id, index) {
	            var _this2 = this;
	
	            var size = 5;
	            if (this.data.blockType == 1) {
	                size = 20;
	            }
	            var pageToken = this.blocks[index].page.next * 1;
	            var pageLast = this.blocks[index].page.last * 1;
	
	            if (pageToken > pageLast) return false;
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/blocks/' + id + '?size=' + size + '&pageToken=' + pageToken).then(function (res) {
	                var result = res.items;
	                if (res.code === 0) {
	                    _this2.blocks[index].articles = [].concat((0, _toConsumableArray3.default)(_this2.blocks[index].articles), (0, _toConsumableArray3.default)(result));
	                    _this2.blocks[index].page.next++;
	                }
	            });
	        },
	
	
	        getDate: function getDate(date) {
	            return date.slice(0, -2) + ':00';
	        },
	
	        getTime: function getTime(time) {
	            var result = '';
	            if (time) {
	                result = time.substring(0, 10) + ' ' + time.substring(11, 16);
	            }
	            return result;
	        },
	        getCount: function getCount(count) {
	            var result = 0;
	            if (count > 0) {
	                result = count;
	                if (count > 999999) {
	                    result = count.substring(0, count.length - 4) + '万';
	                    if (count > 99999999) {
	                        result = '过亿';
	                    }
	                }
	            }
	            return result;
	        },
	        goPath: function goPath(article) {
	            window.location.href = article.shareUrl;
	        },
	        generateElementId: function generateElementId(i) {
	            return "blockElementId" + i;
	        }
	    }
	};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(75);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _style = __webpack_require__(37);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _style3 = __webpack_require__(717);
	
	var _style4 = _interopRequireDefault(_style3);
	
	var _checklist = __webpack_require__(760);
	
	var _checklist2 = _interopRequireDefault(_checklist);
	
	var _vue = __webpack_require__(24);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _appapi = __webpack_require__(18);
	
	var _appapi2 = _interopRequireDefault(_appapi);
	
	var _vote_icon = __webpack_require__(371);
	
	var _vote_icon2 = _interopRequireDefault(_vote_icon);
	
	var _icon_Select2x = __webpack_require__(770);
	
	var _icon_Select2x2 = _interopRequireDefault(_icon_Select2x);
	
	var _project = __webpack_require__(13);
	
	var _dialog = __webpack_require__(385);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_checklist2.default);
	exports.default = {
	    components: {
	        dialogComponent: _dialog2.default
	    },
	    data: function data() {
	        return {
	            voteChecked: _icon_Select2x2.default,
	            titleIcon: _vote_icon2.default,
	            isLogin: 0,
	            vodeOption: null,
	            voteSelectedList: [],
	            isResult: false,
	            voteType: 'radio',
	            radioItem: '',
	            isVoteResult: [],
	            isShowDialog: false,
	            dialogParams: {}
	        };
	    },
	
	    props: {
	        voteObj: {
	            type: Object,
	            default: function _default() {
	                return {};
	            }
	        }
	    },
	
	    watch: {
	        isLogin: function isLogin(newval, oldval) {
	            if (newval == 1) {
	                this.addVote(this.radioItem, this.voteType);
	            }
	            console.log(newval, oldval, 'watchisLogin');
	        },
	        isVoteResult: function isVoteResult(newval, oldval) {
	            console.log(newval, oldval, 'watchisVoteResult');
	            this.voteSelectedList = newval || oldval;
	            if (this.voteSelectedList.length > 0) this.isResult = true;
	        },
	        voteObj: function voteObj(newval, oldval) {
	            console.log(newval, oldval, 'newval');
	            if (newval) {
	                this.getVote(this.newval.voteId);
	            }
	        }
	    },
	    computed: {
	        mutiTitle: function mutiTitle() {
	            var t = '（多选，';
	            if (this.vodeOption.isFix) {
	                t += '每人固定' + this.vodeOption.fixedNum;
	            } else {
	                t += '每人至少选' + this.vodeOption.minNum;
	            }
	            return t + '项）';
	        }
	    },
	
	    methods: {
	        handleItemClick: function handleItemClick(itemId) {
	            var idx = this.voteSelectedList.indexOf(itemId + '');
	
	            if (idx >= 0) {
	                this.voteSelectedList.splice(idx, 1);
	            } else {
	                this.voteSelectedList.push(itemId + '');
	                if (this.vodeOption.isFix) {
	                    if (this.voteSelectedList.length > this.vodeOption.fixedNum) {
	                        this.voteSelectedList.splice(idx, 1);
	                    }
	                }
	            }
	        },
	        openDialog: function openDialog(options) {
	            console.log("rerere");
	        },
	        closeDialog: function closeDialog() {
	            this.isShowDialog = false;
	        },
	        okDialog: function okDialog() {
	            this.isShowDialog = false;
	        },
	        addVote: function addVote(item, type) {
	            var _this2 = this;
	
	            var _this = this;
	            _this.radioItem = item;
	            _this.voteType = type;
	            if (!_this.isSharePage) {
	                if (!_this.isLogin) {
	                    _this.appPostMessage('userLogin', '');
	                }
	                console.log(_this.isLogin, 'this.isLogin');
	                if (_this.isLogin) {
	                    if (type == 'checkbox') {
	                        if (this.vodeOption.isFix) {
	                            if (this.voteSelectedList.length != this.vodeOption.fixedNum) {
	                                (0, _toast2.default)('\u8FD8\u9700\u9009\u62E9' + (this.vodeOption.fixedNum - this.voteSelectedList.length) + '\u9879');
	                                return;
	                            }
	                        } else {
	                            if (this.voteSelectedList.length < this.vodeOption.minNum) {
	                                (0, _toast2.default)('\u8FD8\u9700\u9009\u62E9' + (this.vodeOption.minNum - this.voteSelectedList.length) + '\u9879');
	                                return;
	                            }
	                        }
	                        _this.$axios.post(_project.intfc_prefix_common + '/api/v2/vote/clientVote/' + this.voteObj.voteId + '/voteOptionIds?voteOptionIds=' + this.voteSelectedList.join()).then(function (res) {
	                            if (res.code == 0) {
	                                _this2.isResult = true;
	                                var obj = _this.voteObj.voteId + "|" + _this2.voteSelectedList.join();
	                                console.log(obj, (0, _stringify2.default)(obj), 'test');
	                                _this.appPostMessage('toVoteParams', obj);
	                                _this.getVote(_this.voteObj.voteId);
	                            }
	                        });
	                    } else {
	                        this.voteSelectedList.push(item.id + '');
	                        _this.$axios.post(_project.intfc_prefix_common + '/api/v2/vote/clientVote/' + this.voteObj.voteId + '/voteOptionIds?voteOptionIds=' + item.id).then(function (res) {
	                            if (res.code == 0) {
	                                _this2.isResult = true;
	                                var obj = _this.voteObj.voteId + "|" + item.id;
	                                _this.appPostMessage('toVoteParams', obj);
	                                _this.getVote(_this.voteObj.voteId);
	                            }
	                        });
	                    }
	                }
	            }
	        },
	        appPostMessage: function appPostMessage(name) {
	            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	            if (name) window.appapi.appPostMessage(name, value);
	        },
	        getVote: function getVote(voteId) {
	            var _this3 = this;
	
	            this.$axios.get(_project.intfc_prefix_common + '/api/v2/vote/getVoteInfo/' + voteId).then(function (res) {
	                if (res.code == 0) {
	                    _this3.appPostMessage('getVoteFinish');
	                    _this3.vodeOption = res.item;
	                    var n = 0;
	                    _this3.vodeOption.options.map(function (item) {
	                        if (item.imageUrl) n++;
	                    });
	                    if (n != 0) {
	                        _this3.vodeOption.options.map(function (item) {
	                            if (!item.imageUrl) {
	                                _this3.$nextTick(function () {
	                                    var item = this.$el.querySelectorAll('.ballot-result .noimageUrl');
	                                    console.log(item, 'item');
	                                    for (var i = 0; i < item.length; i++) {
	                                        item[i].style.height = "1rem";
	                                    }
	                                });
	                            }
	                        });
	                    }
	                    if (n == 0) {
	                        _this3.vodeOption.options.map(function (item) {
	                            if (item.title.length > 16) {
	                                _this3.$nextTick(function () {
	                                    var item = this.$el.querySelectorAll('.ballot-result .item');
	                                    for (var i = 0; i < item.length; i++) {
	                                        item[i].style.height = "1rem";
	                                    }
	                                });
	                            }
	                        });
	                    }
	                    if (_this3.isSharePage) _this3.isResult = true;
	                }
	            });
	        }
	    },
	    mounted: function mounted() {
	        if (this.voteObj) {
	            this.getVote(this.voteObj.voteId);
	        }
	        console.log(this.$refs['hello']);
	    },
	    created: function created() {
	        window.appapi = _appapi2.default;
	        window.$vm = this;
	        this.isSharePage = appapi.isSharePage();
	        console.log(this.isSharePage);
	    }
	};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _image = __webpack_require__(27);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		mixins: [_image2.default],
		props: {
			avatar: {
				type: String
			}
		},
		computed: {
			showAvatar: function showAvatar() {
				return !Jt.string.isEmpty(this.avatar);
			}
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(173);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _style = __webpack_require__(37);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _extends2 = __webpack_require__(46);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(391);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_axios2.default.interceptors.request.use(function (config) {
	    config.headers.common = {
	        'Content-Type': "application/x-www-form-urlencoded",
	        'Access-Control-Allow-Origin': "*"
	    };
	    config.timeout = 12000;
	    if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
	        config.data = (0, _extends3.default)({}, config.data, {
	            _t: Date.parse(new Date()) / 1000
	        });
	    } else if (config.method === 'get') {
	        config.params = (0, _extends3.default)({
	            _t: Date.parse(new Date()) / 1000
	        }, config.params);
	    }
	    return config;
	}, function (err) {
	    return null;
	});
	
	_axios2.default.interceptors.response.use(function (response) {
	    var data = response.data;
	    if (response.data.code === -1) {
	        (0, _toast2.default)({
	            message: response.data.msg
	        });
	        return _promise2.default.reject(response.data.msg);
	    }
	    return data;
	}, function (err) {
	    if (err.toString().indexOf("timeout") != -1) {
	        console.log(err);
	    }
	    if (err && err.response) {
	        switch (err.response.status) {
	            case 400:
	                err.message = '请求错误';
	                break;
	
	            case 401:
	                err.message = '未授权，请登录';
	                break;
	
	            case 403:
	                err.message = '拒绝访问';
	                break;
	
	            case 404:
	                err.message = "\u8BF7\u6C42\u5730\u5740\u51FA\u9519: " + err.response.config.url;
	                break;
	            case 405:
	                err.message = "\u8BF7\u6C42\u5730\u5740\u51FA\u9519:";
	                break;
	            case 408:
	                err.message = '请求超时';
	                break;
	
	            case 500:
	                err.message = '服务器开个小差，请稍后再试';
	                break;
	
	            case 501:
	                err.message = '服务器开个小差，请稍后再试';
	                break;
	
	            case 502:
	                err.message = '服务器开个小差，请稍后再试';
	                break;
	
	            case 503:
	                err.message = '服务器开个小差，请稍后再试';
	                break;
	
	            case 504:
	                err.message = '服务器开个小差，请稍后再试';
	                break;
	
	            case 505:
	                err.message = 'HTTP版本不受支持';
	                break;
	
	            default:
	        }
	        if (err.response.data.msg) {
	            err.message = err.response.data.msg;
	        }
	
	        (0, _toast2.default)(err.message);
	    }
	
	    return _promise2.default.reject(err);
	});
	
	exports.default = _axios2.default;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (Vue) {
		Vue.filter('dateCompared_', function (ms) {
			var time = (0, _moment2.default)().diff((0, _moment2.default)(ms), "seconds");
			var timeStr = "";
			if (time < 60) {
				timeStr = "1分钟前";
			} else if (time < 3600) {
				timeStr = parseInt(time / 60) + "分钟前";
			} else if (time < 3600 * 24) {
				timeStr = parseInt(time / 3600) + '小时前';
			} else if (time < 31536000) {
				timeStr = (0, _moment2.default)(ms).format("MM-DD HH:mm");
			} else {
				timeStr = (0, _moment2.default)(ms).format("YYYY-MM-DD HH:mm");
			}
			return timeStr;
		});
		Vue.filter('dateComparedTime', function (date) {
			var result = (0, _moment2.default)(date).startOf('minute').fromNow();
			if (result.indexOf('秒') > -1) {
				result = '1分钟前';
			}
			if (result.indexOf('天') > -1 || result.indexOf('月') > -1 || result.indexOf('年') > -1) {
				result = (0, _moment2.default)(date).format('MM-DD HH:mm');
			}
	
			return result;
		});
		Vue.filter('getTimeUTC', function (time) {
	
			var result = '';
			if (time) {
				result = time.substring(0, 10) + ' ' + time.substring(11, 16);
			}
			return result;
		});
		Vue.filter('dateFormat1', function (date, format) {
			if (!date) {
				return;
			}
			date = date + '';
			if (date.length === 10) {
				date = parseInt(date) * 1000;
			} else {
				date = parseInt(date);
			}
			date = new Date(date);
			if (!format) {
				format = 'yyyy-MM-dd';
			}
			var y_n = new Date().getFullYear(),
			    y_o = date.getFullYear();
			if (y_n != y_o && format.indexOf('yyyy') !== 0) {
				format = 'yyyy-' + format;
			}
			var map = {
				'M': date.getMonth() + 1,
				'd': date.getDate(),
				'h': date.getHours(),
				'm': date.getMinutes(),
				's': date.getSeconds(),
				'q': Math.floor((date.getMonth() + 3) / 3),
				'S': date.getMilliseconds() };
			format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
				var v = map[t];
				if (v !== undefined) {
					if (all.length > 1) {
						v = '0' + v;
						v = v.substr(v.length - 2);
					}
					return v;
				} else if (t === 'y') {
					return (date.getFullYear() + '').substr(4 - all.length);
				}
				return all;
			});
			return format;
		});
	
		Vue.filter('dateFormat2', function (date) {
			if (!date) {
				return;
			}
			date = date + '';
			if (date.length === 10) {
				date = parseInt(date) * 1000;
			} else {
				date = parseInt(date);
			}
			date = new Date(date);
			var dateTime = '';
			var minute = 1000 * 60;
			var hour = minute * 60;
			var day = hour * 24;
			var month = day * 30;
			function pad(num, n) {
				var len = num.toString().length;
				while (len < n) {
					num = '0' + num;
					len++;
				}
				return num;
			}
			function getDateDiff(dateTimeStamp) {
				var now = new Date().getTime();
				var diffValue = now - dateTimeStamp;
				var monthC = diffValue / month;
				var weekC = diffValue / (7 * day);
				var dayC = diffValue / day;
				var hourC = diffValue / hour;
				var minC = diffValue / minute;
				var result = '刚刚';
				if (dayC >= 1) {
					result = pad(date.getMonth() + 1, 2) + '-' + pad(date.getDate(), 2);
					var y_n = new Date().getFullYear(),
					    y_o = date.getFullYear();
					if (y_n != y_o) {
						result = y_o + '-' + result;
					}
				} else if (hourC >= 1) {
					result = parseInt(hourC) + '小时前';
				} else if (minC >= 5) {
					result = parseInt(minC) + '分钟前';
				}
				return result;
			}
			dateTime = getDateDiff(date);
			return dateTime;
		});
	
		Vue.filter('numberFormat', function (num) {
			num = parseInt(num);
			if (num + '' === 'NaN') {
				return 0;
			}
			if (num >= 1000000 && num < 100000000) {
				return parseInt(num / 10000) + '万';
			} else if (num >= 100000000) {
				return '过亿';
			} else {
				return num;
			}
		});
		Vue.filter('dateNewComment', function (date) {
			date = date + '';
			if (date == "") {
				date = new Date();
			} else if (date.length > 10) {
				date = new Date(parseInt(date));
			} else {
				date = new Date(parseInt(date) * 1000);
			}
			function pad(num, n) {
				var len = num.toString().length;
				while (len < n) {
					num = "0" + num;
					len++;
				}
				return num;
			}
			var dateTime = "";
			var minute = 1000 * 60;
			var hour = minute * 60;
			var day = hour * 24;
			var halfamonth = day * 15;
			var month = day * 30;
			function getDateDiff2(dateTimeStamp) {
				var now = new Date().getTime();
				var diffValue = now - dateTimeStamp;
				var monthC = diffValue / month;
				var weekC = diffValue / (7 * day);
				var dayC = diffValue / day;
				var hourC = diffValue / hour;
				var minC = diffValue / minute;
	
				var y_o = date.getFullYear(),
				    y_n = new Date().getFullYear();
				var d_o = date.getDate(),
				    d_n = new Date().getDate();
				var h_o = date.getHours(),
				    h_n = new Date().getHours();
				var m_o = date.getMinutes(),
				    m_n = new Date().getMinutes();
				var s_o = date.getSeconds(),
				    s_n = new Date().getSeconds();
				var result = "";
				if (y_o != y_n) {
					result = y_o + '' + "-" + pad(date.getMonth() + 1, 2) + "-" + pad(d_o, 2) + " " + pad(h_o, 2) + ":" + pad(m_o, 2);
				} else if (y_n == y_o) {
					if (d_n - d_o == 1) {
						result = "昨天 " + pad(h_o, 2) + ":" + pad(m_o, 2);
					} else if (d_n - d_o > 1) {
						result = pad(date.getMonth() + 1, 2) + "-" + pad(date.getDate(), 2) + " " + pad(h_o, 2) + ":" + pad(m_o, 2);
					} else {
						if (minC > 30) {
							result = pad(h_o, 2) + ":" + pad(m_o, 2);
						} else if (minC <= 30 && minC > 0) {
							if (m_n - m_o == 0) result = Math.abs(m_n - m_o + 1) + "分钟前";else {
								result = Math.abs(m_n - m_o) + "分钟前";
							}
						} else {
							result = "1分钟前";
						}
					}
				}
				return result;
			}
			dateTime = getDateDiff2(date);
			return dateTime;
		});
		Vue.filter('dateListComment', function (date) {
			date = date + '';
			if (date == "") {
				date = new Date();
			} else if (date.length > 10) {
				date = new Date(parseInt(date));
			} else {
				date = new Date(parseInt(date) * 1000);
			}
			function pad(num, n) {
				var len = num.toString().length;
				while (len < n) {
					num = "0" + num;
					len++;
				}
				return num;
			}
			var dateTime = "";
			var minute = 1000 * 60;
			var hour = minute * 60;
			var day = hour * 24;
			var halfamonth = day * 15;
			var month = day * 30;
			function getDateDiff2(dateTimeStamp) {
				var now = new Date().getTime();
				var diffValue = now - dateTimeStamp;
				var monthC = diffValue / month;
				var weekC = diffValue / (7 * day);
				var dayC = diffValue / day;
				var hourC = diffValue / hour;
				var minC = diffValue / minute;
	
				var y_o = date.getFullYear(),
				    y_n = new Date().getFullYear();
				var d_o = date.getDate(),
				    d_n = new Date().getDate();
				var h_o = date.getHours(),
				    h_n = new Date().getHours();
				var m_o = date.getMinutes(),
				    m_n = new Date().getMinutes();
				var s_o = date.getSeconds(),
				    s_n = new Date().getSeconds();
				var result = "";
				if (y_o != y_n) {
					result = y_o + '' + "-" + pad(date.getMonth() + 1, 2) + "-" + pad(d_o, 2);
				} else if (y_n == y_o) {
					if (d_n - d_o == 1) {
						result = "昨天 " + pad(h_o, 2) + ":" + pad(m_o, 2);
					} else if (d_n - d_o > 1) {
						result = pad(date.getMonth() + 1, 2) + "-" + pad(date.getDate(), 2);
					} else {
						if (minC > 30) {
							result = pad(h_o, 2) + ":" + pad(m_o, 2);
						} else if (minC <= 30 && minC > 0) {
							if (m_n - m_o == 0) result = Math.abs(m_n - m_o + 1) + "分钟前";else {
								result = Math.abs(m_n - m_o) + "分钟前";
							}
						} else {
							result = "1分钟前";
						}
					}
				}
				return result;
			}
			dateTime = getDateDiff2(date);
			return dateTime;
		});
		Vue.filter('dataISO', function (string) {
			var regexp = "([0-9]{4})(-([0-9]{2})(-([0-9]{2})" + "(T([0-9]{2}):([0-9]{2})(:([0-9]{2})(\.([0-9]+))?)?" + "(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?";
			if (string) {
				var d = string.match(new RegExp(regexp));
				var offset = 0;
				var date = new Date(d[1], 0, 1);
				var time;
				if (d[3]) {
					date.setMonth(d[3] - 1);
				}
				if (d[5]) {
					date.setDate(d[5]);
				}
				if (d[7]) {
					date.setHours(d[7]);
				}
				if (d[8]) {
					date.setMinutes(d[8]);
				}
				if (d[10]) {
					date.setSeconds(d[10]);
				}
				if (d[12]) {
					date.setMilliseconds(Number("0." + d[12]) * 1000);
				}
				if (d[14]) {
					offset = Number(d[16]) * 60 + Number(d[17]);
					offset *= d[15] == '-' ? 1 : -1;
				}
				offset -= date.getTimezoneOffset();
				time = Number(date) + offset * 60 * 1000;
				return bbb(time);
			} else {
				return;
			}
		});
		Vue.filter('dateCompared', function (date) {
			var result = (0, _moment2.default)(date).startOf('minute').fromNow();
			if (result.indexOf('秒') > -1) {
				result = '1分钟前';
			}
			if (result.indexOf('天') > -1 || result.indexOf('月') > -1) {
				result = (0, _moment2.default)(date).format('MM-DD HH:mm');
			}
	
			if (result.indexOf('年') > -1) {
				result = (0, _moment2.default)(date).format('YYYY-MM-DD HH:mm');
			}
	
			return result;
		});
	
		function bbb(date) {
			console.log(date);
			date = date + '';
			if (date == "") {
				date = new Date();
			} else if (date.length > 10) {
				date = new Date(parseInt(date));
			} else {
				date = new Date(parseInt(date) * 1000);
			}
			function pad(num, n) {
				var len = num.toString().length;
				while (len < n) {
					num = "0" + num;
					len++;
				}
				return num;
			}
			var dateTime = "";
			var minute = 1000 * 60;
			var hour = minute * 60;
			var day = hour * 24;
			var halfamonth = day * 15;
			var month = day * 30;
			function getDateDiff2(dateTimeStamp) {
				var now = new Date().getTime();
				var diffValue = now - dateTimeStamp;
				var monthC = diffValue / month;
				var weekC = diffValue / (7 * day);
				var dayC = diffValue / day;
				var hourC = diffValue / hour;
				var minC = diffValue / minute;
	
				var y_o = date.getFullYear(),
				    y_n = new Date().getFullYear();
				var d_o = date.getDate(),
				    d_n = new Date().getDate();
				var h_o = date.getHours(),
				    h_n = new Date().getHours();
				var m_o = date.getMinutes(),
				    m_n = new Date().getMinutes();
				var s_o = date.getSeconds(),
				    s_n = new Date().getSeconds();
				var result = "";
				if (y_o != y_n) {
					result = y_o + '' + "-" + pad(date.getMonth() + 1, 2) + "-" + pad(d_o, 2);
				} else if (y_n == y_o) {
					if (d_n - d_o == 1) {
						result = "昨天 " + pad(h_o, 2) + ":" + pad(m_o, 2);
					} else if (d_n - d_o > 1) {
						result = pad(date.getMonth() + 1, 2) + "-" + pad(date.getDate(), 2);
					} else {
						if (minC > 30) {
							result = pad(h_o, 2) + ":" + pad(m_o, 2);
						} else if (minC <= 30 && minC > 0) {
							if (m_n - m_o == 0) result = Math.abs(m_n - m_o + 1) + "分钟前";else {
								result = Math.abs(m_n - m_o) + "分钟前";
							}
						} else {
							result = "1分钟前";
						}
					}
				}
				return result;
			}
			dateTime = getDateDiff2(date);
			return dateTime;
		}
	};
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_moment2.default.locale('zh-cn', {
		months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
		monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
		weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
		weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
		weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
		longDateFormat: {
			LT: 'HH:mm',
			LTS: 'HH:mm:ss',
			L: 'YYYY-MM-DD',
			LL: 'YYYY年MM月DD日',
			LLL: 'YYYY年MM月DD日Ah点mm分',
			LLLL: 'YYYY年MM月DD日ddddAh点mm分',
			l: 'YYYY-M-D',
			ll: 'YYYY年M月D日',
			lll: 'YYYY年M月D日 HH:mm',
			llll: 'YYYY年M月D日dddd HH:mm'
		},
		meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
		meridiemHour: function meridiemHour(hour, meridiem) {
			if (hour === 12) {
				hour = 0;
			}
			if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
				return hour;
			} else if (meridiem === '下午' || meridiem === '晚上') {
				return hour + 12;
			} else {
				return hour >= 11 ? hour : hour + 12;
			}
		},
		meridiem: function meridiem(hour, minute, isLower) {
			var hm = hour * 100 + minute;
			if (hm < 600) {
				return '凌晨';
			} else if (hm < 900) {
				return '早上';
			} else if (hm < 1130) {
				return '上午';
			} else if (hm < 1230) {
				return '中午';
			} else if (hm < 1800) {
				return '下午';
			} else {
				return '晚上';
			}
		},
		calendar: {
			sameDay: '[今天]LT',
			nextDay: '[明天]LT',
			nextWeek: '[下]ddddLT',
			lastDay: '[昨天]LT',
			lastWeek: '[上]ddddLT',
			sameElse: 'L'
		},
		dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
		ordinal: function ordinal(number, period) {
			switch (period) {
				case 'd':
				case 'D':
				case 'DDD':
					return number + '日';
				case 'M':
					return number + '月';
				case 'w':
				case 'W':
					return number + '周';
				default:
					return number;
			}
		},
		relativeTime: {
			future: '%s内',
			past: '%s前',
			s: '几秒',
			ss: '%d秒',
			m: '1分钟',
			mm: '%d分钟',
			h: '1小时',
			hh: '%d小时',
			d: '1天',
			dd: '%d天',
			M: '1个月',
			MM: '%d个月',
			y: '1年',
			yy: '%d年'
		},
		week: {
			dow: 1,
			doy: 4 }
	});

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(463);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vueRouter = __webpack_require__(388);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _pageNormal = __webpack_require__(829);
	
	var _pageNormal2 = _interopRequireDefault(_pageNormal);
	
	var _pageDetail = __webpack_require__(824);
	
	var _pageDetail2 = _interopRequireDefault(_pageDetail);
	
	var _pageImg = __webpack_require__(826);
	
	var _pageImg2 = _interopRequireDefault(_pageImg);
	
	var _pageTopic = __webpack_require__(832);
	
	var _pageTopic2 = _interopRequireDefault(_pageTopic);
	
	var _pageLive = __webpack_require__(828);
	
	var _pageLive2 = _interopRequireDefault(_pageLive);
	
	var _pageAskDetail = __webpack_require__(822);
	
	var _pageAskDetail2 = _interopRequireDefault(_pageAskDetail);
	
	var _pageAskTopic = __webpack_require__(823);
	
	var _pageAskTopic2 = _interopRequireDefault(_pageAskTopic);
	
	var _pagePaper = __webpack_require__(830);
	
	var _pagePaper2 = _interopRequireDefault(_pagePaper);
	
	var _pageJinguan = __webpack_require__(827);
	
	var _pageJinguan2 = _interopRequireDefault(_pageJinguan);
	
	var _film = __webpack_require__(811);
	
	var _film2 = _interopRequireDefault(_film);
	
	var _pageTheme = __webpack_require__(831);
	
	var _pageTheme2 = _interopRequireDefault(_pageTheme);
	
	var _pageGovernment = __webpack_require__(825);
	
	var _pageGovernment2 = _interopRequireDefault(_pageGovernment);
	
	var _page24hours = __webpack_require__(821);
	
	var _page24hours2 = _interopRequireDefault(_page24hours);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = new _vueRouter2.default({
	  base: '/h5',
	  mode: 'history',
	  routes: [{ path: "/normal/:sysCode/:categoryId/:id", component: _pageNormal2.default }, { path: "/detail/:type/:id", name: "Detail", component: _pageDetail2.default }, { path: "/img/:sysCode/:categoryId/:id", component: _pageImg2.default }, { path: "/topic/:id", component: _pageTopic2.default }, { path: "/live/:id", component: _pageLive2.default }, { path: "/paper/:sysCode/:id/:date", component: _pagePaper2.default }, { path: "/film/:id", component: _film2.default }, {
	    path: "/theme/:id",
	    component: _pageTheme2.default
	  }, {
	    path: "/local/:id",
	    name: 'Local',
	    component: _pageJinguan2.default
	  }, {
	    path: "/government/detail/:id",
	    name: "GovernmentDetail",
	    component: _pageGovernment2.default
	  }, {
	    path: "/24hours",
	    name: "Hours",
	    component: _page24hours2.default
	  }]
	});
	router.beforeEach(function (to, from, next) {
	  var hash = to.hash,
	      fullPath = to.fullPath,
	      path = to.path,
	      query = to.query;
	
	  console.log(router.options.base, 'router');
	  console.log(window.location, 'to');
	
	  if (hash && hash.indexOf('#/') >= 0) {
	    var arr = (0, _keys2.default)(query).map(function (key) {
	      return key + "=" + query[key];
	    });
	    var hashUrl = hash.replace('#/', '');
	    var url = arr.length ? "" + router.options.base + path + hashUrl + "?" + arr.join('&') : "" + router.options.base + path + hashUrl;
	
	    window.location.href = url;
	  }
	  console.log('beforeEach', __dirname);
	  next();
	});
	exports.default = router;
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(24);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(53);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _app = __webpack_require__(453);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _normal = __webpack_require__(457);
	
	var _normal2 = _interopRequireDefault(_normal);
	
	var _topic = __webpack_require__(460);
	
	var _topic2 = _interopRequireDefault(_topic);
	
	var _live = __webpack_require__(456);
	
	var _live2 = _interopRequireDefault(_live);
	
	var _oneComment = __webpack_require__(458);
	
	var _oneComment2 = _interopRequireDefault(_oneComment);
	
	var _askDetail = __webpack_require__(454);
	
	var _askDetail2 = _interopRequireDefault(_askDetail);
	
	var _askTopic = __webpack_require__(455);
	
	var _askTopic2 = _interopRequireDefault(_askTopic);
	
	var _paper = __webpack_require__(459);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
		modules: {
			app: _app2.default,
			normal: _normal2.default,
			topic: _topic2.default,
			live: _live2.default,
			oneComment: _oneComment2.default,
			askDetail: _askDetail2.default,
			askTopic: _askTopic2.default,
			paper: _paper2.default
		}
	});
	
	exports.default = store;

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var app = {
		state: {
			width: 0
		},
		mutations: {
			'app:update:width': function appUpdateWidth(state, width) {
				state.width = width;
			},
			'app:create:scroll': function appCreateScroll(state, el) {
				el.Scroll = new el.$BScroll(el.$refs.scroll, {
					click: true
				});
			}
		},
		actions: {
			'app:update:width': function appUpdateWidth(_ref, width) {
				var commit = _ref.commit;
	
				commit('app:update:width', width);
			},
			'app:create:scroll': function appCreateScroll(_ref2, el) {
				var commit = _ref2.commit;
	
				commit('app:create:scroll', el);
			}
		},
		getters: {
			'app:width': function appWidth(state) {
				return state.width;
			}
		}
	};
	
	exports.default = app;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(60);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(59);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _api = __webpack_require__(58);
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var askDetail = {
		state: {
			id: '',
			detail: {},
			related: [],
			comments: [],
			hasComments: false
		},
		mutations: {
			'ask:detail:update:id': function askDetailUpdateId(state, id) {
				state.id = id;
			},
			'ask:detail:update:detail': function askDetailUpdateDetail(state) {
				var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				state.detail = detail;
			},
			'ask:detail:update:related': function askDetailUpdateRelated(state) {
				var related = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
				state.related = related;
			},
			'ask:detail:update:comments': function askDetailUpdateComments(state) {
				var comments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
				if (comments.length > 0) {
					state.hasComments = true;
				}
				state.comments = comments;
			}
		},
		actions: {
			'ask:detail:init': function askDetailInit(_ref, id) {
				var _this = this;
	
				var commit = _ref.commit,
				    dispatch = _ref.dispatch;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									commit('ask:detail:update:id', id);
	
									dispatch('ask:detail:update:detail');
	
									dispatch('ask:detail:update:comments');
	
								case 3:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this);
				}))();
			},
			'ask:detail:update:detail': function askDetailUpdateDetail(_ref2) {
				var _this2 = this;
	
				var commit = _ref2.commit,
				    dispatch = _ref2.dispatch,
				    state = _ref2.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
					var res, data;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									_context2.next = 2;
									return api.getAskDetail({ id: state.id });
	
								case 2:
									res = _context2.sent;
	
									if (res.result.code === 0) {
										data = res.data;
	
										commit('ask:detail:update:detail', data);
	
										dispatch('ask:detail:update:related', data.title);
									}
	
								case 4:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}))();
			},
			'ask:detail:update:related': function askDetailUpdateRelated(_ref3, title) {
				var _this3 = this;
	
				var commit = _ref3.commit,
				    state = _ref3.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
					var res;
					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									_context3.next = 2;
									return api.getAskRelated({ title: title });
	
								case 2:
									res = _context3.sent;
	
									if (res.result.code === 0) {
										commit('ask:detail:update:related', res.data);
									}
	
								case 4:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}))();
			},
			'ask:detail:update:comments': function askDetailUpdateComments(_ref4) {
				var _this4 = this;
	
				var commit = _ref4.commit,
				    state = _ref4.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
					var id, res, data;
					return _regenerator2.default.wrap(function _callee4$(_context4) {
						while (1) {
							switch (_context4.prev = _context4.next) {
								case 0:
									id = state.id + '_ask_' + state.id;
									_context4.next = 3;
									return api.getHotComments({ articleid: id });
	
								case 3:
									res = _context4.sent;
	
									if (res.result.code === 0) {
										data = res.data;
	
										commit('ask:detail:update:comments', data.comments);
									}
	
								case 5:
								case 'end':
									return _context4.stop();
							}
						}
					}, _callee4, _this4);
				}))();
			}
		},
		getters: {
			'ask:detail:detail': function askDetailDetail(state) {
				return state.detail;
			},
			'ask:detail:related': function askDetailRelated(state) {
				return state.related;
			},
			'ask:detail:comments': function askDetailComments(state) {
				return state.comments;
			},
			'ask:detail:hasComments': function askDetailHasComments(state) {
				return state.hasComments;
			}
		}
	};
	
	exports.default = askDetail;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(60);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(59);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _api = __webpack_require__(58);
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var askTopic = {
		state: {
			id: '',
			detail: {},
			related: [],
			comments: [],
			hasComments: false
		},
		mutations: {
			'ask:topic:update:id': function askTopicUpdateId(state, id) {
				state.id = id;
			},
			'ask:topic:update:detail': function askTopicUpdateDetail(state) {
				var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				state.detail = detail;
			},
			'ask:topic:update:related': function askTopicUpdateRelated(state) {
				var related = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
				state.related = related;
			},
			'ask:topic:update:comments': function askTopicUpdateComments(state) {
				var comments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
				if (comments.length > 0) {
					state.hasComments = true;
				}
				state.comments = comments;
			}
		},
		actions: {
			'ask:topic:init': function askTopicInit(_ref, id) {
				var _this = this;
	
				var commit = _ref.commit,
				    dispatch = _ref.dispatch;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									commit('ask:topic:update:id', id);
	
									dispatch('ask:topic:update:detail');
	
									dispatch('ask:topic:update:comments');
	
								case 3:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this);
				}))();
			},
			'ask:topic:update:detail': function askTopicUpdateDetail(_ref2) {
				var _this2 = this;
	
				var commit = _ref2.commit,
				    state = _ref2.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
					var res, data;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									_context2.next = 2;
									return api.getAskTopic({ sid: state.id });
	
								case 2:
									res = _context2.sent;
	
									if (res.result.code === 0) {
										data = res.data;
	
										commit('ask:topic:update:detail', data.subject);
										commit('ask:topic:update:related', data.question);
									}
	
								case 4:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}))();
			},
			'ask:topic:update:comments': function askTopicUpdateComments(_ref3) {
				var _this3 = this;
	
				var commit = _ref3.commit,
				    state = _ref3.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
					var id, res, data;
					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									id = state.id + '_ask_' + state.id;
									_context3.next = 3;
									return api.getHotComments({ articleid: id });
	
								case 3:
									res = _context3.sent;
	
									if (res.result.code === 0) {
										data = res.data;
	
										commit('ask:topic:update:comments', data.comments);
									}
	
								case 5:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}))();
			}
		},
		getters: {
			'ask:topic:detail': function askTopicDetail(state) {
				return state.detail;
			},
			'ask:topic:related': function askTopicRelated(state) {
				return state.related;
			},
			'ask:topic:comments': function askTopicComments(state) {
				return state.comments;
			},
			'ask:topic:hasComments': function askTopicHasComments(state) {
				return state.hasComments;
			}
		}
	};
	
	exports.default = askTopic;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(60);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(59);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _toConsumableArray2 = __webpack_require__(47);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _api = __webpack_require__(58);
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var live = {
		state: {
			detail: {},
	
			comments_lr: [],
	
			comments_ac: [],
	
			maxid_lr: '',
			maxid_ac: '',
			loading_lr: false,
			loading_ac: false,
			hasMore_lr: true,
			hasMore_ac: true,
			next_lr: '',
			next_ac: '',
			params: {
				sysCode: '',
				id: ''
			}
		},
		mutations: {
			'live:update:params': function liveUpdateParams(state, params) {
				state.params.sysCode = params.sysCode;
	
				state.params.id = params.id;
			},
			'live:update:detail': function liveUpdateDetail(state, detail) {
				state.detail = detail;
			},
			'live:update:comments_lr': function liveUpdateComments_lr(state, comments) {
				var next_lr = state.next_lr,
				    comments_lr = state.comments_lr;
	
				if (comments_lr.length == 0) {
					comments_lr = comments.items;
				} else if (comments.page.next) {
					var _comments_lr;
	
					if (comments.items[0].top) {
						comments_lr[0] = comments.items.splice(0, 1);
					}
					(_comments_lr = comments_lr).push.apply(_comments_lr, (0, _toConsumableArray3.default)(comments.items));
				} else if (!comments.page.next) {
					var _state$comments_lr;
	
					(_state$comments_lr = state.comments_lr).push.apply(_state$comments_lr, (0, _toConsumableArray3.default)(comments.items));
				}
				state.hasMore_lr = comments.page && comments.page.next ? true : false;
	
				state.comments_lr = comments_lr;
				state.loading_lr = false;
				state.next_lr = comments.page.next;
			},
			'live:update:comments_ac': function liveUpdateComments_ac(state, comments) {
				if (comments.page && comments.page.next) {
					var _state$comments_ac;
	
					(_state$comments_ac = state.comments_ac).push.apply(_state$comments_ac, (0, _toConsumableArray3.default)(comments.items));
				} else {
					var _state$comments_ac2;
	
					comments.items ? (_state$comments_ac2 = state.comments_ac).push.apply(_state$comments_ac2, (0, _toConsumableArray3.default)(comments.items)) : state.comments_ac = state.comments_ac;
					state.hasMore_ac = false;
				}
				state.next_ac = comments.page && comments.page.next || '', state.loading_ac = false;
			},
			'live:update:loading_lr': function liveUpdateLoading_lr(state, loading) {
				state.loading_lr = loading;
			},
			'live:update:loading_ac': function liveUpdateLoading_ac(state, loading) {
				state.loading_lr = loading;
			}
		},
		actions: {
			'live:init': function liveInit(_ref, params) {
				var _this = this;
	
				var commit = _ref.commit,
				    dispatch = _ref.dispatch;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									commit('live:update:params', params);
	
									dispatch('live:update:detail');
	
									dispatch('live:update:comments_lr');
	
									dispatch('live:update:comments_ac');
	
								case 4:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this);
				}))();
			},
			'live:update:detail': function liveUpdateDetail(_ref2) {
				var _this2 = this;
	
				var commit = _ref2.commit,
				    state = _ref2.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
					var res, data;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									_context2.next = 2;
									return api.getLiveDetail({ articleId: state.params.id });
	
								case 2:
									res = _context2.sent;
	
									if (res.code === 0) {
										data = res.item || [];
	
										commit('live:update:detail', data);
									}
	
								case 4:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}))();
			},
			'live:update:comments_lr': function liveUpdateComments_lr(_ref3) {
				var _this3 = this;
	
				var commit = _ref3.commit,
				    state = _ref3.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
					var res;
					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									commit('live:update:loading_lr', true);
									_context3.next = 3;
									return api.getLive({ articleId: state.params.id, pageToken: state.next_lr });
	
								case 3:
									res = _context3.sent;
	
									if (res.code >= 0) {
										commit('live:update:comments_lr', res);
									}
	
								case 5:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}))();
			},
			'live:update:comments_ac': function liveUpdateComments_ac(_ref4) {
				var _this4 = this;
	
				var commit = _ref4.commit,
				    state = _ref4.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
					var res;
					return _regenerator2.default.wrap(function _callee4$(_context4) {
						while (1) {
							switch (_context4.prev = _context4.next) {
								case 0:
									commit('live:update:loading_ac', true);
									_context4.next = 3;
									return api.getLiveComments({ articleId: state.params.id, pageToken: state.next_ac });
	
								case 3:
									res = _context4.sent;
	
									if (res.code >= 0) {
										commit('live:update:comments_ac', res);
									}
	
								case 5:
								case 'end':
									return _context4.stop();
							}
						}
					}, _callee4, _this4);
				}))();
			}
		},
		getters: {
			'live:detail': function liveDetail(state) {
				return state.detail;
			},
			'live:comments_lr': function liveComments_lr(state) {
				return state.comments_lr;
			},
			'live:comments_ac': function liveComments_ac(state) {
				return state.comments_ac;
			},
			'live:loading_lr': function liveLoading_lr(state) {
				return state.loading_lr;
			},
			'live:loading_ac': function liveLoading_ac(state) {
				return state.loading_ac;
			},
			'live:hasMore_lr': function liveHasMore_lr(state) {
				return state.hasMore_lr;
			},
			'live:hasMore_ac': function liveHasMore_ac(state) {
				return state.hasMore_ac;
			}
		}
	};
	
	exports.default = live;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _style = __webpack_require__(37);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _toast = __webpack_require__(38);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _regenerator = __webpack_require__(60);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(59);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _toConsumableArray2 = __webpack_require__(47);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _api = __webpack_require__(58);
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var normal = {
		state: {
			detail: {},
			comments: [],
			hasComments: false,
			params: {
				sysCode: '',
				categoryId: '',
				id: '',
				isTimeLimit: false
			}
	
		},
		mutations: {
			'normal:clear': function normalClear(state) {
				state.params.sysCode = '';
				state.params.categoryId = '';
				state.params.id = '';
				state.params.isTimeLimit = false, state.detail = {};
				state.comments = [];
				state.hasComments = false;
			},
			'normal:update:params': function normalUpdateParams(state, params) {
				state.params.sysCode = params.sysCode;
				state.params.categoryId = params.categoryId;
				state.params.id = params.id;
				state.params.isTimeLimit = params.isTimeLimit;
			},
			'normal:update:detail': function normalUpdateDetail(state, detail) {
				state.detail = detail;
			},
			'normal:update:comments': function normalUpdateComments(state) {
				var _state$comments;
	
				var comments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
				if (comments.length > 0) {
					state.hasComments = true;
				}
				(_state$comments = state.comments).push.apply(_state$comments, (0, _toConsumableArray3.default)(comments));
			}
		},
		actions: {
			'normal:init': function normalInit(_ref, params) {
				var _this = this;
	
				var commit = _ref.commit,
				    dispatch = _ref.dispatch;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									commit('normal:update:params', params);
	
									dispatch('normal:update:detail');
	
									dispatch('normal:update:comments');
	
								case 3:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this);
				}))();
			},
			'normal:update:detail': function normalUpdateDetail(_ref2) {
				var _this2 = this;
	
				var commit = _ref2.commit,
				    state = _ref2.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
					var res, data, medias_o, _res, _data;
	
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									if (!(state.params.sysCode === 'gov')) {
										_context2.next = 7;
										break;
									}
	
									_context2.next = 3;
									return api.getDetailGov({ articleId: state.params.id, categoryId: state.params.categoryId, sysCode: state.params.sysCode });
	
								case 3:
									res = _context2.sent;
	
									if (res.code === 0) {
										data = res.data;
										medias_o = data.mediaList || [];
	
										data.medias = medias_o.map(function (item, index) {
											return {
												index: index,
												image: item.image,
												description: item.description
											};
										});
										commit('normal:update:detail', data);
									}
									_context2.next = 18;
									break;
	
								case 7:
									if (!state.params.isTimeLimit) {
										_context2.next = 13;
										break;
									}
	
									_context2.next = 10;
									return api.getDetailPreview({ articleId: state.params.id, categoryId: state.params.categoryId, sysCode: state.params.sysCode });
	
								case 10:
									_context2.t0 = _context2.sent;
									_context2.next = 16;
									break;
	
								case 13:
									_context2.next = 15;
									return api.getDetail({ articleId: state.params.id, categoryId: state.params.categoryId, sysCode: state.params.sysCode });
	
								case 15:
									_context2.t0 = _context2.sent;
	
								case 16:
									_res = _context2.t0;
	
									if (_res.code === 0) {
										_data = _res.item;
	
										commit('normal:update:detail', _data);
									} else {
										(0, _toast2.default)(_res.msg);
									}
	
								case 18:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}))();
			},
			'normal:update:comments': function normalUpdateComments(_ref3) {
				var _this3 = this;
	
				var commit = _ref3.commit,
				    state = _ref3.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}))();
			}
		},
		getters: {
			'normal:detail': function normalDetail(state) {
				return state.detail;
			},
			'normal:comments': function normalComments(state) {
				return state.comments;
			},
			'normal:hasComments': function normalHasComments(state) {
				return state.hasComments;
			}
		}
	};
	
	exports.default = normal;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(60);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(59);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _api = __webpack_require__(58);
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var oneComment = {
		state: {
			id: '',
			detail: {},
			comments: []
		},
		mutations: {
			'oneComment:update': function oneCommentUpdate(state, payload) {
				console.log(payload);
				state.id = payload.id;
				state.detail = payload.detail;
				state.comments = payload.comments;
			}
		},
		actions: {
			'oneComment:init': function oneCommentInit(_ref, id) {
				var _this = this;
	
				var commit = _ref.commit;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
					var res, data, detail, comments;
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									_context.next = 2;
									return api.getCommentDetail({ commentId: id });
	
								case 2:
									res = _context.sent;
	
									if (res.result.code === 0) {
										data = res.data;
										detail = {};
	
										detail.articleId = data.articleId;
										detail.sysCode = data.sysCode;
	
										detail.title = data.title;
										comments = [data.comment];
	
										commit('oneComment:update', { id: id, detail: detail, comments: comments });
									}
	
								case 4:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this);
				}))();
			}
		},
		getters: {
			'oneComment:detail': function oneCommentDetail(state) {
				return state.detail;
			},
			'oneComment:comments': function oneCommentComments(state) {
				return state.comments;
			}
	
		}
	};
	
	exports.default = oneComment;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(60);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(59);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _api = __webpack_require__(58);
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paper = {
		state: {
			detail: {},
			params: {
				id: '',
				date: '',
				sysCode: ''
			}
		},
		mutations: {
			'paper:clear': function paperClear(state) {
				state.params.sysCode = '';
				state.params.date = '';
				state.params.id = '';
				state.detail = {};
			},
			'paper:update:params': function paperUpdateParams(state, params) {
				state.params.sysCode = params.sysCode;
				state.params.date = params.date;
				state.params.id = params.id;
			},
			'paper:update:detail': function paperUpdateDetail(state, detail) {
				state.detail = detail;
			}
		},
		actions: {
			'paper:init': function paperInit(_ref, params) {
				var _this = this;
	
				var commit = _ref.commit,
				    dispatch = _ref.dispatch;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									commit('paper:clear');
									commit('paper:update:params', params);
	
									dispatch('paper:update:detail');
	
								case 3:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this);
				}))();
			},
			'paper:update:detail': function paperUpdateDetail(_ref2) {
				var _this2 = this;
	
				var commit = _ref2.commit,
				    state = _ref2.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
					var res, data;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									_context2.next = 2;
									return api.getPagerDetail({ sysCode: state.params.sysCode, articleId: state.params.id, date: state.params.date, paperName: "cdrb", platform: "android" });
	
								case 2:
									res = _context2.sent;
	
									if (res.result.code == 0) {
										data = res.data;
	
										commit('paper:update:detail', data);
									}
	
								case 4:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}))();
			}
		},
		getters: {
			'paper:detail': function paperDetail(state) {
				return state.detail;
			}
		}
	};
	
	exports.default = paper;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Jt) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _regenerator = __webpack_require__(60);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(59);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _toConsumableArray2 = __webpack_require__(47);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _api = __webpack_require__(58);
	
	var api = _interopRequireWildcard(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var topic = {
		state: {
			id: '',
			subjectList: {},
			blocks: [],
			comments: [],
			hasComments: false,
			area: {
				show: false,
				id: '',
				next: '',
				title: '',
				list: [],
				index: ''
			}
		},
		mutations: {
			'topic:update:id': function topicUpdateId(state, id) {
				state.id = id;
			},
			'topic:update:list': function topicUpdateList(state, payload) {
				state.subjectList = payload.subjectList;
				state.blocks = payload.blocks;
			},
			'topic:update:comments': function topicUpdateComments(state, comments) {
				var _state$comments;
	
				if (comments.length > 0) {
					state.hasComments = true;
				}
				(_state$comments = state.comments).push.apply(_state$comments, (0, _toConsumableArray3.default)(comments));
			},
			'topic:show:area': function topicShowArea(state, payload) {
				var area = state.area;
				area.show = true;
				area.id = payload.id;
				area.next = payload.next;
				area.title = payload.title;
				area.index = payload.index;
			},
			'topic:update:topicList': function topicUpdateTopicList(state, _ref) {
				var more = _ref.more,
				    list = _ref.list;
	
	
				if (more.next) {
					if (list.length > 0) {
						var _state$blocks$state$a;
	
						(_state$blocks$state$a = state.blocks[state.area.index].articles).push.apply(_state$blocks$state$a, (0, _toConsumableArray3.default)(list));
						state.blocks[state.area.index].page = more;
					}
				} else {
					if (list.length > 0) {
						var _state$blocks$state$a2;
	
						(_state$blocks$state$a2 = state.blocks[state.area.index].articles).push.apply(_state$blocks$state$a2, (0, _toConsumableArray3.default)(list));
						state.blocks[state.area.index].page = more;
					}
				}
			},
			'topic:hide:area': function topicHideArea(state) {
				var area = state.area;
				area.show = false;
				area.id = '';
				area.title = '';
				area.maxid = '';
				area.list = [];
				area.hasMore = true;
			}
		},
		actions: {
			'topic:init': function topicInit(_ref2, id) {
				var _this = this;
	
				var commit = _ref2.commit,
				    dispatch = _ref2.dispatch;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
					return _regenerator2.default.wrap(function _callee$(_context) {
						while (1) {
							switch (_context.prev = _context.next) {
								case 0:
									commit('topic:update:id', id);
	
									dispatch('topic:update:list');
	
								case 2:
								case 'end':
									return _context.stop();
							}
						}
					}, _callee, _this);
				}))();
			},
			'topic:update:list': function topicUpdateList(_ref3) {
				var _this2 = this;
	
				var commit = _ref3.commit,
				    state = _ref3.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
					var res, subjectList, blocks;
					return _regenerator2.default.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									_context2.next = 2;
									return api.getSubjectList({ articleId: state.id, size: "5" });
	
								case 2:
									res = _context2.sent;
	
									if (res.code === 0) {
										subjectList = res.item;
										blocks = res.item.blocks || [];
	
										commit('topic:update:list', { subjectList: subjectList, blocks: blocks });
									}
	
								case 4:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this2);
				}))();
			},
			'topic:show:area': function topicShowArea(_ref4, area) {
				var _this3 = this;
	
				var commit = _ref4.commit,
				    dispatch = _ref4.dispatch;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
					return _regenerator2.default.wrap(function _callee3$(_context3) {
						while (1) {
							switch (_context3.prev = _context3.next) {
								case 0:
									console.log(area);
									commit('topic:show:area', area);
	
									dispatch('topic:update:topicList');
	
								case 3:
								case 'end':
									return _context3.stop();
							}
						}
					}, _callee3, _this3);
				}))();
			},
			'topic:update:topicList': function topicUpdateTopicList(_ref5) {
				var _this4 = this;
	
				var commit = _ref5.commit,
				    state = _ref5.state;
				return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
					var res, more, list;
					return _regenerator2.default.wrap(function _callee4$(_context4) {
						while (1) {
							switch (_context4.prev = _context4.next) {
								case 0:
									_context4.next = 2;
									return api.getTopicBlockList({ articleId: state.area.id, pageToken: state.area.next, size: "5" });
	
								case 2:
									res = _context4.sent;
	
									if (res.code === 0 && !Jt.array.isEmpty(res.items)) {
										more = res.page;
										list = res.items;
	
										commit('topic:update:topicList', { more: more, list: list });
									}
	
								case 4:
								case 'end':
									return _context4.stop();
							}
						}
					}, _callee4, _this4);
				}))();
			}
		},
		getters: {
			'topic:subjectList': function topicSubjectList(state) {
				return state.subjectList;
			},
			'topic:blocks': function topicBlocks(state) {
				return state.blocks;
			},
			'topic:comments': function topicComments(state) {
				return state.comments;
			},
			'topic:hasComments': function topicHasComments(state) {
				return state.hasComments;
			},
			'topic:area': function topicArea(state) {
				console.log(state.area.list);
				return state.area;
			}
		}
	};
	
	exports.default = topic;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 232,
		"./af.js": 232,
		"./ar": 239,
		"./ar-dz": 233,
		"./ar-dz.js": 233,
		"./ar-kw": 234,
		"./ar-kw.js": 234,
		"./ar-ly": 235,
		"./ar-ly.js": 235,
		"./ar-ma": 236,
		"./ar-ma.js": 236,
		"./ar-sa": 237,
		"./ar-sa.js": 237,
		"./ar-tn": 238,
		"./ar-tn.js": 238,
		"./ar.js": 239,
		"./az": 240,
		"./az.js": 240,
		"./be": 241,
		"./be.js": 241,
		"./bg": 242,
		"./bg.js": 242,
		"./bm": 243,
		"./bm.js": 243,
		"./bn": 245,
		"./bn-bd": 244,
		"./bn-bd.js": 244,
		"./bn.js": 245,
		"./bo": 246,
		"./bo.js": 246,
		"./br": 247,
		"./br.js": 247,
		"./bs": 248,
		"./bs.js": 248,
		"./ca": 249,
		"./ca.js": 249,
		"./cs": 250,
		"./cs.js": 250,
		"./cv": 251,
		"./cv.js": 251,
		"./cy": 252,
		"./cy.js": 252,
		"./da": 253,
		"./da.js": 253,
		"./de": 256,
		"./de-at": 254,
		"./de-at.js": 254,
		"./de-ch": 255,
		"./de-ch.js": 255,
		"./de.js": 256,
		"./dv": 257,
		"./dv.js": 257,
		"./el": 258,
		"./el.js": 258,
		"./en-au": 259,
		"./en-au.js": 259,
		"./en-ca": 260,
		"./en-ca.js": 260,
		"./en-gb": 261,
		"./en-gb.js": 261,
		"./en-ie": 262,
		"./en-ie.js": 262,
		"./en-il": 263,
		"./en-il.js": 263,
		"./en-in": 264,
		"./en-in.js": 264,
		"./en-nz": 265,
		"./en-nz.js": 265,
		"./en-sg": 266,
		"./en-sg.js": 266,
		"./eo": 267,
		"./eo.js": 267,
		"./es": 271,
		"./es-do": 268,
		"./es-do.js": 268,
		"./es-mx": 269,
		"./es-mx.js": 269,
		"./es-us": 270,
		"./es-us.js": 270,
		"./es.js": 271,
		"./et": 272,
		"./et.js": 272,
		"./eu": 273,
		"./eu.js": 273,
		"./fa": 274,
		"./fa.js": 274,
		"./fi": 275,
		"./fi.js": 275,
		"./fil": 276,
		"./fil.js": 276,
		"./fo": 277,
		"./fo.js": 277,
		"./fr": 280,
		"./fr-ca": 278,
		"./fr-ca.js": 278,
		"./fr-ch": 279,
		"./fr-ch.js": 279,
		"./fr.js": 280,
		"./fy": 281,
		"./fy.js": 281,
		"./ga": 282,
		"./ga.js": 282,
		"./gd": 283,
		"./gd.js": 283,
		"./gl": 284,
		"./gl.js": 284,
		"./gom-deva": 285,
		"./gom-deva.js": 285,
		"./gom-latn": 286,
		"./gom-latn.js": 286,
		"./gu": 287,
		"./gu.js": 287,
		"./he": 288,
		"./he.js": 288,
		"./hi": 289,
		"./hi.js": 289,
		"./hr": 290,
		"./hr.js": 290,
		"./hu": 291,
		"./hu.js": 291,
		"./hy-am": 292,
		"./hy-am.js": 292,
		"./id": 293,
		"./id.js": 293,
		"./is": 294,
		"./is.js": 294,
		"./it": 296,
		"./it-ch": 295,
		"./it-ch.js": 295,
		"./it.js": 296,
		"./ja": 297,
		"./ja.js": 297,
		"./jv": 298,
		"./jv.js": 298,
		"./ka": 299,
		"./ka.js": 299,
		"./kk": 300,
		"./kk.js": 300,
		"./km": 301,
		"./km.js": 301,
		"./kn": 302,
		"./kn.js": 302,
		"./ko": 303,
		"./ko.js": 303,
		"./ku": 304,
		"./ku.js": 304,
		"./ky": 305,
		"./ky.js": 305,
		"./lb": 306,
		"./lb.js": 306,
		"./lo": 307,
		"./lo.js": 307,
		"./lt": 308,
		"./lt.js": 308,
		"./lv": 309,
		"./lv.js": 309,
		"./me": 310,
		"./me.js": 310,
		"./mi": 311,
		"./mi.js": 311,
		"./mk": 312,
		"./mk.js": 312,
		"./ml": 313,
		"./ml.js": 313,
		"./mn": 314,
		"./mn.js": 314,
		"./mr": 315,
		"./mr.js": 315,
		"./ms": 317,
		"./ms-my": 316,
		"./ms-my.js": 316,
		"./ms.js": 317,
		"./mt": 318,
		"./mt.js": 318,
		"./my": 319,
		"./my.js": 319,
		"./nb": 320,
		"./nb.js": 320,
		"./ne": 321,
		"./ne.js": 321,
		"./nl": 323,
		"./nl-be": 322,
		"./nl-be.js": 322,
		"./nl.js": 323,
		"./nn": 324,
		"./nn.js": 324,
		"./oc-lnc": 325,
		"./oc-lnc.js": 325,
		"./pa-in": 326,
		"./pa-in.js": 326,
		"./pl": 327,
		"./pl.js": 327,
		"./pt": 329,
		"./pt-br": 328,
		"./pt-br.js": 328,
		"./pt.js": 329,
		"./ro": 330,
		"./ro.js": 330,
		"./ru": 331,
		"./ru.js": 331,
		"./sd": 332,
		"./sd.js": 332,
		"./se": 333,
		"./se.js": 333,
		"./si": 334,
		"./si.js": 334,
		"./sk": 335,
		"./sk.js": 335,
		"./sl": 336,
		"./sl.js": 336,
		"./sq": 337,
		"./sq.js": 337,
		"./sr": 339,
		"./sr-cyrl": 338,
		"./sr-cyrl.js": 338,
		"./sr.js": 339,
		"./ss": 340,
		"./ss.js": 340,
		"./sv": 341,
		"./sv.js": 341,
		"./sw": 342,
		"./sw.js": 342,
		"./ta": 343,
		"./ta.js": 343,
		"./te": 344,
		"./te.js": 344,
		"./tet": 345,
		"./tet.js": 345,
		"./tg": 346,
		"./tg.js": 346,
		"./th": 347,
		"./th.js": 347,
		"./tk": 348,
		"./tk.js": 348,
		"./tl-ph": 349,
		"./tl-ph.js": 349,
		"./tlh": 350,
		"./tlh.js": 350,
		"./tr": 351,
		"./tr.js": 351,
		"./tzl": 352,
		"./tzl.js": 352,
		"./tzm": 354,
		"./tzm-latn": 353,
		"./tzm-latn.js": 353,
		"./tzm.js": 354,
		"./ug-cn": 355,
		"./ug-cn.js": 355,
		"./uk": 356,
		"./uk.js": 356,
		"./ur": 357,
		"./ur.js": 357,
		"./uz": 359,
		"./uz-latn": 358,
		"./uz-latn.js": 358,
		"./uz.js": 359,
		"./vi": 360,
		"./vi.js": 360,
		"./x-pseudo": 361,
		"./x-pseudo.js": 361,
		"./yo": 362,
		"./yo.js": 362,
		"./zh-cn": 363,
		"./zh-cn.js": 363,
		"./zh-hk": 364,
		"./zh-hk.js": 364,
		"./zh-mo": 365,
		"./zh-mo.js": 365,
		"./zh-tw": 366,
		"./zh-tw.js": 366
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 763;


/***/ }),
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/bg.67a5221.png";

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAABWElEQVQ4T9XTP0iVYRTH8c/VsMElF5ts01Eaw9H+EJqI2BQRiItKS1PaLFHQ1mRTDrU4lpNQpENLgzi4OEg4OBRJGFII3ThwLrxc3vteFRo80/s+zznf55zzO6dWr9dr/oPVzgM4Kq83ii9m/Bh9eHiGztzCIkbwPeIb4KeYT+AzPDkF/A5WcBGbuI6DAHdgGfcLsAU8PwF8Em/Qlb67GMbXRsYX8tXxdIhezWGpAn4PrxGxYTu4gb1iK+I7SnmfpcT/XzzA2xL4FF6hM++2cRP7ZeLFWTfWcC0djnEX7wrwWbxEtDBsK6HfigmUzXEPPmIwHX9jNM8e4UWInndfcBs/mqtqtSCXsY7+DDhMkWYKgM85Xj/LdKjavCvYyNlujv2EMfxqJW67lR7IzHsLgNBgAkdV49gOHLFX8QGXsJpi/qmCNo9ble8Qor/TiElpayfJuC2kzOEfT2hl8dk3gIMAAAAASUVORK5CYII="

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAACs0lEQVQ4T3WUX0hTYRjGn/dsy6wkFEkh3TSwPOdsSjkTpMBR3hRYEERddpeSBt16M+/qxor+Qjd1ITiJELroKodmhZXVpmdnqc1tmhWWSejIufN9sT9nbPN47s7zPe/v+773fc4hzjnB4Jl3OPaZNe0cY5YXtqAvbORJapNOp7kiFmtnTNhl+6I8pULgd6ezOB6LucH4FRAVM4FaahXlvRFwQZLOMI4bAA4S4aFNVTvzgCFZrhYYe06gBh0gmISj1dPTH/KAfX0U9Xj6wdHDgfQNCQ9qVLUrC1y020uZxl5xQMoUvzGZTb1VU1OjhacLS9JN4ria0VcI5I7vLXlSNzHxNwuMiNIAgIvpzfDI6rB3YmiIFcIiknQWHM/SPh6CxdJu9fvnU+9EPAVckOVjjPGxDGwsVFlxos3r1bb0zeUyRX78/ArACuCfQJbm6oBP0X1ZYLReGuSE8wRwJtCRGkXxGQ5BljsY48OpjTluWYOBa7m+NNDtFiKDnl8ASgHM2NRA/XYRiYribQ7qTgEFOm5VlNdbgOGGhlrEN0OZhY8cdIeIL+8uKxsrHx9fyy2IiNIIgLakJhC6wIXVTWiTB1R1NtvDqCw3M429MzjVkgbu0s3J9bAo+QhwFHg5gXqtqnI9deWo3e5kCc0wuAAfsanqSR0QEaXPALIZzQ4DSJiwQ64K+mZoqampPL4eW96mbxu2yoo9yEw8KorDHNRh5BVAl6zBwONUbCKi9BZAi4FxxaYGynV9QZIuM477RkBOuFCrqp7cHL4EYMk387s2Ve3RtcXW1p3an9VPAA7lTReYLdphOVzp969nv5RvouP0JrR+AuoI+A3wgTVB6JUUZT23eK6xcb85nrhH4KcAJAg0KhDvrgoE5rLBzi0Iu1xFNV7vxnZZ1PXkb6uppITr/dVj8x8+tDEgbCJlPwAAAABJRU5ErkJggg=="

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAcCAYAAAAa/l2sAAAAAXNSR0IArs4c6QAABpFJREFUWEfNl2tsFGUUht/zzeyWlgKWixJE6w01Vv2FMREvlXgPJkazG0uhFXtZFdHU2qZidGZDpLg0VsAoLEWkQG13vJBI0IhJi/4QEPWHFg3e46UEY7GBhZbd+Y45092ySAulStJJk/3Rme975v3e854zxMyEUXo5jqM+OnhQ3ZaXpwOBgBZMGo3Att1hCFw4fGtSfi1mZfeLyqMOuB+2Q4fDYV1eu2n6Eeq90VX6i7b6yn2WZalRB0yeQYkfqlt/USKhQ1rpp5g56sOYuubl84+MGuBQNGpGQ6GE4BbXrLtDQz/JzLcB8IMoDtBzrcvLGwcDJlsMY3t/fJbrkULRqHHwjzxywsFjgaqXsg1jbAWBSgBczQILuABMEG+akjN24QnANkAeqA0mkn+dvQSRBOjsnEJpv859dnM+jvUWa7hPgHFeClSKL07AHoOwKitHtZ8ALJCZip5NYM+pRGxZMf++eM+VIHoS4IeZPQRJBxNADxFtM5mWbmwo/zoQiBknKmyD9hY4ZO5K5vn8Cd6wtKT7/7aEbYO6J73vW/XEPX0BK+b3Hf07oLXA4jqAJWvlWA0GfiJFK82crJaNdskBSQhJDg9YokQy7+HadeN6kaxmplnMiLU2VK4V4Mo1a3xSEP9FcQEFOtTevX+y4wTdudVN+dqgMtLuAwxcDkCOn6g/JrYTYbVp+Hc015f+5TF2dBh2YaGmWCxmBINBd/7TzRcn0fcoiCsYOAfALh/T4t5fJuyQDQR6TWWlF+Rneslm6DjeCIoWb7gWyUQIzMXMPAGAKKsIOMRKfUCGr/HN+tJPxQJXXSUvMkWLoAJO4qFwOHisqHb9fayTrwOcN+Ahop2GmV22uX7eXsuyTNi2Hkly2LZNcpxVL8Wyu7p6ZpIXQJjN7FmgfzQgHFBEbYnsCWEnHOwWroICuOmWnBZpQOGi6pbJyoiXupplsdzUDQmA3mOQ1dZQ/rUsYtsBUXlYcdefBDBEkEBV00TT1MXMqAJw8fHCIoH9DESr3MT4t5zG4FGvBw+RUJ6H06FdabdM7onHnyfmeQBEaa9iCfQKm+aK1mULfpb7BeTfb55pk/TQkm4ED9aumwntloIxB4T81L1C2kdAGytqzgHtfj1SdsiyWBUUODTU+h6wbCA+loVKa964tA+JJWAuGjgGor8I9JrB/mUbG0riUrEFBQWDLprOV/Gc2Oi7oxfepLV+HIS7wJydAfsnQG1+n29Vc32pzAlm96TrjZumHk6eSoyBWMuEDlavvlkpVeMpcvz6AWw0jB93bnPUvveIZbWbtl3ovWTmJUUuURoKb82OHz5wp0aynkFXZDQCsdTvIPXK/deVNQaD5MpaKATswpPXO2n9f3slGHSUpEKqny9n5msGVCH8rExaOOOOyz6UxaWYbNv2/ByNfm7m5f2o5aSKa9dOF6cx82MMnngCLFG7SVi+KVKxvT9yz6yjnjRLpDO5snKNLz7enOMiuQKgC1KbSvR8QcqoaYmUtS9auS1LjvCT/bmmNIJCyzLPPzJtNrMqZfDtDEyRyCKQArAfQCv7jFbXn/ulzA4SqZ2dAZZRYLhROei0ZttvZIXDC3q9YcTMXQiGdKLpAi1dCIR3ya+WtbxQvju9kdd0mO/SrB8BMAtA1nEI+l6xWp9j6OamSMVvgVjMmLo/11y56G6ZzoYN66XfUPGROe4VPR1dyoQqsAeRBMHHwNvjjtHCtS+XHwjVOeMPuYcWMLl1qcFFICRfk0T4hojslkjFO+lilY1PVVinUntIYGml4TB531Elz2yYlEj21YJRmyHHYYC3EFGTIhXUzOJZOXq5RX6PgrHVMH1LNr+44CvPr3yGcg5CftoBXoopFJqZmFuzegZD1TFQnFJaXqYPoE4QX5BS1pOVCd8wVKuf2NkYKf9WDlLUlQZ3Jn4dTOnTAmfm6vzFTVcnEnoFGLNTi6WPXuJNhhdNjD2kaJ0xNmtL/5TVbnZN20cjnUNOG2uDvVU6OWQYMfN7bmHwEgA3pJMj5VeXCB8rosWbIxU7RdGuadOM/wt0oIkNd2QMOo5yUt2wuLapNMlcTamMJqK/oWgDjxkbaQ0X/SGLC3A6o4cbWcO577SWSC8iRdj/6SQV7igzv2cRkwxK/CtYrYVSb7VGyjxYia3Af0iCEaXEEA+RbTumTF9z6169BNp3Kwx0JXppp9NY3i2NZOI12e5wWuxw1BxR0Q32kBSiAyBtEW8WkA/tQWaLkYIN9dw/25NzIxpd6vQAAAAASUVORK5CYII="

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic_default_common.e75d77a.png";

/***/ }),
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(732)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(409),
	  /* template */
	  __webpack_require__(838),
	  /* scopeId */
	  "data-v-1e48ea8f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(734)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(410),
	  /* template */
	  __webpack_require__(841),
	  /* scopeId */
	  "data-v-257f710e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(749)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(412),
	  /* template */
	  __webpack_require__(865),
	  /* scopeId */
	  "data-v-ccf1485e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(414),
	  /* template */
	  __webpack_require__(834),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(415),
	  /* template */
	  __webpack_require__(855),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(417),
	  /* template */
	  __webpack_require__(870),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(418),
	  /* template */
	  __webpack_require__(857),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(419),
	  /* template */
	  __webpack_require__(863),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(420),
	  /* template */
	  __webpack_require__(864),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(748)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(423),
	  /* template */
	  __webpack_require__(862),
	  /* scopeId */
	  "data-v-bdd94b2a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(740)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(424),
	  /* template */
	  __webpack_require__(850),
	  /* scopeId */
	  "data-v-50527d7c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(733)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(425),
	  /* template */
	  __webpack_require__(839),
	  /* scopeId */
	  "data-v-239e7c7c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(427),
	  /* template */
	  __webpack_require__(844),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(756)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(428),
	  /* template */
	  __webpack_require__(873),
	  /* scopeId */
	  "data-v-ffb2961a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(730)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(429),
	  /* template */
	  __webpack_require__(836),
	  /* scopeId */
	  "data-v-122e29da",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(742)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(430),
	  /* template */
	  __webpack_require__(854),
	  /* scopeId */
	  "data-v-5d3d08e7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(752)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(431),
	  /* template */
	  __webpack_require__(867),
	  /* scopeId */
	  "data-v-d9080016",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(739)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(432),
	  /* template */
	  __webpack_require__(847),
	  /* scopeId */
	  "data-v-47a3804c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(744)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(433),
	  /* template */
	  __webpack_require__(858),
	  /* scopeId */
	  "data-v-6c5ca4ae",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(736)
	__webpack_require__(735)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(434),
	  /* template */
	  __webpack_require__(842),
	  /* scopeId */
	  "data-v-2ba3a936",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(435),
	  /* template */
	  __webpack_require__(852),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(436),
	  /* template */
	  __webpack_require__(845),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(754)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(438),
	  /* template */
	  __webpack_require__(871),
	  /* scopeId */
	  "data-v-eb72ad90",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(743)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(439),
	  /* template */
	  __webpack_require__(856),
	  /* scopeId */
	  "data-v-62c31b58",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(731)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(440),
	  /* template */
	  __webpack_require__(837),
	  /* scopeId */
	  "data-v-1a276728",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(745)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(441),
	  /* template */
	  __webpack_require__(859),
	  /* scopeId */
	  "data-v-6e2789d3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(746)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(442),
	  /* template */
	  __webpack_require__(860),
	  /* scopeId */
	  "data-v-79cd47af",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(747)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(443),
	  /* template */
	  __webpack_require__(861),
	  /* scopeId */
	  "data-v-7d3312ce",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(444),
	  /* template */
	  __webpack_require__(851),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(738)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(445),
	  /* template */
	  __webpack_require__(846),
	  /* scopeId */
	  "data-v-413b1732",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(751)
	__webpack_require__(750)
	
	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(446),
	  /* template */
	  __webpack_require__(866),
	  /* scopeId */
	  "data-v-d86e5e6c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(4)(
	  /* script */
	  __webpack_require__(448),
	  /* template */
	  __webpack_require__(849),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 834 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "comment-block comments-normal"
	  }, _vm._l((_vm.comments), function(item, index) {
	    return _c('comment-item', {
	      key: item.id,
	      attrs: {
	        "item": item
	      }
	    })
	  }), 1)
	},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.pageCls
	  }, [_c('div', {
	    staticClass: "g-main"
	  }, [(_vm.showAppTopLink && !_vm.$route.query.isGovPreviewPage) ? _c('a', {
	    staticClass: "app-top-link openApp",
	    attrs: {
	      "href": "javascript:;"
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.showAppBotLink) ? _c('a', {
	    staticClass: "app-bot-link openApp",
	    attrs: {
	      "href": "javascript:;",
	      "id": "openApp"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.appBotLinkText) + "\n            ")]) : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ['news-item', 'news-' + _vm.type]
	  }, [_c('news-normal', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-common', {
	    attrs: {
	      "type": "img",
	      "has-comments": _vm.hasComments,
	      "detail": _vm.detail
	    }
	  }, [_c('div', {
	    staticClass: "m-header"
	  }, [_c('h2', {
	    staticClass: "title f-taj"
	  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('div', {
	    staticClass: "info"
	  }, [_c('span', {
	    staticClass: "time"
	  }, [_vm._v(_vm._s(_vm.getTime(_vm.detail.date)))]), _vm._v(" "), (_vm.detail.authors) ? _c('span', {
	    staticClass: "authors"
	  }, [_vm._v(_vm._s(_vm.detail.authors))]) : _vm._e(), _vm._v(" "), (_vm.detail.source) ? _c('span', {
	    staticClass: "copyfrom"
	  }, [_vm._v(_vm._s(_vm.detail.source))]) : _vm._e()])]), _vm._v(" "), (_vm.detail.type == 'image') ? _c('div', {
	    staticClass: "m-img"
	  }, [_c('div', {
	    staticClass: "swiper-container"
	  }, [_c('div', {
	    staticClass: "swiper-wrapper"
	  }, _vm._l((_vm.detail.medias), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "swiper-slide"
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.webp(item.image)
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "summary tj"
	    }, [_c('pre', {
	      staticClass: "f-pre"
	    }, [_vm._v(_vm._s(item.description))])])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "swiper-pagination"
	  })])]) : _vm._e(), _vm._v(" "), _c('news-related', {
	    attrs: {
	      "list": _vm.detail.extend
	    }
	  }), _vm._v(" "), _c('comment-normal', {
	    attrs: {
	      "comments": _vm.comments
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "app",
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.isPreviewPage) ? _c('div', {
	    staticClass: "preview"
	  }, [_vm._v("内部链接 请勿分享给机构外部人员使用")]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "wrapper",
	    staticClass: "wrapper",
	    style: ({
	      height: _vm.wrapperHeight + 'px'
	    })
	  }, [(_vm.list.length > 0) ? _c('ul', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadMore),
	      expression: "loadMore"
	    }],
	    ref: "viewBox",
	    staticClass: "live-room",
	    attrs: {
	      "infinite-scroll-disabled": "loading",
	      "infinite-scroll-distance": "50"
	    }
	  }, [(_vm.top) ? _c('li', {
	    staticClass: "flex top"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "avatar",
	    style: ({
	      backgroundImage: ("url(" + (_vm.top.userIcon ? _vm.top.userIcon: _vm.head) + ")")
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "job"
	  }, [_vm._v(_vm._s(_vm.top.userType === 'host' ? '主持人' : '嘉宾'))])]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "flex-default"
	  }, [_c('div', {
	    staticClass: "name ellipsis"
	  }, [_vm._v("\n                        " + _vm._s(_vm.top.userName) + "\n                        "), _c('div', {
	    staticClass: "i"
	  }, [_vm._v("置顶")])]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(_vm.top.date))))])]), _vm._v(" "), _c('div', {
	    staticClass: "content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.top.content)
	    }
	  }), _vm._v(" "), (_vm.top && !!_vm.top.medias && _vm.top.medias.type === 'video') ? _c('div', {
	    staticClass: "video-wrap content video-content"
	  }, [_c('p', {
	    staticClass: "common-video-box"
	  }, [_c('video', {
	    staticClass: "videoClass common-video live-top-video",
	    staticStyle: {
	      "object-fit": "fill"
	    },
	    attrs: {
	      "id": _vm.top.id,
	      "src": _vm.top.medias.url,
	      "poster": _vm.top.medias.coverImg,
	      "x-webkit-airplay": "allow",
	      "controlslist": "nodownload",
	      "x5-video-player-fullscreen": "false",
	      "x5-video-orientation": "portraint",
	      "x5-video-player-type": "h5-page",
	      "webkit-playsinline": "",
	      "controls": "",
	      "playsinline": "",
	      "preload": "auto"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (!!_vm.top && !!_vm.top.medias && _vm.top.medias.type === 'audio') ? _c('div', {
	    staticClass: "content"
	  }, [_c('audio', {
	    staticClass: "audioClass",
	    attrs: {
	      "src": _vm.top.medias.url,
	      "controls": "",
	      "controlslist": "nodownload"
	    }
	  })]) : (!!_vm.top.image) ? _c('div', {
	    staticClass: "content"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "60vw",
	      "height": "35vw"
	    },
	    attrs: {
	      "src": _vm.top.image,
	      "alt": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showGallary(_vm.top.image)
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.top.replies), function(replie) {
	    return _c('div', {
	      key: replie.id,
	      staticClass: "reply"
	    }, [_c('p', [_c('span', [_vm._v("回复：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(replie.userName))]), _vm._v("\n                        " + _vm._s(replie.content) + "\n                        "), (replie.image) ? _c('img', {
	      staticStyle: {
	        "width": "60vw",
	        "height": "35vw"
	      },
	      attrs: {
	        "src": replie.image,
	        "alt": ""
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showGallary(replie.image)
	        }
	      }
	    }) : _vm._e()])])
	  })], 2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(item) {
	    return _c('li', {
	      key: item.id,
	      staticClass: "flex"
	    }, [_c('div', {
	      staticClass: "left"
	    }, [_c('div', {
	      staticClass: "avatar",
	      style: ({
	        backgroundImage: ("url(" + (item.userIcon ? item.userIcon: _vm.head) + ")")
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "job"
	    }, [_vm._v(_vm._s(item.userType === 'host' ? '主持人' : '嘉宾'))])]), _vm._v(" "), _c('div', {
	      staticClass: "right"
	    }, [_c('div', {
	      staticClass: "flex-default"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(item.date))))])]), _vm._v(" "), _c('div', {
	      staticClass: "content",
	      domProps: {
	        "innerHTML": _vm._s(item.content)
	      }
	    }), _vm._v(" "), (!!item.image) ? _c('div', {
	      staticClass: "content"
	    }, [_c('img', {
	      staticStyle: {
	        "width": "60vw",
	        "height": "35vw"
	      },
	      attrs: {
	        "src": item.image
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showGallary(item.image)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (!!item && !!item.medias && item.medias.type === 'video') ? _c('div', {
	      staticClass: "video-wrap content video-content"
	    }, [_c('p', {
	      staticClass: "common-video-box"
	    }, [_c('video', {
	      staticClass: "videoClass common-video",
	      staticStyle: {
	        "object-fit": "fill"
	      },
	      attrs: {
	        "src": item.medias.url,
	        "poster": item.medias.coverImg,
	        "controlslist": "nodownload",
	        "x-webkit-airplay": "allow",
	        "webkit-playsinline": "playsinline",
	        "x5-video-orientation": "portraint",
	        "x5-video-player-type": "h5-page",
	        "x5-video-player-fullscreen": "false",
	        "webkit-appearance": "none",
	        "playsinline": "",
	        "controls": "",
	        "preload": "auto"
	      }
	    })])]) : _vm._e(), _vm._v(" "), (!!item && !!item.medias && item.medias.type === 'audio') ? _c('div', {
	      staticClass: "content"
	    }, [_c('audio', {
	      staticClass: "audioClass",
	      attrs: {
	        "src": item.medias.url,
	        "controls": "",
	        "controlslist": "nodownload"
	      }
	    })]) : _vm._e(), _vm._v(" "), _vm._l((item.replies), function(replie) {
	      return _c('div', {
	        key: replie.id,
	        staticClass: "reply"
	      }, [_c('p', [_c('span', [_vm._v("回复：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(replie.userName))]), _vm._v("\n                        " + _vm._s(replie.content) + "\n                    ")])])
	    })], 2)])
	  })], 2) : _c('div', {
	    class: ['null-data', 'share-null-data']
	  }), _vm._v(" "), (_vm.loading) ? _c('p', {
	    staticClass: "loading"
	  }, [_c('mt-spinner', {
	    attrs: {
	      "type": "fading-circle"
	    }
	  }), _vm._v("加载中...\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAll) ? _c('p', {
	    staticClass: "loading"
	  }, [_vm._v("已显示全部内容")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.show) ? _c('div', {
	    staticClass: "m-comment"
	  }, [_c('h4', {
	    staticClass: "m-bt"
	  }, [_c('span', {
	    staticClass: "u-tt"
	  }, [_vm._v(_vm._s(_vm.blockTitle))])]), _vm._v(" "), _c('comment-block', {
	    attrs: {
	      "comments": _vm.comments
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "c-m-audio"
	  }, [_c('audio', {
	    ref: "audio",
	    attrs: {
	      "src": _vm.src
	    },
	    on: {
	      "loadedmetadata": _vm.onLoadedmetadata,
	      "canplay": _vm.onCanplay,
	      "timeupdate": _vm.onTimeupdate
	    }
	  }, [_vm._v("\n\t\t您的浏览器版本过低，不识别audio标签\n\t")]), _vm._v(" "), _c('div', {
	    staticClass: "flex flex-main-justify control"
	  }, [_c('span', {
	    staticClass: "status prev",
	    on: {
	      "click": function($event) {
	        return _vm.stepPlayer(-10)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    class: ['status', _vm.status ? 'play' : 'pause'],
	    on: {
	      "click": _vm.onToggle
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "status next",
	    on: {
	      "click": function($event) {
	        return _vm.stepPlayer(10)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    ref: "bar",
	    staticClass: "bar",
	    on: {
	      "click": function($event) {
	        return _vm.onBarClick($event)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "buffer",
	    style: ({
	      width: _vm.bw_f
	    })
	  }), _vm._v(" "), _c('span', {
	    staticClass: "progress",
	    style: ({
	      width: _vm.pw_c_f
	    })
	  }), _vm._v(" "), _c('span', {
	    ref: "dot",
	    staticClass: "dot",
	    style: ({
	      left: _vm.dl_f
	    }),
	    on: {
	      "touchstart": function($event) {
	        return _vm.onStart($event)
	      },
	      "touchmove": function($event) {
	        return _vm.onMove($event)
	      },
	      "touchend": function($event) {
	        return _vm.onEnd($event)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "time-c"
	  }, [_vm._v(_vm._s(_vm.currentTime_f))]), _vm._v(" "), _c('span', {
	    staticClass: "time-t"
	  }, [_vm._v(_vm._s(_vm.duration_f))])])
	},staticRenderFns: []}

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper"
	  }, [_c('van-pull-refresh', {
	    attrs: {
	      "success-text": "刷新成功"
	    },
	    on: {
	      "refresh": _vm.onRefresh
	    },
	    model: {
	      value: (_vm.isLoading),
	      callback: function($$v) {
	        _vm.isLoading = $$v
	      },
	      expression: "isLoading"
	    }
	  }, [_c('div', {
	    staticClass: "hours_header"
	  }, [_c('img', {
	    ref: "imgHight",
	    staticClass: "bg_header_img",
	    style: ('background:#F6F6F6'),
	    attrs: {
	      "src": __webpack_require__(767)
	    },
	    on: {
	      "load": _vm.loadImg
	    }
	  })]), _vm._v(" "), _c('section', {
	    staticClass: "tab_list",
	    attrs: {
	      "id": "list_scroll"
	    }
	  }, [(_vm.data_.length > 0 || _vm.dataList.length > 0) ? _c('van-tabs', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadMore),
	      expression: "loadMore"
	    }],
	    attrs: {
	      "infinite-scroll-disabled": "loading",
	      "infinite-scroll-distance": "50"
	    },
	    on: {
	      "click": _vm.changeID
	    },
	    model: {
	      value: (_vm.active),
	      callback: function($$v) {
	        _vm.active = $$v
	      },
	      expression: "active"
	    }
	  }, [_vm._l(((_vm.data_.slice(0, 1))), function(v, index) {
	    return _c('van-tab', {
	      key: index,
	      attrs: {
	        "title": v.categoryInfo.name
	      }
	    }, [_c('ul', _vm._l((v.list), function(i, index) {
	      return _c('div', {
	        key: index
	      }, [_c('h2', {
	        staticClass: "date_",
	        staticStyle: {
	          "margin": "25px 0"
	        }
	      }, [_vm._v(_vm._s(index))]), _vm._v(" "), _vm._l((i), function(article, index) {
	        return _c('div', {
	          key: index,
	          staticClass: "hours_list"
	        }, [_c('div', {
	          staticClass: "time_red"
	        }, [_vm._v(_vm._s(_vm.getTime(article.date)))]), _vm._v(" "), _c('li', {
	          staticClass: "flex flex-main-justify",
	          on: {
	            "click": function($event) {
	              return _vm.goPath(article)
	            }
	          }
	        }, [_c('div', {
	          staticClass: "info",
	          staticStyle: {
	            "width": "100%"
	          }
	        }, [_c('div', {
	          class: ["title", "mult_line_ellipsis", article.images && article.images.length > 0 ? "min_height" : ""]
	        }, [(article.tags && article.type === 'subject') ? _c('span', {
	          staticClass: "tag_label_2"
	        }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
	          staticClass: "flex date"
	        }, [_c('time', [_vm._v(_vm._s(_vm._f("dateComparedTime")(_vm.getDate(article.date))))]), _vm._v(" "), _c('span', {
	          staticClass: "hours_tag likes_"
	        }, [_vm._v(_vm._s(_vm.getCount(article.likes)))]), _vm._v(" "), _c('span', {
	          staticClass: "comments hours_tag"
	        }, [_vm._v(_vm._s(_vm.getCount(article.comments)))])])]), _vm._v(" "), (article.images) ? _c('div', {
	          staticClass: "thumbnail",
	          style: ({
	            backgroundImage: 'url(' + article.images[0] + ')'
	          })
	        }, [_c('i', {
	          class: [article.type + '-icon']
	        })]) : _vm._e()])])
	      })], 2)
	    }), 0)])
	  }), _vm._v(" "), _vm._l((_vm.nav), function(v) {
	    return _c('van-tab', {
	      key: v.id,
	      attrs: {
	        "title": v.name
	      }
	    }, [_c('ul', _vm._l((_vm.dataList.list), function(i, index) {
	      return _c('div', {
	        key: index
	      }, [_c('h2', {
	        staticClass: "date_",
	        staticStyle: {
	          "margin": "25px 0"
	        }
	      }, [_vm._v(_vm._s(index))]), _vm._v(" "), _vm._l((i), function(article, index) {
	        return _c('div', {
	          key: index,
	          staticClass: "hours_list"
	        }, [_c('div', {
	          staticClass: "time_red"
	        }, [_vm._v(_vm._s(_vm.getTime(article.date)))]), _vm._v(" "), _c('li', {
	          staticClass: "flex flex-main-justify",
	          on: {
	            "click": function($event) {
	              return _vm.goPath(article)
	            }
	          }
	        }, [_c('div', {
	          staticClass: "info",
	          staticStyle: {
	            "width": "100%"
	          }
	        }, [_c('div', {
	          class: ["title", "mult_line_ellipsis", article.images && article.images.length > 0 ? "min_height" : ""]
	        }, [(article.tags && article.type === 'subject') ? _c('span', {
	          staticClass: "tag_label_2"
	        }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
	          staticClass: "flex date"
	        }, [_c('time', [_vm._v(_vm._s(_vm._f("dateComparedTime")(_vm.getDate(article.date))))]), _vm._v(" "), _c('span', {
	          staticClass: "hours_tag likes_"
	        }, [_vm._v(_vm._s(_vm.getCount(article.likes)))]), _vm._v(" "), _c('span', {
	          staticClass: "comments hours_tag"
	        }, [_vm._v(_vm._s(_vm.getCount(article.hits)))])])]), _vm._v(" "), (article.images) ? _c('div', {
	          staticClass: "thumbnail",
	          style: ({
	            backgroundImage: 'url(' + article.images[0] + ')'
	          })
	        }, [_c('i', {
	          class: [article.type + '-icon']
	        })]) : _vm._e()])])
	      })], 2)
	    }), 0)])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.noData == 0 || _vm.noData_ == 0) ? _c('div', {
	    staticClass: "null-data",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("暂无相关内容")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('p', {
	    staticClass: "loading",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('spinner', {
	    attrs: {
	      "type": "fading-circle"
	    }
	  }), _vm._v("\n            加载中...\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAll) ? _c('p', {
	    staticClass: "loading",
	    staticStyle: {
	      "text-align": "center",
	      "margin-bottom": "50px"
	    }
	  }, [_vm._v("已显示全部内容")]) : _vm._e()], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.vodeOption) ? _c('div', {
	    staticClass: "ballot"
	  }, [_c('div', {
	    staticClass: "ballot-title"
	  }, [_c('p', [_vm._v(_vm._s(_vm.vodeOption.title))])]), _vm._v(" "), (_vm.isResult) ? _c('div', {
	    staticClass: "ballot-result"
	  }, [(_vm.vodeOption.options.length > 0) ? _c('i') : _vm._e(), _vm._v(" "), _vm._l((_vm.vodeOption.options), function(item) {
	    return _c('div', {
	      key: item.id,
	      class: _vm.voteSelectedList.indexOf(item.id + '') >= 0 ?
	        (item.imageUrl ? 'item item-checked imageUrl' : _vm.isSharePage ? 'item noimageUrl' : 'item item-checked noimageUrl') :
	        (item.imageUrl ? 'item  imageUrl' : _vm.isSharePage ? 'item  noimageUrl' : 'item  noimageUrl'),
	      style: (_vm.voteSelectedList.indexOf(item.id + '') >= 0 ?
	        'background:linear-gradient(to right, rgba(237,244,254,1)' + item.percentage + '%, rgba(255,255,255,1)' + item.percentage + '%' :
	        'background:linear-gradient(to right, rgba(249,249,249,1)' + item.percentage + '%, rgba(255,255,255,1)' + item.percentage + '%')
	    }, [(item.imageUrl) ? _c('div', {
	      staticClass: "itemImg"
	    }, [_c('img', {
	      attrs: {
	        "src": item.imageUrl
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "item-title"
	    }, [_c('span', {
	      staticStyle: {
	        "-webkit-box-orient": "vertical",
	        "text-align": "left"
	      }
	    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (_vm.voteSelectedList.indexOf(item.id + '') >= 0) ? _c('img', {
	      staticClass: "votechecked-img",
	      attrs: {
	        "src": _vm.voteChecked
	      }
	    }) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "item-percentage"
	    }, [_vm._v(_vm._s(item.percentage || '0.0') + "%")])])
	  })], 2) : _c('div', {
	    staticClass: "ballot-list",
	    staticStyle: {
	      "position": "relative"
	    }
	  }, [(_vm.vodeOption.type == 'radio') ? _c('div', [(_vm.vodeOption.options.length > 0) ? _c('i') : _vm._e(), _vm._v(" "), _vm._l((_vm.vodeOption.options), function(item) {
	    return _c('div', {
	      key: item.id,
	      class: item.imageUrl ? 'item imageUrl' : 'item noimageUrl',
	      on: {
	        "click": function($event) {
	          return _vm.addVote(item, 'radio')
	        }
	      }
	    }, [(item.imageUrl) ? _c('div', {
	      staticClass: "itemImg"
	    }, [_c('img', {
	      attrs: {
	        "src": item.imageUrl
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "item-title"
	    }, [_c('span', {
	      staticStyle: {
	        "-webkit-box-orient": "vertical"
	      }
	    }, [_vm._v(_vm._s(item.title))])])])
	  })], 2) : (_vm.vodeOption.type == 'checkbox') ? _c('div', [(_vm.vodeOption.options.length > 0) ? _c('i', {
	    staticStyle: {
	      "padding": "0 4px",
	      "left": "-6px"
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.vodeOption.options), function(item) {
	    return _c('div', {
	      key: item.id,
	      staticClass: "checkbox-box",
	      on: {
	        "click": function($event) {
	          return _vm.handleItemClick(item.id)
	        }
	      }
	    }, [_c('div', {
	      class: item.imageUrl ? 'checkbox-item item imageUrl' : 'checkbox-item item noimageUrl',
	      staticStyle: {
	        "padding": "0.333333rem 0"
	      }
	    }, [_c('div', {
	      staticClass: "checkbox"
	    }, [_c('span', {
	      class: _vm.voteSelectedList.indexOf(item.id + '') >= 0 ? 'checked' : ''
	    })]), _vm._v(" "), (item.imageUrl) ? _c('div', {
	      staticClass: "itemImg"
	    }, [_c('img', {
	      attrs: {
	        "src": item.imageUrl
	      }
	    })]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "item-title"
	    }, [_c('span', {
	      staticStyle: {
	        "-webkit-box-orient": "vertical"
	      }
	    }, [_vm._v(_vm._s(item.title))])])])])
	  }), _vm._v(" "), (!_vm.isSharePage) ? _c('div', {
	    staticClass: "btn-ok",
	    on: {
	      "click": function($event) {
	        return _vm.addVote([], 'checkbox')
	      }
	    }
	  }, [_vm._v("投票")]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('dialogComponent', {
	    attrs: {
	      "params": _vm.dialogParams,
	      "is-show": _vm.isShowDialog
	    },
	    on: {
	      "on-close": _vm.closeDialog,
	      "on-ok": _vm.okDialog
	    }
	  }, [_c('div', {
	    staticClass: "dialog_publish_main",
	    attrs: {
	      "slot": "main"
	    },
	    slot: "main"
	  }, [_vm._v("\n\t\t\t\t即将离开当前页面"), _c('br'), _vm._v("打开“成都日报锦观”客户端\n\t\t\t")])])], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.show) ? _c('div', {
	    staticClass: "m-votes-news"
	  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.votesList), function(item, index) {
	    return _c('div', {
	      key: item.id,
	      staticClass: "survey_block"
	    }, [_c('div', {
	      staticClass: "surveyItem_wrap"
	    }, [_c('h4', {
	      staticClass: "survey_title"
	    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('ul', {
	      staticClass: "items items_result"
	    }, _vm._l((item.options), function(key, value) {
	      return _c('li', {
	        key: key.id
	      }, [_c('h5', [_vm._v(_vm._s(value + 1) + "." + _vm._s(key.title))]), _vm._v(" "), (_vm.isShowResult) ? _c('div', {
	        staticClass: "proportion"
	      }, [_c('span', {
	        staticClass: "bar",
	        style: ({
	          width: (key.preo_val) + '%'
	        })
	      }), _vm._v(" "), _c('span', {
	        staticClass: "preo_val"
	      }, [_vm._v(_vm._s(key.preo_val) + "%")])]) : _vm._e()])
	    }), 0)])])
	  })], 2) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "m-bt"
	  }, [_c('span', {
	    staticClass: "u-tt"
	  }, [_vm._v("用户调查")])])
	}]}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-common', {
	    attrs: {
	      "type": "ask-topic",
	      "has-comments": _vm.hasComments,
	      "detail": _vm.detail,
	      "auto-open-app": false
	    }
	  }, [_c('div', {
	    staticClass: "m-focus bg-d",
	    style: ({
	      height: _vm.focusImgH
	    })
	  }, [_c('div', {
	    staticClass: "bg-c",
	    style: ({
	      backgroundImage: 'url(' + _vm.webp(_vm.detail.image) + ')'
	    })
	  }), _vm._v(" "), _c('span', {
	    staticClass: "praise-num"
	  }, [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.detail.false_zan_num)))]), _vm._v(" "), _c('h4', {
	    staticClass: "title f-toe1"
	  }, [_vm._v(_vm._s(_vm.detail.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "m-desc"
	  }, [_c('div', {
	    staticClass: "text f-taj",
	    domProps: {
	      "innerHTML": _vm._s(_vm.detail.interpretation)
	    }
	  }), _vm._v(" "), _c('a', {
	    staticClass: "more-btn"
	  })]), _vm._v(" "), (_vm.showRelated) ? _c('div', {
	    staticClass: "m-related"
	  }, [_c('h4', {
	    staticClass: "m-bt"
	  }, [_c('span', {
	    staticClass: "u-tt"
	  }, [_vm._v("相关问题")])]), _vm._v(" "), _c('ul', _vm._l((_vm.related), function(item, index) {
	    return _c('li', [_c('a', {
	      class: ['f-cb', 'ask-link', 'status-' + item.status]
	    }, [(item.image) ? _c('div', {
	      staticClass: "f-fl col-l bg-d"
	    }, [_c('div', {
	      staticClass: "bg-c",
	      style: ({
	        backgroundImage: 'url(' + _vm.webp(item.image) + ')'
	      })
	    })]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "f-toe2 col-m"
	    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
	      staticClass: "info-l f-toe1"
	    }, [(item.status + '' === '3') ? _c('span', [_vm._v(_vm._s(item.rep_user_name) + "回复")]) : _vm._e(), _vm._v(" \n\t\t\t\t")]), _vm._v(" "), _c('div', {
	      staticClass: "info-r"
	    }, [_c('span', {
	      staticClass: "praise-num"
	    }, [_vm._v(_vm._s(_vm._f("numberFormat")(item.like_num)))]), _vm._v(" "), _c('span', {
	      staticClass: "comment-num"
	    }, [_vm._v(_vm._s(_vm._f("numberFormat")(item.comment_num)))])])])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('comment-normal', {
	    attrs: {
	      "comments": _vm.comments
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-common', {
	    attrs: {
	      "type": "normal",
	      "showAppTopLink": _vm.isSharePage,
	      "showAppBotLink": _vm.isSharePage,
	      "detail": _vm.data
	    }
	  }, [_c('div', {
	    staticClass: "theme"
	  }, [_c('div', {
	    staticClass: "theme__top"
	  }, [_c('div', {
	    staticClass: "theme_header"
	  }, [(_vm.data.headImage) ? _c('img', {
	    staticClass: "bg_header_img",
	    style: ('background:#F6F6F6'),
	    attrs: {
	      "src": _vm.data.headImage
	    },
	    on: {
	      "load": _vm.loadImg
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "theme_header_tip"
	  }, [_c('span', {
	    staticClass: "tip"
	  }, [_vm._v("#话题")]), _vm._v(" "), _c('span', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.data.hits)), _c('span', {
	    staticClass: "num_tip"
	  }, [_vm._v("人参与讨论")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "title-area"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.data.viewType == 'bigimage' ? (_vm.data.showTitle ? _vm.data.title : '') : (_vm.data.showTitle ? _vm.data.listTitle : _vm.data.title)))]), _vm._v(" "), _c('div', {
	    staticClass: "description_content"
	  }, [_c('div', {
	    class: _vm.isHideDescFlag ? 'description mult_line_ellipsis' : 'description',
	    domProps: {
	      "innerHTML": _vm._s(_vm.data.description && _vm.data.description.replace(/(\r\n|\n|\r)/gm, '<br />'))
	    }
	  }), _vm._v(" "), (_vm.isNeedUnfold) ? _c('div', {
	    class: _vm.isHideDescFlag ? 'unfold' : 'fold',
	    on: {
	      "click": _vm.unfold
	    }
	  }, [_vm._v(_vm._s(_vm.unfoldText) + " "), _c('span', {
	    staticClass: "arrow-down"
	  })]) : _vm._e()])]), _vm._v(" "), (_vm.data.hasVote) ? _c('PageVote', {
	    attrs: {
	      "voteObj": _vm.data
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "list"
	  }, [_c('theme-list', {
	    attrs: {
	      "sysCode": _vm.data.sysCode
	    },
	    on: {
	      "on-openApp": _vm.openDialog
	    }
	  })], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    ref: "wrapper",
	    staticClass: "theme-list wrapper"
	  }, [_c('ul', {
	    staticClass: "tab-wrap"
	  }, _vm._l((_vm.tabList), function(item) {
	    return _c('li', {
	      key: item.key,
	      class: _vm.activeTab === item.key ? 'tab-wrap__item active' : 'tab-wrap__item',
	      on: {
	        "click": function($event) {
	          return _vm.handleTabClick(item.key)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(item.text) + "\n        ")])
	  }), 0), _vm._v(" "), (_vm.activeTab === '0') ? _c('div', [(_vm.hotCommentsList.length > 0) ? [_c('div', {
	    staticClass: "comments-title "
	  }, [_c('img', {
	    staticClass: "icon_hot",
	    attrs: {
	      "src": _vm.hotImg
	    }
	  }), _vm._v("\n                热门留言\n                ")]), _vm._v(" "), _c('ul', _vm._l((_vm.hotCommentsList), function(item, index) {
	    return _c('li', {
	      key: index
	    }, [_c('header', {
	      staticClass: "flex flex-cross-center flex-main-justify"
	    }, [_c('div', {
	      staticClass: "flex flex-cross-center"
	    }, [_c('div', {
	      staticClass: "avatar",
	      style: ({
	        backgroundImage: ("url(" + (item.userIcon?item.userIcon:_vm.icon) + ")")
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "info-area"
	    }, [_c('div', {
	      staticClass: "name ellipsis"
	    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('div', {
	      staticClass: "time ellipsis"
	    }, [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(item.date))))])])]), _vm._v(" "), _c('div', {
	      staticClass: "like flex flex-cross-center"
	    }, [_c('span', {
	      class: [item.isLike ? 'active-num' : 'num']
	    }, [_vm._v(_vm._s(_vm.getLikesCount(item.likes + '')))]), _vm._v(" "), _c('i', {
	      class: [item.isLike ? 'active-good' : 'good']
	    })])]), _vm._v(" "), _c('section', [_c('themeRemark', {
	      attrs: {
	        "content": item.content,
	        "image": item.image
	      }
	    })], 1), _vm._v(" "), (item.parent) ? _c('div', {
	      staticClass: "origin"
	    }, [_c('div', {
	      staticClass: "origin-info flex flex-cross-center flex-main-justify"
	    }, [_c('div', {
	      staticClass: "origin-name"
	    }, [_vm._v(_vm._s(item.parent.username))]), _vm._v(" "), _c('div', {
	      staticClass: "origin-time"
	    }, [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(item.parent.date))))])]), _vm._v(" "), _c('div', {
	      staticClass: "origin-content"
	    }, [_vm._v("\n                            " + _vm._s(item.parent.content) + "\n                        ")]), _vm._v(" "), (!!item.parent.image) ? _c('div', {
	      staticClass: "replyImage"
	    }, [_c('img', {
	      attrs: {
	        "src": item.parent.image,
	        "alt": ""
	      }
	    })]) : _vm._e()]) : _vm._e()])
	  }), 0)] : _vm._e(), _vm._v(" "), (_vm.newCommentsList.length > 0) ? [_c('div', {
	    staticClass: "comments-title "
	  }, [_c('img', {
	    staticClass: "icon_liuyan",
	    attrs: {
	      "src": _vm.hotImg
	    }
	  }), _vm._v("最新留言")]), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadMore),
	      expression: "loadMore"
	    }],
	    attrs: {
	      "infinite-scroll-disabled": "loading",
	      "infinite-scroll-distance": "50"
	    }
	  }, _vm._l((_vm.newCommentsList), function(item, index) {
	    return _c('li', {
	      key: index
	    }, [_c('header', {
	      staticClass: "flex flex-cross-center flex-main-justify"
	    }, [_c('div', {
	      staticClass: "flex flex-cross-center"
	    }, [_c('div', {
	      staticClass: "avatar",
	      style: ({
	        backgroundImage: ("url(" + (item.userIcon?item.userIcon:_vm.icon) + ")")
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "info-area"
	    }, [_c('div', {
	      staticClass: "name ellipsis"
	    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('div', {
	      staticClass: "time ellipsis"
	    }, [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(item.date))))])])]), _vm._v(" "), _c('div', {
	      staticClass: "like flex flex-cross-center"
	    }, [_c('span', {
	      class: [item.isLike ? 'active-num' : 'num']
	    }, [_vm._v(_vm._s(_vm.getLikesCount(item.likes + '')))]), _vm._v(" "), _c('i', {
	      class: [item.isLike ? 'active-good' : 'good']
	    })])]), _vm._v(" "), _c('section', [_c('themeRemark', {
	      attrs: {
	        "content": item.content,
	        "image": item.image
	      }
	    })], 1), _vm._v(" "), (item.parent) ? _c('div', {
	      staticClass: "origin"
	    }, [_c('div', {
	      staticClass: "origin-info flex flex-cross-center flex-main-justify"
	    }, [_c('div', {
	      staticClass: "origin-name"
	    }, [_vm._v(_vm._s(item.parent.username))]), _vm._v(" "), _c('div', {
	      staticClass: "origin-time"
	    }, [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(item.parent.date))))])]), _vm._v(" "), _c('div', {
	      staticClass: "origin-content"
	    }, [_vm._v("\n                            " + _vm._s(item.parent.content) + "\n                        ")]), _vm._v(" "), (!!item.parent.image) ? _c('div', {
	      staticClass: "replyImage"
	    }, [_c('img', {
	      attrs: {
	        "src": item.parent.image,
	        "alt": ""
	      }
	    })]) : _vm._e()]) : _vm._e()])
	  }), 0)] : _c('div', {
	    staticClass: "null-data"
	  }, [_vm._v("暂无相关内容")]), _vm._v(" "), (_vm.loading) ? _c('p', {
	    staticClass: "loading"
	  }, [_c('spinner', {
	    attrs: {
	      "type": "fading-circle"
	    }
	  }), _vm._v("\n            加载中...\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAll) ? _c('p', {
	    staticClass: "loading"
	  }, [_vm._v("已显示全部内容")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.activeTab === '1') ? [_c('listArticle')] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.show) ? _c('div', {
	    staticClass: "m-related-news"
	  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.relatedNews), function(item) {
	    return _c('news-item', {
	      key: item.id,
	      attrs: {
	        "item": item
	      }
	    })
	  })], 2) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h4', {
	    staticClass: "m-bt"
	  }, [_c('span', {
	    staticClass: "u-tt"
	  }, [_vm._v("推荐阅读")])])
	}]}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "m-user-avatar"
	  }, [_c('div', {
	    staticClass: "bg-d"
	  }, [(_vm.showAvatar) ? _c('div', {
	    staticClass: "bg-c",
	    style: ({
	      backgroundImage: 'url(' + _vm.userIcon + ')'
	    })
	  }) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "wrapper",
	    staticClass: "wrapper",
	    style: ({
	      height: _vm.wrapperHeight + 'px'
	    })
	  }, [(_vm.list.length > 0) ? _c('ul', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadMore),
	      expression: "loadMore"
	    }],
	    attrs: {
	      "infinite-scroll-disabled": "loading",
	      "infinite-scroll-distance": "50"
	    }
	  }, _vm._l((_vm.list), function(item) {
	    return _c('li', {
	      key: item.id,
	      staticClass: "flex"
	    }, [_c('div', {
	      staticClass: "avatar",
	      style: ({
	        backgroundImage: ("url(" + (item.userIcon?item.userIcon:_vm.head) + ")")
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "bubble"
	    }, [_c('div', {
	      staticClass: "flex-default info"
	    }, [_c('span', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(item.date))))])]), _vm._v(" "), (item.content) ? _c('div', {
	      staticClass: "content",
	      domProps: {
	        "innerHTML": _vm._s(item.content)
	      }
	    }) : _vm._e(), _vm._v(" "), (!!item.image) ? _c('div', {
	      staticClass: "content"
	    }, [_c('img', {
	      staticStyle: {
	        "width": "60vw",
	        "height": "35vw"
	      },
	      attrs: {
	        "src": item.image,
	        "alt": ""
	      },
	      on: {
	        "click": function($event) {
	          return _vm.showGallary(item.image)
	        }
	      }
	    })]) : _vm._e(), _vm._v(" "), (!!item && !!item.medias && item.medias.type === 'video') ? _c('div', {
	      staticClass: "video-wrap content video-content"
	    }, [_c('video', {
	      staticStyle: {
	        "object-fit": "fill"
	      },
	      attrs: {
	        "src": item.medias.url,
	        "poster": item.medias.image,
	        "controlsList": "nodownload",
	        "x5-playsinline": "",
	        "playsinline": "",
	        "webkit-playsinline": "",
	        "controls": "",
	        "preload": "auto"
	      }
	    })]) : (!!item && !!item.medias && item.medias.type === 'audio') ? _c('div', {
	      staticClass: "content"
	    }, [_c('audio', {
	      attrs: {
	        "src": item.medias.url,
	        "controls": "",
	        "controlsList": "nodownload",
	        "oncontextmenu": "return false"
	      }
	    })]) : _vm._e(), _vm._v(" "), _vm._l((item.replies), function(replie) {
	      return _c('div', {
	        key: replie.id,
	        staticClass: "reply"
	      }, [_c('p', [_c('span', [_vm._v("回复：")]), _c('span', [_vm._v(_vm._s(replie.username))]), _vm._v(_vm._s(replie.content))])])
	    })], 2)])
	  }), 0) : _c('div', {
	    class: ['null-data', 'share-null-data']
	  }), _vm._v(" "), (_vm.loading) ? _c('p', {
	    staticClass: "loading"
	  }, [_c('mt-spinner', {
	    attrs: {
	      "type": "fading-circle"
	    }
	  }), _vm._v("\n        加载中...\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAll) ? _c('p', {
	    staticClass: "loading"
	  }, [_vm._v("已显示全部内容")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-common', {
	    attrs: {
	      "type": "normal",
	      "detail": _vm.detail
	    }
	  }, [_c('div', {
	    staticClass: "m-header"
	  }, [_c('h2', {
	    staticClass: "title f-taj"
	  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('div', {
	    staticClass: "info"
	  }, [_c('span', {
	    staticClass: "time"
	  }, [_vm._v(_vm._s(_vm.detail.newsDatetime))]), _vm._v(" "), (_vm.detail.authors) ? _c('span', {
	    staticClass: "authors"
	  }, [_vm._v(_vm._s(_vm.detail.authors))]) : _vm._e(), _vm._v(" "), (_vm.detail.copyfrom) ? _c('span', {
	    staticClass: "copyfrom"
	  }, [_vm._v(_vm._s(_vm.detail.copyfrom))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "m-detail"
	  }, [(_vm.showMedias) ? _c('div', {
	    staticClass: "m-media"
	  }, _vm._l((_vm.detail.medias), function(media, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "media-item"
	    }, [(media.type === 'video') ? _c('div', {
	      staticClass: "m-video",
	      style: ({
	        height: _vm.videoH
	      })
	    }, [_c('video', {
	      attrs: {
	        "src": media.sourceUrl,
	        "poster": media.image,
	        "x-webkit-airplay": "true",
	        "webkit-playsinline": "true",
	        "preload": "auto",
	        "controls": ""
	      }
	    })]) : (media.type === 'audio') ? _c('audio-bar', {
	      attrs: {
	        "src": media.sourceUrl
	      }
	    }) : (media.type === 'img') ? _c('div', {
	      staticClass: "m-img"
	    }, [_c('img', {
	      attrs: {
	        "src": media.image
	      }
	    })]) : _vm._e(), _vm._v(" "), (media.title) ? _c('p', {
	      staticClass: "title f-taj"
	    }, [_vm._v(_vm._s(media.title))]) : _vm._e(), _vm._v(" "), (media.description) ? _c('p', {
	      staticClass: "summary f-taj"
	    }, [_vm._v(_vm._s(media.description))]) : _vm._e()], 1)
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.detail.content) ? _c('div', {
	    staticClass: "m-content f-taj",
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  }) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "open-full-btn",
	    on: {
	      "click": _vm.openFullHandle
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-common', {
	    attrs: {
	      "type": "ask-detail",
	      "has-comments": _vm.hasComments,
	      "detail": _vm.detail,
	      "auto-open-app": false
	    }
	  }, [_c('div', {
	    staticClass: "m-header"
	  }, [_c('h2', {
	    staticClass: "title f-taj"
	  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('div', {
	    staticClass: "type"
	  }, [(_vm.showDomain) ? _c('span', [_vm._v(_vm._s(_vm.detail.domain))]) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "dot"
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.type))])])]), _vm._v(" "), _c('div', {
	    staticClass: "m-content"
	  }, [_c('div', {
	    staticClass: "item m-f-q"
	  }, [_c('user-avatar', {
	    attrs: {
	      "avatar": _vm.fQ.avatar
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "name f-toe1"
	  }, [_vm._v(_vm._s(_vm.fQ.user_name))]), _vm._v(" "), _c('div', {
	    staticClass: "to f-cb"
	  }, [_c('span', {
	    staticClass: "f-fl f-toe1 name-a"
	  }, [_c('span', {
	    staticClass: "prefix"
	  }, [_vm._v("向")]), _vm._v(_vm._s(_vm.detail.answer_user_name))]), _vm._v(" "), _c('span', {
	    staticClass: "f-fl suffix"
	  }, [_vm._v("提问")])]), _vm._v(" "), _c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm._f("dateFormat1")(_vm.fQ.date_timestamp, 'yyyy-MM-dd hh:mm')))]), _vm._v(" "), _c('div', {
	    staticClass: "text"
	  }, [_c('pre', {
	    staticClass: "f-pre",
	    domProps: {
	      "innerHTML": _vm._s(_vm.fQ.content)
	    }
	  })])], 1), _vm._v(" "), (_vm.showFA) ? _c('div', {
	    staticClass: "item m-f-a"
	  }, [_c('user-avatar', {
	    attrs: {
	      "avatar": _vm.fA.avatar
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "name f-toe1"
	  }, [_vm._v(_vm._s(_vm.fA.user_name))]), _vm._v(" "), _c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm._f("dateFormat1")(_vm.fA.date_timestamp, 'yyyy-MM-dd hh:mm')))]), _vm._v(" "), _c('div', {
	    staticClass: "text"
	  }, [_c('pre', {
	    staticClass: "f-pre",
	    domProps: {
	      "innerHTML": _vm._s(_vm.fA.content)
	    }
	  })])], 1) : _vm._e(), _vm._v(" "), (_vm.showSQ) ? _c('div', {
	    staticClass: "item m-s-q"
	  }, [_c('user-avatar', {
	    attrs: {
	      "avatar": _vm.sQ.avatar
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "name f-toe1"
	  }, [_vm._v(_vm._s(_vm.sQ.user_name))]), _vm._v(" "), _c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm._f("dateFormat1")(_vm.sQ.date_timestamp, 'yyyy-MM-dd hh:mm')))]), _vm._v(" "), _c('div', {
	    staticClass: "text"
	  }, [_c('pre', {
	    staticClass: "f-pre",
	    domProps: {
	      "innerHTML": _vm._s(_vm.sQ.content)
	    }
	  })])], 1) : _vm._e(), _vm._v(" "), (_vm.showSA) ? _c('div', {
	    staticClass: "item m-s-a"
	  }, [_c('user-avatar', {
	    attrs: {
	      "avatar": _vm.sA.avatar
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "name f-toe1"
	  }, [_vm._v(_vm._s(_vm.sA.user_name))]), _vm._v(" "), _c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm._f("dateFormat1")(_vm.sA.date_timestamp, 'yyyy-MM-dd hh:mm')))]), _vm._v(" "), _c('div', {
	    staticClass: "text"
	  }, [_c('pre', {
	    staticClass: "f-pre",
	    domProps: {
	      "innerHTML": _vm._s(_vm.sA.content)
	    }
	  })])], 1) : _vm._e(), _vm._v(" "), (_vm.showStatus) ? _c('div', {
	    staticClass: "m-status-bar"
	  }, [_vm._v("\n\t\t\t问题状态"), _c('span', {
	    class: ['status', 'status-' + _vm.statusCode]
	  }, [_vm._v(_vm._s(_vm.statusText))])]) : _vm._e()]), _vm._v(" "), (_vm.showRelated) ? _c('div', {
	    staticClass: "m-related"
	  }, [_c('h4', {
	    staticClass: "m-bt"
	  }, [_c('span', {
	    staticClass: "u-tt"
	  }, [_vm._v("相关问题")])]), _vm._v(" "), _c('ul', _vm._l((_vm.related), function(item, index) {
	    return _c('li', [_c('a', {
	      class: ['ask-link', 'f-toe1', 'status-' + item.status],
	      attrs: {
	        "href": _vm._f("path")(item)
	      }
	    }, [_vm._v(_vm._s(item.title))])])
	  }), 0)]) : _vm._e(), _vm._v(" "), _c('comment-normal', {
	    attrs: {
	      "comments": _vm.comments
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.bannerUrl) ? _c('div', {
	    ref: "subjectSwipe",
	    staticClass: "swipe-wrap"
	  }, [_c('ul', {
	    staticClass: "flex-default"
	  }, [_vm._l((_vm.bannerUrl), function(item) {
	    return _c('li', {
	      key: item.url,
	      staticClass: "swipe-item"
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "des ellipsis"
	    }, [_vm._v(_vm._s(item.dec))])])
	  }), _vm._v(" "), _vm._m(0)], 2)]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "more"
	  }, [_vm._v("查"), _c('br'), _vm._v("看"), _c('br'), _vm._v("更"), _c('br'), _vm._v("多"), _c('br'), _vm._v(">")])
	}]}

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "news-link f-cb",
	    attrs: {
	      "href": _vm.path
	    }
	  }, [(_vm.showImg) ? _c('div', {
	    staticClass: "col-l bg-d f-fl"
	  }, [_c('div', {
	    staticClass: "bg-c",
	    style: ({
	      backgroundImage: 'url(' + _vm.showImg + ')'
	    })
	  }), _vm._v(" "), _c('i', {
	    class: ['icon', 'icon-' + _vm.item.type]
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-m"
	  }, [_c('div', {
	    staticClass: "title f-toe2"
	  }, [_vm._v(_vm._s(_vm.item.listTitle || _vm.item.title))]), _vm._v(" "), _c('div', {
	    staticClass: "info-l"
	  }, [(_vm.item.date) ? _c('span', {
	    staticClass: "time"
	  }, [_vm._v(_vm._s(_vm._f("dataISO")(_vm.item.date)))]) : _vm._e(), _vm._v(" "), (_vm.showJoin) ? _c('span', {
	    staticClass: "join-count"
	  }, [_vm._v("参与 " + _vm._s(_vm.item.join_count))]) : _vm._e(), _vm._v("\n\t\t\t \n\t\t")]), _vm._v(" "), _c('div', {
	    staticClass: "info-r"
	  }, [(_vm.showTag) ? _c('span', {
	    staticClass: "tag"
	  }, [_vm._v(_vm._s(_vm.item.tags))]) : _vm._e(), _vm._v(" "), (_vm.item.comments != '0' && _vm.item.comments) ? _c('span', {
	    staticClass: "comment-count"
	  }, [_vm._v(_vm._s(_vm.item.comments))]) : _vm._e(), _vm._v("\n\t\t\t \n\t\t")])])])
	},staticRenderFns: []}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "comment-item"
	  }, [_c('div', {
	    staticClass: "item-avatar f-fl"
	  }, [_c('div', {
	    staticClass: "bg-d"
	  }, [_c('div', {
	    staticClass: "bg-c",
	    style: ({
	      backgroundImage: 'url(' + _vm.webp(_vm.item.userIcon) + ')'
	    })
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "item-body"
	  }, [_c('main-item', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _vm._v(" "), (_vm.showReply) ? _c('div', {
	    staticClass: "reply-block"
	  }, [_c('span', {
	    staticClass: "triangle-up"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "triangle-up-shadow"
	  }), _vm._v(" "), _vm._l((_vm.item.replies), function(replyItem, index) {
	    return _c('reply-item', {
	      key: replyItem.id,
	      attrs: {
	        "open-reply-status": _vm.openReplyStatus,
	        "open-reply-handle": _vm.openReplyHandle,
	        "item": replyItem,
	        "index": index,
	        "count": _vm.replyCount
	      }
	    })
	  })], 2) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-common', {
	    attrs: {
	      "type": "normal",
	      "showAppTopLink": _vm.isSharePage,
	      "showAppBotLink": _vm.isSharePage,
	      "detail": _vm.data
	    }
	  }, [(_vm.data) ? _c('h1', {
	    staticClass: "QA-subject",
	    domProps: {
	      "innerHTML": _vm._s(_vm.data.subject)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('section', {
	    staticClass: "QA-area"
	  }, [_c('div', {
	    staticClass: "QQ-wrap"
	  }, [_c('div', {
	    staticClass: "QQ_header header-wrap flex flex-default flex-main-justify"
	  }, [_c('div', {
	    staticClass: "flex flex-cross-center"
	  }, [_c('div', {
	    staticClass: "avatar",
	    style: ({
	      backgroundImage: ("url(" + (_vm.data.avatar?_vm.data.avatar:_vm.icon) + ")")
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "info-area"
	  }, [_c('div', {
	    staticClass: "name ellipsis"
	  }, [_vm._v(" " + _vm._s(_vm.data.nickName))]), _vm._v(" "), _c('div', {
	    staticClass: "time ellipsis"
	  }, [_vm._v(_vm._s(_vm.data.dateline))])])]), _vm._v(" "), _c('div', {
	    class: ['like', 'flex', 'flex-cross-center',
	      _vm.data.stateName == '已回复' ? 'replied' : _vm.data.stateName == '未回复' ? 'no_replied' : ''
	    ]
	  })]), _vm._v(" "), _c('div', {
	    class: ['content', 'font-size-' + _vm.fontSizeNum],
	    domProps: {
	      "innerHTML": _vm._s(_vm.summaryReplace(_vm.data.content))
	    }
	  }), _vm._v(" "), (_vm.data.attachmentList) ? _c('ul', {
	    staticClass: "media-list"
	  }, _vm._l((_vm.data.attachmentList), function(item, index) {
	    return _c('li', {
	      key: index,
	      class: item.type == 'video' ? 'icon-video' : '',
	      on: {
	        "click": function($event) {
	          return _vm.bigImage(item.type, item.imageUrl)
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": item.imageUrl
	      }
	    })])
	  }), 0) : _vm._e()]), _vm._v(" "), (_vm.data.asOrgName && _vm.data.asContent) ? _c('div', {
	    staticClass: "lines"
	  }) : _vm._e(), _vm._v(" "), (_vm.data.asOrgName && _vm.data.asContent) ? _c('div', {
	    staticClass: "QA-wrap"
	  }, [_c('div', {
	    staticClass: "QA-label"
	  }, [_c('label', [_vm._v("- 反馈 -")])]), _vm._v(" "), _c('i', {
	    staticClass: "start"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "contentDiv"
	  }, [_c('div', [_c('div', {
	    class: ['content', 'font-size-' + _vm.fontSizeNum],
	    domProps: {
	      "innerHTML": _vm._s(_vm.summaryReplace(_vm.data.asContent))
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "header-wrap_as"
	  }, [_c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.data.asDateline) + " "), _c('span', {
	    staticClass: "ending"
	  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "content-footer"
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "article-desc"
	  }, [_c('li', [_vm._v("未经授权，严禁转载")]), _vm._v(" "), _c('li', [_vm._v("联系电话：028-86751128")])]), _vm._v(" "), (_vm.comments !== null && _vm.comments.length > 0) ? _c('div', {
	    staticClass: "comment"
	  }, [(_vm.comments.length > 0) ? _c('div', {
	    staticClass: "title"
	  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("热门评论")])]) : _vm._e(), _vm._v(" "), (_vm.comments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.comments), function(item, index) {
	    return _c('li', {
	      key: index,
	      on: {
	        "click": function($event) {
	          return _vm.addComment(item)
	        }
	      }
	    }, [_c('header', {
	      staticClass: "flex flex-cross-center flex-main-justify"
	    }, [_c('div', {
	      staticClass: "flex flex-cross-center"
	    }, [_c('div', {
	      staticClass: "avatar",
	      style: ({
	        backgroundImage: ("url(" + (item.userIcon?item.userIcon:_vm.icon) + ")")
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "info-area"
	    }, [_c('div', {
	      staticClass: "name ellipsis"
	    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('div', {
	      staticClass: "time ellipsis"
	    }, [_vm._v(_vm._s(_vm.getTime(item.date)))])])]), _vm._v(" "), _c('div', {
	      staticClass: "like flex flex-cross-center",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setActiveLike(item)
	        }
	      }
	    }, [_c('span', {
	      class: [item.isLike ? 'active-num' : 'num']
	    }, [_vm._v(_vm._s(_vm.getLikesCount(item.likes + '')))]), _vm._v(" "), _c('i', {
	      class: [item.isLike ? 'active-good' : 'good']
	    })])]), _vm._v(" "), _c('section', [_c('p', {
	      domProps: {
	        "innerHTML": _vm._s(item.content)
	      }
	    })]), _vm._v(" "), (item.parent) ? _c('div', {
	      staticClass: "origin"
	    }, [_c('div', {
	      staticClass: "origin-name"
	    }, [_vm._v(_vm._s(item.parent.username))]), _vm._v(" "), _c('div', {
	      staticClass: "origin-time"
	    }, [_vm._v(_vm._s(_vm.getTime(item.parent.date)))]), _vm._v(" "), _c('div', {
	      staticClass: "origin-content"
	    }, [_vm._v("\n                    " + _vm._s(item.parent.content) + "\n                ")])]) : _vm._e()])
	  }), 0), _vm._v(" "), (!_vm.isSharePage && _vm.comments.length >= 5) ? _c('div', {
	    staticClass: "check-all",
	    on: {
	      "click": function($event) {
	        return _vm.appPostMessage('checkAllComment')
	      }
	    }
	  }, [_vm._v("查看全部评论 "), _c('i')]) : (!_vm.isSharePage && _vm.comments.length > 0 && _vm.comments.length < 5) ? _c('div', {
	    staticClass: "show-all"
	  }, [_vm._v("已显示全部内容")]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-top-bar"
	  }, [_c('div', {
	    staticClass: "row-1 f-cb"
	  }, [(_vm.item.area) ? _c('span', {
	    staticClass: "addr f-fl f-toe1"
	  }, [_vm._v(_vm._s(_vm.item.area))]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "name f-fl f-toe1"
	  }, [_vm._v(_vm._s(_vm.item.userName || _vm.item.userName))])]), _vm._v(" "), _c('div', {
	    staticClass: "row-2"
	  }, [_c('span', {
	    staticClass: "praise-btn f-fr"
	  }, [_vm._v(_vm._s(_vm.item.likes))]), _vm._v(" "), _c('span', {
	    staticClass: "time"
	  }, [_vm._v(_vm._s(_vm._f("dateNewComment")(_vm.item.time)))])])])
	},staticRenderFns: []}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content"
	  }, [(_vm.content) ? _c('p', {
	    ref: "con",
	    class: _vm.isHideFlag ? "line-5" : '',
	    staticStyle: {
	      "-webkit-box-orient": "vertical"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.content.replace(/(\r\n|\n|\r)/gm, '<br />'))
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isHideFlag) ? _c('div', {
	    class: _vm.isHideFlag ? 'unfold' : 'fold',
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.unfold.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.unfoldText) + " "), _c('span', {
	    staticClass: "arrow-down"
	  })]) : _vm._e(), _vm._v(" "), (!!_vm.image) ? _c('div', {
	    staticClass: "image"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.image,
	      "alt": ""
	    }
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('header', {
	    staticClass: "flex flex-cross-center"
	  }, [_c('img', {
	    staticClass: "avatar",
	    attrs: {
	      "src": _vm.office.logo,
	      "alt": "",
	      "onerror": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "info"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.office.name))]), _vm._v(" "), _c('div', {
	    staticClass: "intro"
	  }, [_vm._v(_vm._s(_vm.office.introduction))])])]), _vm._v(" "), _c('nav', {
	    ref: "nav"
	  }, [_c('ul', {
	    staticClass: "flex-default"
	  }, _vm._l((_vm.categoryList), function(li, index) {
	    return _c('li', {
	      class: {
	        activeItem: _vm.activeIndex == index
	      },
	      on: {
	        "click": function($event) {
	          return _vm.routerPush(li, index)
	        }
	      }
	    }, [_c('span', [_vm._v(_vm._s(li.name))])])
	  }), 0)]), _vm._v(" "), (_vm.categoryId && _vm.categoryId !== 'desc') ? _c('section', [(_vm.list.length > 0) ? _c('ul', _vm._l((_vm.list), function(article) {
	    return _c('li', {
	      staticClass: "flex flex-main-justify",
	      on: {
	        "click": function($event) {
	          return _vm.goPath(article)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "info",
	      staticStyle: {
	        "width": "100%"
	      }
	    }, [_c('div', {
	      class: ["title", "mult_line_ellipsis", article.images && article.images.length > 0 ? "min_height" : ""],
	      domProps: {
	        "innerHTML": _vm._s(article.title)
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "flex date"
	    }, [_c('div', {
	      staticClass: "tag ellipsis",
	      staticStyle: {
	        "justify-content": "flex-start"
	      }
	    }, [(article.type != 'subject') ? _c('span', {
	      staticClass: "tag-red",
	      domProps: {
	        "innerHTML": _vm._s(article.tags)
	      }
	    }) : _vm._e(), _vm._v(" "), _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(article.source)
	      }
	    })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]), _vm._v(" "), (article.image) ? _c('div', {
	      staticClass: "thumbnail",
	      style: ({
	        backgroundImage: 'url(' + article.image + ')'
	      })
	    }, [_c('i', {
	      class: [article.type + '-icon']
	    })]) : _vm._e()])
	  }), 0) : _c('div', {
	    staticClass: "desc no-desc"
	  }, [_vm._v("该锦观号暂未发布内容")]), _vm._v(" "), (_vm.list.length > 0 && (_vm.data.page.next * 1 <= _vm.data.page.last * 1)) ? _c('footer', {
	    on: {
	      "click": _vm.getArticles
	    }
	  }, [_vm._v("加载更多")]) : _vm._e()]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    class: !_vm.isShowGallary ? '' : 'hidden-video'
	  }, [_c('div', {
	    staticClass: "video-wrap"
	  }, [(_vm.data.showTitle === 'true') ? _c('div', {
	    staticClass: "top-title mult_line_ellipsis"
	  }, [_vm._v(_vm._s(_vm.data.title))]) : _vm._e(), _vm._v(" "), (_vm.data.liveType === 1 && _vm.data.status === 1) ? _c('img', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    },
	    attrs: {
	      "src": _vm.data.imageUrl,
	      "alt": ""
	    }
	  }) : (_vm.data.liveType === 1 && _vm.data.status === 2) ? _c('video', {
	    staticStyle: {
	      "object-fit": "fill"
	    },
	    attrs: {
	      "id": "liveId",
	      "src": _vm.data.video,
	      "poster": _vm.data.image,
	      "controlsList": "nodownload",
	      "x5-playsinline": "",
	      "playsinline": "",
	      "webkit-playsinline": "",
	      "x-webkit-airplay": "true",
	      "x5-video-player-type": "h5",
	      "controls": "",
	      "preload": "auto",
	      "x5-video-player-fullscreen": "",
	      "x5-video-orientation": "portraint"
	    }
	  }) : (_vm.data.liveType === 1 && _vm.data.status === 3 && _vm.data.playback) ? _c('video', {
	    staticStyle: {
	      "object-fit": "fill"
	    },
	    attrs: {
	      "id": "liveId",
	      "src": _vm.data.playback,
	      "poster": _vm.data.image,
	      "controlsList": "nodownload",
	      "x5-playsinline": "",
	      "playsinline": "",
	      "webkit-playsinline": "",
	      "x-webkit-airplay": "true",
	      "x5-video-player-type": "h5",
	      "controls": "",
	      "preload": "auto",
	      "x5-video-player-fullscreen": "",
	      "x5-video-orientation": "portraint"
	    }
	  }) : (_vm.data.liveType === 1 && _vm.data.status === 3 && !_vm.data.playback) ? [_vm._v("\n                该直播已结束\n            ")] : _c('img', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    },
	    attrs: {
	      "src": _vm.data.image,
	      "alt": ""
	    }
	  })], 2), _vm._v(" "), _c('nav', {
	    staticClass: "flex"
	  }, [_vm._l((_vm.linkList), function(li, index) {
	    return _c('div', {
	      key: index,
	      class: {
	        activeItem: _vm.activeIndex == index
	      },
	      on: {
	        "click": function($event) {
	          return _vm.routerPush(index)
	        }
	      }
	    }, [_c('span', [_vm._v(_vm._s(li.name))])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "line"
	  })], 2), _vm._v(" "), _c('section', [(!_vm.activeIndex) ? _c('Room', {
	    on: {
	      "handleGallary": _vm.handleGallary
	    }
	  }) : _c('Interactive', {
	    on: {
	      "handleGallary": _vm.handleGallary
	    }
	  })], 1)]), _vm._v(" "), (_vm.isShowGallary) ? _c('div', {
	    staticClass: "gallary-container"
	  }, [_c('span', {
	    staticClass: "closeBtn",
	    on: {
	      "click": _vm.closeGallary
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
	    staticClass: "gallary-img",
	    attrs: {
	      "src": _vm.gallaryImg,
	      "alt": ""
	    }
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-common', {
	    attrs: {
	      "type": "normal",
	      "has-comments": _vm.hasComments,
	      "detail": _vm.detail
	    }
	  }, [_c('div', {
	    staticClass: "m-header"
	  }, [_c('h2', {
	    staticClass: "title f-taj"
	  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('div', {
	    staticClass: "info"
	  }, [_c('span', {
	    staticClass: "time"
	  }, [_vm._v(_vm._s(_vm._f("dateFormat1")(_vm.detail.date, 'yyyy-MM-dd hh:mm')))]), _vm._v(" "), (_vm.detail.authors) ? _c('span', {
	    staticClass: "authors"
	  }, [_vm._v(_vm._s(_vm.detail.authors))]) : _vm._e(), _vm._v(" "), (_vm.detail.source) ? _c('span', {
	    staticClass: "copyfrom"
	  }, [_vm._v(_vm._s(_vm.detail.source))]) : _vm._e(), _vm._v(" "), (_vm.detail.copyfrom) ? _c('span', {
	    staticClass: "copyfrom"
	  }, [_vm._v(_vm._s(_vm.detail.copyfrom))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "m-detail"
	  }, [(_vm.showMedias) ? _c('div', {
	    staticClass: "m-media"
	  }, _vm._l((_vm.detail.medias), function(media, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "media-item"
	    }, [(media.type === 'video') ? _c('div', {
	      staticClass: "m-video",
	      style: ({
	        height: _vm.videoH
	      })
	    }, [_c('video', {
	      attrs: {
	        "src": media.resources[1].url,
	        "poster": media.image,
	        "x-webkit-airplay": "true",
	        "webkit-playsinline": "true",
	        "preload": "auto",
	        "controls": ""
	      }
	    })]) : (media.type === 'audio') ? _c('audio-bar', {
	      attrs: {
	        "src": media.resources[1].url
	      }
	    }) : (media.type === 'img') ? _c('div', {
	      staticClass: "m-img"
	    }, [_c('img', {
	      attrs: {
	        "src": media.image
	      }
	    })]) : _vm._e(), _vm._v(" "), (media.title) ? _c('p', {
	      staticClass: "title f-taj"
	    }, [_vm._v(_vm._s(media.title))]) : _vm._e(), _vm._v(" "), (media.description) ? _c('p', {
	      staticClass: "summary f-taj"
	    }, [_vm._v(_vm._s(media.description))]) : _vm._e()], 1)
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.detail.content) ? _c('div', {
	    staticClass: "m-content f-taj",
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  }) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "open-full-btn",
	    on: {
	      "click": _vm.openFullHandle
	    }
	  })]), _vm._v(" "), _c('news-votes', {
	    attrs: {
	      "list": _vm.detail.votes
	    }
	  }), _vm._v(" "), _c('news-related', {
	    attrs: {
	      "list": _vm.detail.extend
	    }
	  }), _vm._v(" "), _c('comment-normal', {
	    attrs: {
	      "comments": _vm.comments
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-common', {
	    attrs: {
	      "type": "normal",
	      "showAppTopLink": _vm.isSharePage,
	      "showAppBotLink": false,
	      "detail": _vm.dataAll
	    }
	  }, [_c('div', {
	    staticClass: "wrapper",
	    style: ((!_vm.isSharePage) ? {
	      height: '100vh'
	    } : {})
	  }, [_c('button', {
	    staticClass: "content-button"
	  }), _vm._v(" "), _c('video', {
	    staticStyle: {
	      "object-fit": "contain"
	    },
	    attrs: {
	      "src": _vm.data.resources ? _vm.data.resources[1].url : '',
	      "poster": _vm.data.image ? _vm.data.image : '',
	      "controlslist": "nodownload",
	      "x-webkit-airplay": "allow",
	      "webkit-playsinline": "playsinline",
	      "x5-video-orientation": "portraint",
	      "x5-video-player-type": "h5-page",
	      "webkit-appearance": "none",
	      "playsinline": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "info-box"
	  }, [_c('div', {
	    staticClass: "info-bottom"
	  }, [_c('p', {
	    staticClass: "info-auth"
	  }, [_vm._v("@" + _vm._s(_vm.authors))]), _vm._v(" "), _c('p', {
	    ref: "dsc",
	    staticClass: "info-desc",
	    class: _vm.showMoreDesc ? 'showmore' : ''
	  }, [_vm._v(_vm._s(_vm.desc) + " "), _c('span', {
	    ref: "morebtn",
	    staticClass: "info-more",
	    on: {
	      "click": _vm.showMore
	    }
	  }, [_vm._v(_vm._s(_vm.showMoreDesc ? '收起' : '更多')), _c('span', {
	    staticClass: "arrow"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(768)
	    }
	  })])])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ['reply-item', _vm.itemHide ? 'f-dn' : '']
	  }, [(_vm.openBtnShow) ? _c('a', {
	    staticClass: "open-btn",
	    attrs: {
	      "href": "javascript:void(0);"
	    },
	    on: {
	      "click": _vm.openReplyHandle
	    }
	  }, [_vm._v("\n\t\t展开" + _vm._s(_vm.count - 3) + "条回复"), _c('span', {
	    staticClass: "icon-arrow"
	  })]) : _vm._e(), _vm._v(" "), _c('reply-top-bar', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _vm._v(" "), _c('item-content', {
	    attrs: {
	      "item": _vm.item,
	      "hide": _vm.itemHide
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ['reply-top-bar', _vm.item.del === '1' ? 'del' : '']
	  }, [(_vm.item.del !== '1') ? _c('div', {
	    staticClass: "info-l f-cb"
	  }, [_c('div', {
	    staticClass: "from f-fl f-toe1"
	  }, [(_vm.item.area) ? _c('span', {
	    staticClass: "addr"
	  }, [_vm._v(_vm._s(_vm.item.area))]) : _vm._e(), _vm._v(_vm._s(_vm.item.userName) + "\n\t\t")]), _vm._v(" "), _c('div', {
	    staticClass: "to"
	  }, [_c('em', [_vm._v("回复：")]), _vm._v(_vm._s(_vm.item.replyTo) + "\n\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "info-r"
	  }, [_c('span', {
	    staticClass: "floor"
	  }, [_vm._v(_vm._s(_vm.item.floor) + "楼")])])])
	},staticRenderFns: []}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "list"
	  }, [_c('ul', _vm._l((_vm.relvantNewsData), function(article) {
	    return _c('li', {
	      key: article.id,
	      staticClass: "flex flex-main-justify",
	      on: {
	        "click": function($event) {
	          return _vm.goPath(article)
	        }
	      }
	    }, [
	      [_c('div', {
	        staticClass: "info"
	      }, [_c('div', {
	        class: ["title", "mult_line_ellipsis", article.images && article.images.length > 0 ? "min_height" : article.imageUrl ? "min_height" : "" ]
	      }, [(article.type === 'subject') ? _c('span', {
	        staticClass: "tag_label_2"
	      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle))]), _vm._v(" "), _c('div', {
	        staticClass: "flex-default date",
	        staticStyle: {
	          "justify-content": "flex-start"
	        }
	      }, [_c('div', {
	        staticClass: "tag ellipsis"
	      }, [(article.type != 'subject') ? _c('span', {
	        staticClass: "tag-red",
	        domProps: {
	          "innerHTML": _vm._s(article.tags)
	        }
	      }) : _vm._e(), _vm._v(" "), _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(article.source)
	        }
	      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]), _vm._v(" "), (article.imageUrl && article.imageUrl.length > 0) ? _c('div', {
	        staticClass: "thumbnail",
	        style: ({
	          backgroundImage: 'url(' + article.imageUrl[0] + ')'
	        })
	      }, [_c('i', {
	        class: [article.type + '-icon']
	      })]) : _vm._e()]
	    ], 2)
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    staticClass: "top-pic"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.data.image,
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "title-area"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.data.viewType == 'bigimage' ? (_vm.data.showTitle ? _vm.data.title : '') : (_vm.data.showTitle ? _vm.data.listTitle : _vm.data.title)))]), _vm._v(" "), _c('div', {
	    staticClass: "description"
	  }, [_vm._v(_vm._s(_vm.data.description))])]), _vm._v(" "), (_vm.data.blockType != 1) ? _c('div', {
	    staticClass: "lable-ul"
	  }, [_c('div', {
	    staticClass: "label-ul-content"
	  }, [_c('ul', _vm._l((_vm.blocks), function(item, index) {
	    return (_vm.blocks && _vm.blocks.length) ? _c('li', [_c('a', {
	      attrs: {
	        "href": "javascript:void(0);"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.toggleBlock(index, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(item.title))])]) : _vm._e()
	  }), 0)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.blocks), function(item, index) {
	    return (_vm.blocks && _vm.blocks.length) ? _c('section', [_c('header', {
	      staticClass: "flex flex-cross-center",
	      attrs: {
	        "id": _vm.generateElementId(index)
	      }
	    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v("∕"), _c('span', [_vm._v(_vm._s(_vm.data.blocks.length))]), _vm._v(" "), _c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('ul', _vm._l((item.articles), function(article) {
	      return _c('li', {
	        key: article.id,
	        staticClass: "flex flex-main-justify",
	        on: {
	          "click": function($event) {
	            return _vm.goPath(article)
	          }
	        }
	      }, [(article.type === 'live') ? _c('div', {
	        staticStyle: {
	          "width": "100%"
	        }
	      }, [_c('div', {
	        staticClass: "title"
	      }, [(article.tags && article.type === 'subject') ? _c('span', {
	        staticClass: "tag_label"
	      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), (article.liveType != 3 && article.images) ? _c('div', {
	        staticClass: "pic-wrap-2"
	      }, [_c('img', {
	        attrs: {
	          "src": article.images[0],
	          "alt": ""
	        }
	      }), _vm._v(" "), _c('div', {
	        class: 'living-label-' + article.liveStatus
	      })]) : _vm._e(), _vm._v(" "), _c('div', {
	        staticClass: "flex flex-main-justify date"
	      }, [_c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))]), _vm._v(" "), (article.hits > 0) ? _c('span', [_vm._v(_vm._s(article.hits) + "人参与")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (article.viewType === 'three') ? _c('div', {
	        staticStyle: {
	          "height": "100%",
	          "width": "100%"
	        }
	      }, [_c('div', {
	        staticClass: "title"
	      }, [(article.tags && article.type === 'subject') ? _c('span', {
	        staticClass: "tag_label"
	      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
	        staticClass: "three-list flex"
	      }, [_vm._l((article.images), function(img) {
	        return _c('div', {
	          key: img,
	          staticClass: "img",
	          style: ({
	            backgroundImage: 'url(' + img + ')'
	          })
	        })
	      }), _vm._v(" "), (article.type === 'image') ? _c('div', {
	        staticClass: "images-label"
	      }, [_vm._v(_vm._s(article.medias && article.medias.length > 0 ? article.medias.length : 0) + "图")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
	        staticClass: "flex-default date",
	        staticStyle: {
	          "justify-content": "flex-start"
	        }
	      }, [_c('div', {
	        staticClass: "tag ellipsis"
	      }, [(article.type != 'subject') ? _c('span', {
	        staticClass: "tag-red",
	        domProps: {
	          "innerHTML": _vm._s(article.tags)
	        }
	      }) : _vm._e(), _vm._v(" "), _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(article.source)
	        }
	      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : (article.viewType === 'bannerSmall') ? _c('div', {
	        staticStyle: {
	          "width": "100%"
	        }
	      }, [_c('div', {
	        staticClass: "img-frame-small"
	      }, [(article.images) ? _c('div', {
	        staticClass: "img-bac",
	        style: ('background:url(' + article.images[0] + ') no-repeat;background-size:100%')
	      }) : _vm._e()])]) : (article.viewType === 'banner') ? _c('div', {
	        staticStyle: {
	          "height": "100%",
	          "width": "100%"
	        }
	      }, [(article.type === 'normal') ? _c('div', [_c('div', {
	        staticClass: "title"
	      }, [(article.tags && article.type === 'subject') ? _c('span', {
	        staticClass: "tag_label"
	      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
	        staticClass: "pic-wrap"
	      }, [_c('img', {
	        attrs: {
	          "src": article.image,
	          "alt": ""
	        }
	      })]), _vm._v(" "), _c('div', {
	        staticClass: "description",
	        domProps: {
	          "innerHTML": _vm._s(article.description)
	        }
	      }), _vm._v(" "), _c('div', {
	        staticClass: "flex-default date",
	        staticStyle: {
	          "justify-content": "flex-start"
	        }
	      }, [_c('div', {
	        staticClass: "tag ellipsis"
	      }, [(article.type != 'subject') ? _c('span', {
	        staticClass: "tag-red",
	        domProps: {
	          "innerHTML": _vm._s(article.tags)
	        }
	      }) : _vm._e(), _vm._v(" "), _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(article.source)
	        }
	      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : (article.type === 'video') ? _c('div', [_c('div', {
	        staticClass: "title"
	      }, [(article.tags && article.type === 'subject') ? _c('span', {
	        staticClass: "tag_label"
	      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
	        staticClass: "pic-wrap"
	      }, [_c('img', {
	        attrs: {
	          "src": article.images[0],
	          "alt": ""
	        }
	      }), _vm._v(" "), _c('i', {
	        staticClass: "content-button"
	      })]), _vm._v(" "), _c('div', {
	        staticClass: "flex-default date",
	        staticStyle: {
	          "justify-content": "flex-start"
	        }
	      }, [_c('div', {
	        staticClass: "tag ellipsis"
	      }, [(article.type != 'subject') ? _c('span', {
	        staticClass: "tag-red",
	        domProps: {
	          "innerHTML": _vm._s(article.tags)
	        }
	      }) : _vm._e(), _vm._v(" "), _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(article.source)
	        }
	      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : _c('div', [_c('div', {
	        staticClass: "title"
	      }, [(article.tags && article.type === 'subject') ? _c('span', {
	        staticClass: "tag_label"
	      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), (article.images) ? _c('div', {
	        staticClass: "pic-wrap"
	      }, [_c('img', {
	        attrs: {
	          "src": article.images[0],
	          "alt": ""
	        }
	      }), _vm._v(" "), (article.type === 'image') ? _c('div', {
	        staticClass: "images-label"
	      }, [_vm._v(_vm._s(article.medias && article.medias.length > 0 ? article.medias.length : 0) + "图")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	        staticClass: "description",
	        domProps: {
	          "innerHTML": _vm._s(article.description)
	        }
	      }), _vm._v(" "), _c('div', {
	        staticClass: "flex-default date",
	        staticStyle: {
	          "justify-content": "flex-start"
	        }
	      }, [_c('div', {
	        staticClass: "tag ellipsis"
	      }, [(article.type != 'subject') ? _c('span', {
	        staticClass: "tag-red",
	        domProps: {
	          "innerHTML": _vm._s(article.tags)
	        }
	      }) : _vm._e(), _vm._v(" "), _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(article.source)
	        }
	      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])])]) : [_c('div', {
	        staticClass: "info",
	        staticStyle: {
	          "width": "100%"
	        }
	      }, [_c('div', {
	        staticClass: "title"
	      }, [(article.tags && article.type === 'subject') ? _c('span', {
	        staticClass: "tag_label_2"
	      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
	        staticClass: "flex date"
	      }, [_c('div', {
	        staticClass: "tag ellipsis",
	        staticStyle: {
	          "justify-content": "flex-start"
	        }
	      }, [(article.type != 'subject') ? _c('span', {
	        staticClass: "tag-red",
	        domProps: {
	          "innerHTML": _vm._s(article.tags)
	        }
	      }) : _vm._e(), _vm._v(" "), _c('span', {
	        domProps: {
	          "innerHTML": _vm._s(article.source)
	        }
	      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]), _vm._v(" "), (article.images) ? _c('div', {
	        staticClass: "thumbnail",
	        style: ({
	          backgroundImage: 'url(' + article.images[0] + ')'
	        })
	      }, [_c('i', {
	        class: [article.type + '-icon']
	      })]) : _vm._e()]], 2)
	    }), 0), _vm._v(" "), (item.page.next * 1 <= item.page.last * 1) ? _c('footer', {
	      on: {
	        "click": function($event) {
	          return _vm.getArticles(item.id, index)
	        }
	      }
	    }, [_vm._v("加载更多")]) : _vm._e()]) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "list"
	  }, [(_vm.articleList.length > 0) ? _c('ul', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadMore),
	      expression: "loadMore"
	    }],
	    attrs: {
	      "infinite-scroll-disabled": "loading",
	      "infinite-scroll-distance": "50"
	    }
	  }, _vm._l((_vm.articleList), function(article, index) {
	    return _c('li', {
	      key: index,
	      staticClass: "flex flex-main-justify",
	      on: {
	        "click": function($event) {
	          return _vm.goPath(article)
	        }
	      }
	    }, [(article.type === 'live') ? _c('div', {
	      staticStyle: {
	        "width": "100%"
	      }
	    }, [_c('div', {
	      staticClass: "title"
	    }, [(article.tags && article.type === 'subject') ? _c('span', {
	      staticClass: "tag_label"
	    }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), (article.liveType != 3 && (article.liveImage || article.images)) ? _c('div', {
	      staticClass: "pic-wrap"
	    }, [_c('img', {
	      staticStyle: {
	        "max-width": "100%"
	      },
	      attrs: {
	        "src": article.liveImage || article.images[0],
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      class: ['status', 'status-' + article.liveStatus]
	    })]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "flex flex-main-justify date"
	    }, [_c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))]), _vm._v(" "), (article.hits > 0) ? _c('span', [_vm._v(_vm._s(article.hits) + "人参与")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (article.viewType === 'three') ? _c('div', {
	      staticStyle: {
	        "height": "100%",
	        "width": "100%"
	      }
	    }, [_c('div', {
	      staticClass: "title"
	    }, [(article.tags && article.type === 'subject') ? _c('span', {
	      staticClass: "tag_label"
	    }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
	      staticClass: "three-list flex"
	    }, _vm._l((article.images), function(img) {
	      return _c('div', {
	        key: img,
	        staticClass: "img",
	        style: ({
	          backgroundImage: 'url(' + img + ')'
	        })
	      })
	    }), 0), _vm._v(" "), _c('div', {
	      staticClass: "flex-default date",
	      staticStyle: {
	        "justify-content": "flex-start"
	      }
	    }, [_c('div', {
	      staticClass: "tag ellipsis"
	    }, [(article.source) ? _c('span', [_vm._v(_vm._s(article.source))]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : (article.viewType === 'bannerSmall') ? _c('div', {
	      staticStyle: {
	        "width": "100%"
	      }
	    }, [_c('div', {
	      staticClass: "img-frame-small"
	    }, [(article.images) ? _c('div', {
	      staticClass: "img-bac",
	      style: ('background:url(' + article.images[0] + ') no-repeat;background-size:100%')
	    }) : _vm._e()])]) : ((article.viewType === 'banner' || article.viewType === 'bigimage') && article.type != 'live') ? _c('div', {
	      staticStyle: {
	        "height": "100%",
	        "width": "100%"
	      }
	    }, [(article.type === 'normal' || article.type === 'subject') ? _c('div', [_c('div', {
	      staticClass: "pic-wrap"
	    }, [_c('img', {
	      attrs: {
	        "src": article.image,
	        "alt": ""
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "title"
	    }, [(article.tags && article.type === 'subject') ? _c('span', {
	      staticClass: "tag_label"
	    }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
	      staticClass: "description",
	      domProps: {
	        "innerHTML": _vm._s(article.description)
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "flex-default date",
	      staticStyle: {
	        "justify-content": "flex-start"
	      }
	    }, [_c('div', {
	      staticClass: "tag ellipsis"
	    }, [(article.source) ? _c('span', [_vm._v(_vm._s(article.source))]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : (article.type === 'video') ? _c('div', [_c('div', {
	      staticClass: "title"
	    }, [(article.tags && article.type === 'subject') ? _c('span', {
	      staticClass: "tag_label"
	    }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
	      staticClass: "pic-wrap"
	    }, [_c('img', {
	      attrs: {
	        "src": article.images[0],
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('i', {
	      staticClass: "content-button"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "flex-default date",
	      staticStyle: {
	        "justify-content": "flex-start"
	      }
	    }, [_c('div', {
	      staticClass: "tag ellipsis"
	    }, [(article.source) ? _c('span', [_vm._v(_vm._s(article.source))]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : (article.type === 'theme') ? _c('div', [(article.images) ? _c('div', {
	      staticClass: "pic-wrap"
	    }, [_c('img', {
	      attrs: {
	        "src": article.images[0],
	        "alt": ""
	      }
	    }), _vm._v(" "), (article.type === 'image') ? _c('div', {
	      staticClass: "images-label"
	    }, [_vm._v(_vm._s(article.medias && article.medias.length > 0 ? article.medias.length : 0) + "图")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "title"
	    }, [_c('span', {
	      staticClass: "tag_theme"
	    }, [_vm._v("#话题")]), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
	      staticClass: "description",
	      domProps: {
	        "innerHTML": _vm._s(article.description)
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "flex-default date",
	      staticStyle: {
	        "justify-content": "flex-start"
	      }
	    }, [_c('div', {
	      staticClass: "tag ellipsis"
	    }, [(article.source) ? _c('span', [_vm._v(_vm._s(article.source))]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : _c('div', [(article.images) ? _c('div', {
	      staticClass: "pic-wrap"
	    }, [_c('img', {
	      attrs: {
	        "src": article.images[0],
	        "alt": ""
	      }
	    }), _vm._v(" "), (article.type === 'image') ? _c('div', {
	      staticClass: "images-label"
	    }, [_vm._v(_vm._s(article.medias && article.medias.length > 0 ? article.medias.length : 0) + "图")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "title"
	    }, [_vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
	      staticClass: "description",
	      domProps: {
	        "innerHTML": _vm._s(article.description)
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "flex date ellipsis"
	    }, [(article.source) ? _c('span', {
	      staticClass: "tag"
	    }, [_vm._v(_vm._s(article.source))]) : _vm._e(), _vm._v(" "), _c('span', {
	      staticClass: "tag"
	    }, [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])])]) : [(article.type != 'live') ? _c('div', {
	      staticClass: "info"
	    }, [_c('div', {
	      class: ["title", "mult_line_ellipsis", article.images && article.images.length > 0 ? "min_height" : ""]
	    }, [(article.tags && article.type === 'subject') ? _c('span', {
	      staticClass: "tag_label_2"
	    }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
	      staticClass: "flex date"
	    }, [_c('div', {
	      staticClass: "tag ellipsis",
	      staticStyle: {
	        "justify-content": "flex-start"
	      }
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(article.source)
	      }
	    })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : _vm._e(), _vm._v(" "), (article.images && article.viewType != 'noimage' && article.type != 'live') ? _c('div', {
	      staticClass: "thumbnail",
	      style: ({
	        backgroundImage: 'url(' + article.images[0] + ')'
	      })
	    }, [(article.type == 'video' && article.medias) ? _c('i', {
	      staticClass: "video-icon"
	    }, [_vm._v(_vm._s(article.medias[0].times))]) : _vm._e(), _vm._v(" "), (article.type == 'image' && article.medias) ? _c('i', {
	      staticClass: "image-icon"
	    }, [_vm._v(_vm._s(article.medias.length))]) : (article.type == 'audio' && article.medias) ? _c('i', {
	      staticClass: "audio-icon"
	    }, [_vm._v(_vm._s(article.medias[0].times))]) : _vm._e()]) : _vm._e()]], 2)
	  }), 0) : _c('div', {
	    staticClass: "null-data"
	  }, [_vm._v("暂无相关内容")]), _vm._v(" "), (_vm.loading) ? _c('p', {
	    staticClass: "loading"
	  }, [_c('spinner', {
	    attrs: {
	      "type": "fading-circle"
	    }
	  }), _vm._v("\n        加载中...\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAll) ? _c('p', {
	    staticClass: "loading"
	  }, [_vm._v("已显示全部内容")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 868 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "item-content"
	  }, [_c('div', {
	    ref: "textWrap",
	    class: ['text-wrap', _vm.textWrapClosed ? '' : 'opened']
	  }, [_c('div', {
	    ref: "text",
	    class: ['text', _vm.textClosed ? 'f-toe3' : '']
	  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.item.content) + "\n\t\t")])]), _vm._v(" "), _c('div', {
	    class: ['toggle-wrap', _vm.showToggle ? '' : 'f-dn', _vm.textClosed ? 'closed' : 'opened']
	  }, [_c('a', {
	    staticClass: "toggle-btn",
	    on: {
	      "click": _vm.toggleText
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.textClosed ? '展开' : '收起'))]), _vm._v(" "), _c('span', {
	    staticClass: "icon-arrow"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "m-audio"
	  }, [_c('audio', {
	    ref: "audio",
	    attrs: {
	      "src": _vm.src
	    },
	    on: {
	      "loadedmetadata": _vm.onLoadedmetadata,
	      "canplay": _vm.onCanplay,
	      "timeupdate": _vm.onTimeupdate
	    }
	  }, [_vm._v("\n\t\t您的浏览器版本过低，不识别audio标签\n\t")]), _vm._v(" "), _c('span', {
	    class: ['status', _vm.status ? 'play' : 'pause'],
	    on: {
	      "click": _vm.onToggle
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "time-c"
	  }, [_vm._v(_vm._s(_vm.currentTime_f))]), _vm._v(" "), _c('span', {
	    ref: "bar",
	    staticClass: "bar",
	    on: {
	      "click": function($event) {
	        return _vm.onBarClick($event)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "buffer",
	    style: ({
	      width: _vm.bw_f
	    })
	  }), _vm._v(" "), _c('span', {
	    staticClass: "progress",
	    style: ({
	      width: _vm.pw_c_f
	    })
	  }), _vm._v(" "), _c('span', {
	    ref: "dot",
	    staticClass: "dot",
	    style: ({
	      left: _vm.dl_f
	    }),
	    on: {
	      "touchstart": function($event) {
	        return _vm.onStart($event)
	      },
	      "touchmove": function($event) {
	        return _vm.onMove($event)
	      },
	      "touchend": function($event) {
	        return _vm.onEnd($event)
	      }
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "time-t"
	  }, [_vm._v(_vm._s(_vm.duration_f))])])
	},staticRenderFns: []}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-item"
	  }, [_c('main-top-bar', {
	    attrs: {
	      "item": _vm.item
	    }
	  }), _vm._v(" "), _c('item-content', {
	    attrs: {
	      "item": _vm.item
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-common', {
	    attrs: {
	      "type": "normal",
	      "showAppTopLink": _vm.isSharePage,
	      "showAppBotLink": _vm.isSharePage,
	      "detail": _vm.data
	    }
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    staticClass: "wrap"
	  }, [(_vm.data.type === 'video') ? _c('div', {
	    ref: "videoWrap"
	  }) : _vm._e(), _vm._v(" "), (_vm.data.type === 'video') ? _c('p', {
	    staticClass: "video-wrap"
	  }, [_c('video', {
	    attrs: {
	      "src": _vm.videoUrl,
	      "poster": _vm.poster,
	      "webkit-playsinline": "true",
	      "playsinline": "true",
	      "x5-playsinline": "true",
	      "x-webkit-airplay": "allow",
	      "controlsList": "nodownload"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "content-button"
	  })]) : (_vm.data.type === 'audio' && _vm.isSharePage) ? _c('audioBar', {
	    attrs: {
	      "src": _vm.audioUrl,
	      "totalTimes": _vm.totalTimes
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "essay"
	  }, [(_vm.data.introTitle) ? _c('h3', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.data.introTitle)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.data.title) ? _c('h1', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.data.title)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.data.subTitle) ? _c('div', {
	    staticClass: "desc",
	    domProps: {
	      "innerHTML": _vm._s(_vm.data.subTitle)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.$route.params.type === 'normal') ? [(_vm.data.categoryInfo && _vm.data.categoryInfo.parentId > 1) ? [_c('div', {
	    staticClass: "category-info flex-default"
	  }, [_c('div', {
	    staticClass: "flex flex-cross-center"
	  }, [_c('img', {
	    staticClass: "avatar",
	    attrs: {
	      "src": _vm.data.categoryInfo.image,
	      "alt": "",
	      "onerror": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "info"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.data.categoryInfo.name))]), _vm._v(" "), _c('div', {
	    staticClass: "date mult_line_ellipsis"
	  }, [_vm._v(_vm._s(_vm.data.categoryInfo.description))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "date-wrap flex flex-cross-center"
	  }, [_c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.date))])])] : _c('div', {
	    staticClass: "date-wrap flex flex-cross-center"
	  }, [_c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.date) + " " + _vm._s(_vm.source) + " " + _vm._s(_vm.data.authors))])])] : _vm._e(), _vm._v(" "), (_vm.data.sysCode === 'gov') ? [(_vm.data.orgInfo) ? [_c('div', {
	    staticClass: "gov-info flex-default"
	  }, [_c('div', {
	    staticClass: "flex flex-cross-center",
	    on: {
	      "click": _vm.goGov
	    }
	  }, [_c('img', {
	    staticClass: "avatar",
	    attrs: {
	      "src": _vm.data.orgInfo.logo,
	      "alt": "",
	      "onerror": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "info"
	  }, [_c('h5', [_c('div', {
	    staticClass: "line_ellipsis"
	  }, [_vm._v(_vm._s(_vm.data.orgInfo.name))]), _c('span', {
	    staticClass: "title-icon"
	  }, [_vm._v("锦观号")])]), _vm._v(" "), _c('div', {
	    staticClass: "date  mult_line_ellipsis"
	  }, [_vm._v(_vm._s(_vm.data.orgInfo.introduction))])])]), _vm._v(" "), (!_vm.isSharePage && (_vm.isFollow === 1 || _vm.isFollow === 0)) ? _c('div', {
	    class: ['follow-btn', _vm.isFollow ? 'no' : ''],
	    on: {
	      "click": _vm.setFollow
	    }
	  }, [_vm._v("\n                                " + _vm._s(_vm.isFollow ? '已订阅' : '+订阅') + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "date-wrap flex flex-cross-center"
	  }, [_c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.date) + " " + _vm._s(_vm.source) + " " + _vm._s(_vm.data.authors))])])] : _c('div', {
	    staticClass: "date-wrap flex flex-cross-center"
	  }, [_c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.date) + " " + _vm._s(_vm.source) + " " + _vm._s(_vm.data.authors))])])] : _vm._e(), _vm._v(" "), (_vm.$route.params.type === 'paper') ? [_c('div', {
	    staticClass: "date-wrap flex flex-cross-center"
	  }, [_c('div', {
	    staticClass: "date"
	  }, [_vm._v(_vm._s(_vm.date) + " " + _vm._s(_vm.source) + " " + _vm._s(_vm.data.authors))])])] : _vm._e()], 2), _vm._v(" "), (_vm.$route.params.type === 'paper') ? _c('ul', {
	    staticClass: "images"
	  }, _vm._l((_vm.data.imgall), function(item) {
	    return _c('li', [_c('img', {
	      directives: [{
	        name: "lazy",
	        rawName: "v-lazy",
	        value: (item.imgUrl),
	        expression: "item.imgUrl"
	      }],
	      attrs: {
	        "alt": ""
	      }
	    })])
	  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
	    ref: "content",
	    class: ['content', !_vm.isSharePage ? 'font-size-' + _vm.fontSizeNum : 'font-size-4'],
	    domProps: {
	      "innerHTML": _vm._s(_vm.data.content ? _vm.data.content : '')
	    }
	  }), _vm._v(" "), (_vm.data.hasVote) ? _c('PageVote', {
	    attrs: {
	      "voteObj": _vm.data
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "content-footer"
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "article-desc"
	  }, [_c('li', [_vm._v("未经授权，严禁转载")]), _vm._v(" "), _c('li', [_vm._v("联系电话：028-86751128")])]), _vm._v(" "), (_vm.isSharePage && (_vm.$route.params.type === 'paper' || _vm.$route.params.type === 'normal' || _vm.data.sysCode === 'gov')) ? _c('div', {
	    class: [_vm.isLike ? 'active-good uuidLikes flex flex-cross-center' : 'uuidLikes like flex flex-cross-center'],
	    on: {
	      "click": _vm.uuid
	    }
	  }, [_c('i', {
	    class: [_vm.isLike ? 'active-good' : 'good']
	  }), _vm._v(" "), _c('span', {
	    class: [_vm.isLike ? 'active-num' : 'num']
	  }, [_vm._v(_vm._s(_vm.likes <= 0 ? '赞' : _vm.getLikesCount(_vm.likes)))])]) : _vm._e(), _vm._v(" "), (_vm.relvantNewsData.length > 0) ? _c('div', {
	    staticClass: "relevant-news"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("\n                    大家都在看\n                ")]), _vm._v(" "), _c('list', {
	    attrs: {
	      "relvantNewsData": _vm.relvantNewsData
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.comments !== null) ? _c('div', {
	    staticClass: "comment"
	  }, [(_vm.comments.length > 0) ? _c('div', {
	    staticClass: "title"
	  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("热门评论")])]) : _vm._e(), _vm._v(" "), (_vm.comments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.comments), function(item, index) {
	    return _c('li', {
	      key: index,
	      on: {
	        "click": function($event) {
	          return _vm.addComment(item)
	        }
	      }
	    }, [_c('header', {
	      staticClass: "flex flex-cross-center flex-main-justify"
	    }, [_c('div', {
	      staticClass: "flex flex-cross-center"
	    }, [_c('div', {
	      staticClass: "avatar",
	      style: ({
	        backgroundImage: ("url(" + (item.userIcon?item.userIcon:_vm.icon) + ")")
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "info-area"
	    }, [_c('div', {
	      staticClass: "name ellipsis"
	    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('div', {
	      staticClass: "time ellipsis"
	    }, [_vm._v(_vm._s(_vm.getTime(item.date)))])])]), _vm._v(" "), _c('div', {
	      staticClass: "like flex flex-cross-center",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.setActiveLike(item)
	        }
	      }
	    }, [_c('span', {
	      class: [item.isLike ? 'active-num' : 'num']
	    }, [_vm._v(_vm._s(_vm.getLikesCount(item.likes + '')))]), _vm._v(" "), _c('i', {
	      class: [item.isLike ? 'active-good' : 'good']
	    })])]), _vm._v(" "), _c('section', [_c('p', {
	      domProps: {
	        "innerHTML": _vm._s(item.content)
	      }
	    })]), _vm._v(" "), (item.parent) ? _c('div', {
	      staticClass: "origin"
	    }, [_c('div', {
	      staticClass: "origin-info flex flex-cross-center flex-main-justify"
	    }, [_c('div', {
	      staticClass: "origin-name"
	    }, [_vm._v(_vm._s(item.parent.username))])]), _vm._v(" "), _c('div', {
	      staticClass: "origin-content"
	    }, [_vm._v("\n                                    " + _vm._s(item.parent.content) + "\n                                ")])]) : _vm._e()])
	  }), 0), _vm._v(" "), (!_vm.isSharePage) ? _c('div', {
	    staticClass: "check-all",
	    on: {
	      "click": function($event) {
	        return _vm.appPostMessage('checkAllComment')
	      }
	    }
	  }, [_vm._v("查看全部评论 "), _c('i')]) : _vm._e()]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.showLargeImage) ? _c('div', {
	    staticClass: "largeSwiper"
	  }, [_c('div', {
	    staticClass: "viewSwiper",
	    on: {
	      "click": _vm.closeLargeImage,
	      "touchmove": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "swiper-container"
	  }, [_c('div', {
	    staticClass: "swiper-wrapper "
	  }, _vm._l((_vm.newImages), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "swiper-slide swiper-zoom-container"
	    }, [_c('img', {
	      attrs: {
	        "src": item
	      }
	    })])
	  }), 0)])]), _vm._v(" "), _c('div', {
	    staticClass: "swiper-pagination"
	  })]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade",
	      "enter-class": "fade-in-enter",
	      "enter-active-class": "fade-in-active",
	      "leave-class": "fade-out-enter",
	      "leave-active-class": "fade-out-active"
	    }
	  }, [(_vm.isShow) ? _c('div', {
	    staticClass: "dialog-cover",
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('div', {
	    staticClass: "dialog-content",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.doSomething($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "dialog_head"
	  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
	    staticClass: "dialog_main"
	  }, [_vm._t("main", function() {
	    return [_vm._v("弹窗内容")]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "footer"
	  }, [_c('button', {
	    staticClass: "close",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
	    staticClass: "ok openApp",
	    on: {
	      "click": _vm.ok
	    }
	  }, [_vm._v("确定")])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "news-link",
	    attrs: {
	      "href": _vm.path
	    }
	  }, [_c('div', {
	    staticClass: "row-2 f-cb"
	  }, [_c('h2', {
	    staticClass: "title f-toe1"
	  }, [_vm._v(_vm._s(_vm.item.listTitle || _vm.item.title))]), _vm._v(" "), (_vm.item.comments != '0' && _vm.item.comments) ? _c('span', {
	    staticClass: "comment-count"
	  }, [_vm._v(_vm._s(_vm.item.comments))]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row-1 f-cb"
	  }, [_c('div', {
	    staticClass: "col-1",
	    style: ({
	      height: _vm.imgH
	    })
	  }, [_c('div', {
	    staticClass: "bg-d"
	  }, [_c('div', {
	    staticClass: "bg-c",
	    style: ({
	      backgroundImage: 'url(' + _vm.webp(_vm.item.images[0]) + ')'
	    })
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-2",
	    style: ({
	      height: _vm.imgH
	    })
	  }, [_c('div', {
	    staticClass: "bg-d"
	  }, [_c('div', {
	    staticClass: "bg-c",
	    style: ({
	      backgroundImage: 'url(' + _vm.webp(_vm.item.images[1]) + ')'
	    })
	  })])])])])
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.8b8a488eaa54ea70ac45.js